window.slate = window.slate || {};
window.theme = window.theme || {};

/*================ Slate ================*/
/**
 * A11y Helpers
 * -----------------------------------------------------------------------------
 * A collection of useful functions that help make your theme more accessible
 * to users with visual impairments.
 *
 *
 * @namespace a11y
 */

slate.a11y = {
  /**
   * For use when focus shifts to a container rather than a link
   * eg for In-page links, after scroll, focus shifts to content area so that
   * next `tab` is where user expects if focusing a link, just $link.focus();
   *
   * @param {JQuery} $element - The element to be acted upon
   */
  pageLinkFocus: function ($element) {
    var focusClass = 'js-focus-hidden';

    $element
      .first()
      .attr('tabIndex', '-1')
      .focus()
      .addClass(focusClass)
      .one('blur', callback);

    function callback() {
      $element.first().removeClass(focusClass).removeAttr('tabindex');
    }
  },

  /**
   * If there's a hash in the url, focus the appropriate element
   */
  focusHash: function () {
    var hash = window.location.hash;

    // is there a hash in the url? is it an element on the page?
    if (hash && document.getElementById(hash.slice(1))) {
      this.pageLinkFocus($(hash));
    }
  },

  /**
   * When an in-page (url w/hash) link is clicked, focus the appropriate element
   */
  bindInPageLinks: function () {
    $('a[href*=#]').on(
      'click',
      function (evt) {
        this.pageLinkFocus($(evt.currentTarget.hash));
      }.bind(this)
    );
  },

  /**
   * Traps the focus in a particular container
   *
   * @param {object} options - Options to be used
   * @param {jQuery} options.$container - Container to trap focus within
   * @param {jQuery} options.$elementToFocus - Element to be focused when focus leaves container
   * @param {string} options.namespace - Namespace used for new focus event handler
   */
  trapFocus: function (options) {
    var eventName = options.namespace
      ? 'focusin.' + options.namespace
      : 'focusin';

    if (!options.$elementToFocus) {
      options.$elementToFocus = options.$container;
    }

    options.$container.attr('tabindex', '-1');
    options.$elementToFocus.focus();

    $(document).on(eventName, function (evt) {
      if (
        options.$container[0] !== evt.target &&
        !options.$container.has(evt.target).length
      ) {
        options.$container.focus();
      }
    });
  },

  /**
   * Removes the trap of focus in a particular container
   *
   * @param {object} options - Options to be used
   * @param {jQuery} options.$container - Container to trap focus within
   * @param {string} options.namespace - Namespace used for new focus event handler
   */
  removeTrapFocus: function (options) {
    var eventName = options.namespace
      ? 'focusin.' + options.namespace
      : 'focusin';

    if (options.$container && options.$container.length) {
      options.$container.removeAttr('tabindex');
    }

    $(document).off(eventName);
  },
};

/**
 * Cart Template Script
 * ------------------------------------------------------------------------------
 * A file that contains scripts highly couple code to the Cart template.
 *
 * @namespace cart
 */

slate.cart = {
  /**
   * Browser cookies are required to use the cart. This function checks if
   * cookies are enabled in the browser.
   */
  cookiesEnabled: function () {
    var cookieEnabled = navigator.cookieEnabled;

    if (!cookieEnabled) {
      document.cookie = 'testcookie';
      cookieEnabled = document.cookie.indexOf('testcookie') !== -1;
    }
    return cookieEnabled;
  },
};

/**
 * Utility helpers
 * -----------------------------------------------------------------------------
 * A collection of useful functions for dealing with arrays and objects
 *
 * @namespace utils
 */

slate.utils = {
  /**
   * Return an object from an array of objects that matches the provided key and value
   *
   * @param {array} array - Array of objects
   * @param {string} key - Key to match the value against
   * @param {string} value - Value to get match of
   */
  findInstance: function (array, key, value) {
    for (var i = 0; i < array.length; i++) {
      if (array[i][key] === value) {
        return array[i];
      }
    }
  },

  /**
   * Remove an object from an array of objects by matching the provided key and value
   *
   * @param {array} array - Array of objects
   * @param {string} key - Key to match the value against
   * @param {string} value - Value to get match of
   */
  removeInstance: function (array, key, value) {
    var i = array.length;
    while (i--) {
      if (array[i][key] === value) {
        array.splice(i, 1);
        break;
      }
    }

    return array;
  },

  /**
   * _.compact from lodash
   * Remove empty/false items from array
   * Source: https://github.com/lodash/lodash/blob/master/compact.js
   *
   * @param {array} array
   */
  compact: function (array) {
    var index = -1;
    var length = array == null ? 0 : array.length;
    var resIndex = 0;
    var result = [];

    while (++index < length) {
      var value = array[index];
      if (value) {
        result[resIndex++] = value;
      }
    }
    return result;
  },

  /**
   * _.defaultTo from lodash
   * Checks `value` to determine whether a default value should be returned in
   * its place. The `defaultValue` is returned if `value` is `NaN`, `null`,
   * or `undefined`.
   * Source: https://github.com/lodash/lodash/blob/master/defaultTo.js
   *
   * @param {*} value - Value to check
   * @param {*} defaultValue - Default value
   * @returns {*} - Returns the resolved value
   */
  defaultTo: function (value, defaultValue) {
    return value == null || value !== value ? defaultValue : value;
  },
};

/**
 * Rich Text Editor
 * -----------------------------------------------------------------------------
 * Wrap videos in div to force responsive layout.
 *
 * @namespace rte
 */

slate.rte = {
  /**
   * Wrap tables in a container div to make them scrollable when needed
   *
   * @param {object} options - Options to be used
   * @param {jquery} options.$tables - jquery object(s) of the table(s) to wrap
   * @param {string} options.tableWrapperClass - table wrapper class name
   */
  wrapTable: function (options) {
    options.$tables.wrap(
      '<div class="' + options.tableWrapperClass + '"></div>'
    );
  },

  /**
   * Wrap iframes in a container div to make them responsive
   *
   * @param {object} options - Options to be used
   * @param {jquery} options.$iframes - jquery object(s) of the iframe(s) to wrap
   * @param {string} options.iframeWrapperClass - class name used on the wrapping div
   */
  wrapIframe: function (options) {
    options.$iframes.each(function () {
      // Add wrapper to make video responsive
      $(this).wrap('<div class="' + options.iframeWrapperClass + '"></div>');

      // Re-set the src attribute on each iframe after page load
      // for Chrome's "incorrect iFrame content on 'back'" bug.
      // https://code.google.com/p/chromium/issues/detail?id=395791
      // Need to specifically target video and admin bar
      this.src = this.src;
    });
  },
};

slate.Sections = function Sections() {
  this.constructors = {};
  this.instances = [];

  $(document)
    .on('shopify:section:load', this._onSectionLoad.bind(this))
    .on('shopify:section:unload', this._onSectionUnload.bind(this))
    .on('shopify:section:select', this._onSelect.bind(this))
    .on('shopify:section:deselect', this._onDeselect.bind(this))
    .on('shopify:section:reorder', this._onReorder.bind(this))
    .on('shopify:block:select', this._onBlockSelect.bind(this))
    .on('shopify:block:deselect', this._onBlockDeselect.bind(this));
};

slate.Sections.prototype = $.extend({}, slate.Sections.prototype, {
  _createInstance: function (container, constructor) {
    var $container = $(container);
    var id = $container.attr('data-section-id');
    var type = $container.attr('data-section-type');

    constructor = constructor || this.constructors[type];

    if (typeof constructor === 'undefined') {
      return;
    }

    var instance = $.extend(new constructor(container), {
      id: id,
      type: type,
      container: container,
    });

    this.instances.push(instance);
  },

  _onSectionLoad: function (evt) {
    var container = $('[data-section-id]', evt.target)[0];
    if (container) {
      this._createInstance(container);
    }
  },

  _onSectionUnload: function (evt) {
    var instance = slate.utils.findInstance(
      this.instances,
      'id',
      evt.detail.sectionId
    );

    if (!instance) {
      return;
    }

    if (typeof instance.onUnload === 'function') {
      instance.onUnload(evt);
    }

    this.instances = slate.utils.removeInstance(
      this.instances,
      'id',
      evt.detail.sectionId
    );
  },

  _onSelect: function (evt) {
    var instance = slate.utils.findInstance(
      this.instances,
      'id',
      evt.detail.sectionId
    );

    if (instance && typeof instance.onSelect === 'function') {
      instance.onSelect(evt);
    }
  },

  _onDeselect: function (evt) {
    var instance = slate.utils.findInstance(
      this.instances,
      'id',
      evt.detail.sectionId
    );

    if (instance && typeof instance.onDeselect === 'function') {
      instance.onDeselect(evt);
    }
  },

  _onReorder: function (evt) {
    var instance = slate.utils.findInstance(
      this.instances,
      'id',
      evt.detail.sectionId
    );

    if (instance && typeof instance.onReorder === 'function') {
      instance.onReorder(evt);
    }
  },

  _onBlockSelect: function (evt) {
    var instance = slate.utils.findInstance(
      this.instances,
      'id',
      evt.detail.sectionId
    );

    if (instance && typeof instance.onBlockSelect === 'function') {
      instance.onBlockSelect(evt);
    }
  },

  _onBlockDeselect: function (evt) {
    var instance = slate.utils.findInstance(
      this.instances,
      'id',
      evt.detail.sectionId
    );

    if (instance && typeof instance.onBlockDeselect === 'function') {
      instance.onBlockDeselect(evt);
    }
  },

  register: function (type, constructor) {
    this.constructors[type] = constructor;

    document.querySelectorAll('[data-section-type=' + type + ']').forEach(
      function (container, index) {
        this._createInstance(container, constructor);
      }.bind(this)
    );
  },
});

/**
 * Currency Helpers
 * -----------------------------------------------------------------------------
 * A collection of useful functions that help with currency formatting
 *
 * Current contents
 * - formatMoney - Takes an amount in cents and returns it as a formatted dollar value.
 *
 */

slate.Currency = (function () {
  var moneyFormat = '${{amount}}';

  /**
   * Format money values based on your shop currency settings
   * @param  {Number|string} cents - value in cents or dollar amount e.g. 300 cents
   * or 3.00 dollars
   * @param  {String} format - shop money_format setting
   * @return {String} value - formatted value
   */
  function formatMoney(cents, format) {
    if (typeof cents === 'string') {
      cents = cents.replace('.', '');
    }
    var value = '';
    var placeholderRegex = /\{\{\s*(\w+)\s*\}\}/;
    var formatString = format || moneyFormat;

    function formatWithDelimiters(number, precision, thousands, decimal) {
      precision = slate.utils.defaultTo(precision, 2);
      thousands = slate.utils.defaultTo(thousands, ',');
      decimal = slate.utils.defaultTo(decimal, '.');

      if (isNaN(number) || number == null) {
        return 0;
      }

      number = (number / 100.0).toFixed(precision);

      var parts = number.split('.');
      var dollarsAmount = parts[0].replace(
        /(\d)(?=(\d\d\d)+(?!\d))/g,
        '$1' + thousands
      );
      var centsAmount = parts[1] ? decimal + parts[1] : '';

      return dollarsAmount + centsAmount;
    }

    switch (formatString.match(placeholderRegex)[1]) {
      case 'amount':
        value = formatWithDelimiters(cents, 2);
        break;
      case 'amount_no_decimals':
        value = formatWithDelimiters(cents, 0);
        break;
      case 'amount_with_space_separator':
        value = formatWithDelimiters(cents, 2, ' ', '.');
        break;
      case 'amount_with_comma_separator':
        value = formatWithDelimiters(cents, 2, '.', ',');
        break;
      case 'amount_no_decimals_with_comma_separator':
        value = formatWithDelimiters(cents, 0, ',', '.');
        break;
      case 'amount_no_decimals_with_space_separator':
        value = formatWithDelimiters(cents, 0, ' ');
        break;
    }

    return formatString.replace(placeholderRegex, value);
  }

  return {
    formatMoney: formatMoney,
  };
})();

/**
 * Image Helper Functions
 * -----------------------------------------------------------------------------
 * A collection of functions that help with basic image operations.
 *
 */

slate.Image = (function () {
  /**
   * Preloads an image in memory and uses the browsers cache to store it until needed.
   *
   * @param {Array} images - A list of image urls
   * @param {String} size - A shopify image size attribute
   */

  function preload(images, size) {
    if (typeof images === 'string') {
      images = [images];
    }

    for (var i = 0; i < images.length; i++) {
      var image = images[i];
      this.loadImage(this.getSizedImageUrl(image, size));
    }
  }

  /**
   * Loads and caches an image in the browsers cache.
   * @param {string} path - An image url
   */
  function loadImage(path) {
    new Image().src = path;
  }

  /**
   * Find the Shopify image attribute size
   *
   * @param {string} src
   * @returns {null}
   */
  function imageSize(src) {
    var match = src.match(
      /.+_((?:pico|icon|thumb|small|compact|medium|large|grande)|\d{1,4}x\d{0,4}|x\d{1,4})[_\.@]/
    );

    if (match) {
      return match[1];
    } else {
      return null;
    }
  }

  /**
   * Adds a Shopify size attribute to a URL
   *
   * @param src
   * @param size
   * @returns {*}
   */
  function getSizedImageUrl(src, size) {
    if (size === null) {
      return src;
    }

    if (size === 'master') {
      return this.removeProtocol(src);
    }

    var match = src.match(
      /\.(jpg|jpeg|gif|png|bmp|bitmap|tiff|tif)(\?v=\d+)?$/i
    );

    if (match) {
      var prefix = src.split(match[0]);
      var suffix = match[0];

      return this.removeProtocol(prefix[0] + '_' + size + suffix);
    } else {
      return null;
    }
  }

  function removeProtocol(path) {
    return path.replace(/http(s)?:/, '');
  }

  return {
    preload: preload,
    loadImage: loadImage,
    imageSize: imageSize,
    getSizedImageUrl: getSizedImageUrl,
    removeProtocol: removeProtocol,
  };
})();

/**
 * Variant Selection scripts
 * ------------------------------------------------------------------------------
 *
 * Handles change events from the variant inputs in any `cart/add` forms that may
 * exist. Also updates the master select and triggers updates when the variants
 * price or image changes.
 *
 * @namespace variants
 */

slate.Variants = (function () {
  /**
   * Variant constructor
   *
   * @param {object} options - Settings from `product.js`
   */
  function Variants(options) {
    this.$container = options.$container;
    this.product = options.product;
    this.singleOptionSelector = options.singleOptionSelector;
    this.originalSelectorId = options.originalSelectorId;
    this.enableHistoryState = options.enableHistoryState;
    this.currentVariant = this._getVariantFromOptions();
    this.subscriptionSelector = options.subscriptionSelector;

    // inside check if sub or not,
    $(this.subscriptionSelector, this.$container).on(
      'change',
      this._onSubscriptionRadioChange.bind(this)
    );
    $(this.singleOptionSelector, this.$container).on(
      'change',
      this._onSelectChange.bind(this)
    );

    this._showHideSubscribtionBox(this.currentVariant);

    this._updateAddToCartBtn(this.currentVariant.id);
  }

  Variants.prototype = $.extend({}, Variants.prototype, {
    /**
     * Get the currently selected options from add-to-cart form. Works with all
     * form input elements.
     *
     * @return {array} options - Values of currently selected variants
     */
    _getCurrentOptions: function () {
      var currentOptions = _.map(
        $(this.singleOptionSelector, this.$container),
        function (element) {
          var $element = $(element);
          this.element_type = $element.attr('type');
          var currentOption = {};

          if (
            this.element_type === 'radio' ||
            this.element_type === 'checkbox'
          ) {
            if ($element[0].checked) {
              currentOption.value = $element.val();
              currentOption.index = $element.data('index').trim();

              return currentOption;
            } else {
              return false;
            }
          } else {
            currentOption.value = $element.val();
            currentOption.index = $element.data('index').trim();
            console.log(currentOption)
            return currentOption;
          }
        }
      );

      // remove any unchecked input values if using radio buttons or checkboxes
      currentOptions = slate.utils.compact(currentOptions);

      return currentOptions;
    },

    /**
     * Find variant based on selected values.
     *
     * @param  {array} selectedValues - Values of variant inputs
     * @return {object || undefined} found - Variant object from product.variants
     */
    _getVariantFromOptions: function () {
      var selectedValues = this._getCurrentOptions();
      var variants = this.product.variants;
      var found = false;

      console.log(selectedValues)
      variants.forEach(function (variant) {
        var satisfied = true;

        selectedValues.forEach(function (option) {
          if (satisfied) {
            satisfied = option.value === variant[option.index];
          }
        });

        if (satisfied) {
          found = variant;
        }
      });
      // console.log("current variant is:", found || "unknown")

      return found || null;
    },

    /**
     * Event handler for when a variant input changes.
     */
    _onSelectChange: function () {
      console.log("===============")
      // console.log("_onSelectChange!")

      var variant = this._getVariantFromOptions();

      // console.log(variant)

      this.$container.trigger({
        type: 'variantChange',
        variant: variant,
        element_type: this.element_type,
      });

      if (!variant) {
        return;
      }
      
      this._updateOutOfStockMsg(variant);
      this._showHideSubscribtionBox(variant);
      this._updateMasterSelect(variant);
      this._updateImages(variant);
      this._updatePrice(variant);
      this._updateOptions(variant);
      this._updateSKU(variant);
      this.currentVariant = variant;

      this._updateAddToCartBtn(this.currentVariant.id);

      if (this.enableHistoryState) {
        this._updateHistoryState(variant);
      }
    },
    _updateOutOfStockMsg:function(variant){
      if(variant.inventory_quantity>0 || variant.available){
        $('.out_of_stock_msg').hide();
      }else{
        $('.out_of_stock_msg').show();
      }
    },
    /**
     * Trigger event when subscription radio button changes
     *
     * @param  {object} variant - Currently selected variant
     * @return {event}  variantImageChange
     */
    _onSubscriptionRadioChange: function () {
      console.log("_onSubscriptionRadioChange")
      console.log(document.querySelector('#ProductSelect-option-size-50-bag-refill'))
      var variant = this._getVariantFromOptions();

      var purchaseType = event.currentTarget.value;

      this.$container.trigger({
        type: 'subscriptionPurchaseTypeChange',
        variant: variant,
        purchaseType: purchaseType,
        element_type: this.element_type,
      });

      if (!variant) {
        return;
      }

      //this._updateMasterSelect(variant);
      //this._updateImages(variant);
      this._updatePrice(variant);
      //this._updateOptions(variant);
      //this._updateSKU(variant);
      this.currentVariant = variant;

      if (this.enableHistoryState) {
        this._updateHistoryState(variant);
      }
    },
    /**
     * Trigger event when variant image changes
     *
     * @param  {object} variant - Currently selected variant
     * @return {event}  variantImageChange
     */
    _updateImages: function (variant) {
      var variantImage = variant.featured_image || {};
      var currentVariantImage = this.currentVariant.featured_image || {};

      if (
        !variant.featured_image ||
        variantImage.src === currentVariantImage.src
      ) {
        return;
      }

      this.$container.trigger({
        type: 'variantImageChange',
        variant: variant,
      });
    },

    /**
     * Trigger event when variant price changes.
     *
     * @param  {object} variant - Currently selected variant
     * @return {event} variantPriceChange
     */
    _updatePrice: function (variant) {
      if (
        variant.price === this.currentVariant.price &&
        variant.compare_at_price === this.currentVariant.compare_at_price
      ) {
        return;
      }

      this.$container.trigger({
        type: 'variantPriceChange',
        variant: variant,
      });
    },

    /**
     * Trigger event when available variant options change.
     *
     * @param  {object} variant - Currently selected variant
     * @return {event} variantOptionChange
     */
    _updateOptions: function (variant) {
      if (!variant) {
        return;
      }

      this.$container.trigger({
        type: 'variantOptionChange',
        variant: variant,
      });
    },

    /**
     * Trigger event when variant sku changes.
     *
     * @param  {object} variant - Currently selected variant
     * @return {event} variantSKUChange
     */
    _updateSKU: function (variant) {
      if (variant.sku === this.currentVariant.sku) {
        return;
      }

      this.$container.trigger({
        type: 'variantSKUChange',
        variant: variant,
      });
    },

    /**
     * Update history state for product deeplinking
     *
     * @param  {variant} variant - Currently selected variant
     * @return {k}         [description]
     */
    _updateHistoryState: function (variant) {
      if (!history.replaceState || !variant) {
        return;
      }

      var newurl =
        window.location.protocol +
        '//' +
        window.location.host +
        window.location.pathname +
        '?variant=' +
        variant.id;
      window.history.replaceState({ path: newurl }, '', newurl);
    },

    /**
     * Update hidden master select of variant change
     *
     * @param  {variant} variant - Currently selected variant
     */
    _updateMasterSelect: function (variant) {
      $(this.originalSelectorId, this.$container)[0].value = variant.id;
    },


    _showHideSubscribtionBox: function (variant) {
      const title = variant.title.toLowerCase();
      if (title.includes("caddy")) {
        $('#subscribe_box',this.$container).hide();
        $('#subscribe_box_1',this.$container).hide();
        $('#subscribe_box_2',this.$container).hide();
        $('.help-tool', this.$container).hide();
        this._selectOTP();
      } else {
        $('#subscribe_box',this.$container).show();
        $('#subscribe_box_1',this.$container).show();
        $('#subscribe_box_2',this.$container).show();
        $('.help-tool', this.$container).show();
      }
    },
    _selectOTP:function(){
      var that = this;
      var checkExist = setInterval(function() {
        // Check if RC widget exists on the page, if not, check again in 100ms
        if ($('#rc_container', that.$container).css('display')==='block') {
          // Clear interval so this only runs once
          clearInterval(checkExist);
          setTimeout(() => {
            $('#aria-oneTimePurchase',that.$container).click();
          }, 200);
        } 
      }, 100); // check every 100ms
    },

    _updateAddToCartBtn: function (sku) {
      $(document).on("click", '[data-selling-plan-id]', function(){
        // console.log(`on("click", '[data-selling-plan-id]')`)

        $('.rodeo-variant--active .rc_block__type__autodeliver input').prop("checked", "checked");
        $('.rodeo-variant--active .rc_block__type__onetime input').prop("checked", false);
        if (sku == 33250268217430){
          $('[data-add-to-cart-text]').children().first().html("<span>Pre-order</span>");
        } else {
          $('[data-add-to-cart-text]').children().first().html("<span>Subscribe</span>");
        }
        $('.additional-checkout-buttons').hide();
        var subOnlyContainer = document.querySelector('#rc_container.rc_subscription');
        if (subOnlyContainer){
          $('[data-original-price]').show();
        }
        
        $('.afterpay_wrap').hide();
      });
      $(document).on("click", '.rc_block__type__onetime', function(){
        // console.log(`on("click", '.rc_block__type__onetime')`)
        $('.rodeo-variant--active .rc_block__type__autodeliver input').prop("checked", false);
        $('.rodeo-variant--active .rc_block__type__onetime input').prop("checked", "checked");
        $('[data-add-to-cart-text]').children().first().html("<span>Add To Cart</span>");
        $('.additional-checkout-buttons').show();
        $('[data-original-price]').hide(); 
         $('.afterpay_wrap').show();
      });

    
    var currentUrl = window.location.hash;
      
    if (currentUrl.indexOf('subscription') > -1){
      // let subscriptionInput = document.querySelector('.rc_label__autodeliver');
      let subscriptionInput = document.querySelector('.rodeo-variant--active .rc_block__type__autodeliver');

      if (subscriptionInput) {
        subscriptionInput.click();
      }
    }

      // if ($('.rc_block__type__autodeliver input').is(':checked')) {
      //   $('[data-add-to-cart-text]').html("<span>Subscribe</span>");
      //   $('.additional-checkout-buttons').hide();
      //   $('[data-original-price]').show();
      // } else {
      //   $('[data-original-price]').hide();
      //   $('[data-add-to-cart-text]').html("<span>Add To Cart</span>");
      // }
    },
  });

  return Variants;
})();

/*================ Global ================*/
/*============================================================================
  Helper utilities
==============================================================================*/
window.theme = window.theme || {};

theme.utils = {
  /**
   * Locks the page scroll.
   *
   * @param      {element}  scrollEl  optional
   */
  lockPageScroll: function (scrollEl) {
    document.documentElement.classList.add('scroll-locked');
    if ('bodyScrollLock' in window) {
      bodyScrollLock.lock(scrollEl);
    }
  },

  /**
   * Unlocks the page scroll.
   */
  unlockPageScroll: function () {
    document.documentElement.classList.remove('scroll-locked');

    if ('bodyScrollLock' in window) {
      bodyScrollLock.unlock();
    }

    if (theme.stickyHeader) {
      theme.stickyHeader.update();
    }
  },

  /**
   * Turns a string into a handle. Mimics Shopify's format.
   */
  handleize: function (str) {
    return str
      .toLowerCase()
      .replace(/[^\w\u00C0-\u024f]+/g, '-')
      .replace(/^-+|-+$/g, '');
  },

  /**
   * Cross-browser URL query param getter
   */
  getQueryParams: function (qs) {
    qs = qs || document.location.search;

    if (!qs) {
      return;
    }

    qs = qs.split('+').join(' ');

    var params = {},
      tokens,
      re = /[?&]?([^=]+)=([^&]*)/g;

    while ((tokens = re.exec(qs))) {
      params[decodeURIComponent(tokens[1])] = decodeURIComponent(tokens[2]);
    }

    return params;
  },

  getQueryParam: function (param) {
    var params = this.getQueryParams();
    return params ? params[param] : undefined;
  },

  updateQueryStringParameter: function (key, value, url) {
    if (!url) url = window.location.href;

    var re = new RegExp('([?&])' + key + '=.*?(&|#|$)(.*)', 'gi'),
      hash;

    if (re.test(url)) {
      if (typeof value !== 'undefined' && value !== null)
        return url.replace(re, '$1' + key + '=' + value + '$2$3');
      else {
        hash = url.split('#');
        url = hash[0].replace(re, '$1$3').replace(/(&|\?)$/, '');
        if (typeof hash[1] !== 'undefined' && hash[1] !== null)
          url += '#' + hash[1];
        return url;
      }
    } else {
      if (typeof value !== 'undefined' && value !== null) {
        var separator = url.indexOf('?') !== -1 ? '&' : '?';
        hash = url.split('#');
        url = hash[0] + separator + key + '=' + value;
        if (typeof hash[1] !== 'undefined' && hash[1] !== null)
          url += '#' + hash[1];
        return url;
      } else return url;
    }
  },

  getYoutubeId: function (url) {
    var regExp = /^.*((youtu.be\/)|(v\/)|(\/u\/\w\/)|(embed\/)|(watch\?))\??v?=?([^#\&\?]*).*/;
    var match = url.match(regExp);
    return match && match[7].length == 11 ? match[7] : false;
  },

  getProductJSON: function (handle, callback) {
    return $.get('/products/' + handle + '?view=data', null, callback, 'text');
  },

  hexToRgb: function (hex) {
    var result = /^#?([a-f\d]{2})([a-f\d]{2})([a-f\d]{2})$/i.exec(hex);
    return result
      ? {
          r: parseInt(result[1], 16),
          g: parseInt(result[2], 16),
          b: parseInt(result[3], 16),
        }
      : null;
  },

  forceRedraw: function (elem) {
    if (!elem) {
      return;
    }

    var disp = elem.style.display;
    elem.style.display = 'none';
    var redrawElem = elem.offsetHeight;
    elem.style.display = disp;
  },

  flash: function (elements, color, duration) {
    var opacity = 100;
    color = color || '255, 255, 136';
    duration = duration || 1500;

    if (color.indexOf('#') > -1) {
      var rgbColor = theme.utils.hexToRgb(color);
      color = [rgbColor.r, rgbColor.g, rgbColor.b].join(',');
    }

    var interval = setInterval(function () {
      opacity -= 2.5;

      $(elements).css({
        background: 'rgba(' + color + ', ' + opacity / 100 + ')',
      });

      if (opacity <= 0) {
        clearInterval(interval);
        return;
      }
    }, duration / 40);
  },

  getOffset: function (el) {
    var rect = el.getBoundingClientRect(),
      scrollLeft = window.pageXOffset || document.documentElement.scrollLeft,
      scrollTop = window.pageYOffset || document.documentElement.scrollTop;
    return { top: rect.top + scrollTop, left: rect.left + scrollLeft };
  },

  // Gets the rendered size of an image using object-fit
  getRenderedImgSize: function (contains, cWidth, cHeight, width, height, pos) {
    var oRatio = width / height,
      cRatio = cWidth / cHeight;
    return function () {
      if (contains ? oRatio > cRatio : oRatio < cRatio) {
        this.width = cWidth;
        this.height = cWidth / oRatio;
      } else {
        this.width = cHeight * oRatio;
        this.height = cHeight;
      }
      this.left = (cWidth - this.width) * (pos / 100);
      this.right = this.width + this.left;
      return this;
    }.call({});
  },

  // Returns size info for an image rendered with object-fit
  getImgSizeInfo: function (img) {
    var pos = window
      .getComputedStyle(img)
      .getPropertyValue('object-position')
      .split(' ');
    return theme.utils.getRenderedImgSize(
      true,
      img.width,
      img.height,
      img.naturalWidth,
      img.naturalHeight,
      parseInt(pos[0])
    );
  },

  // Returns content of template placed into snippets/js-tempales.liquid
  getTemplate: function (template) {
    return $('[data-template-for="' + template + '"]').html();
  },

  // Returns a HTML element from a string
  createElementFromHTML: function (htmlString) {
    var div = document.createElement('div');
    div.innerHTML = htmlString.trim();
    return div.firstChild;
  },

  // Returns deep differences between objects, ignoring functions
  difference: function (object, base) {
    function changes(object, base) {
      return _.transform(object, function (result, value, key) {
        if (typeof value !== 'function' && !_.isEqual(value, base[key])) {
          var comparison =
            _.isObject(value) && _.isObject(base[key])
              ? changes(value, base[key])
              : value;

          if (!_.isNil(comparison)) {
            result[key] = comparison;
          }
        }
      });
    }
    return changes(object, base);
  },

  // Adds syntax highlighting to JSON output
  syntaxHighlight: function (json) {
    json = json
      .replace(/&/g, '&amp;')
      .replace(/</g, '&lt;')
      .replace(/>/g, '&gt;');
    json = json.replace(
      /("(\\u[a-zA-Z0-9]{4}|\\[^u]|[^\\"])*"(\s*:)?|\b(true|false|null)\b|-?\d+(?:\.\d*)?(?:[eE][+\-]?\d+)?)/g,
      function (match) {
        var cls = 'number';
        if (/^"/.test(match)) {
          if (/:$/.test(match)) {
            cls = 'key';
          } else {
            cls = 'string';
          }
        } else if (/true|false/.test(match)) {
          cls = 'boolean';
        } else if (/null/.test(match)) {
          cls = 'null';
        }
        return '<span class="' + cls + '">' + match + '</span>';
      }
    );
    json = json
      .replace(
        /([\n\r]|^)(\s*){/g,
        '<span class="group">$2<span class="group-handle">{</span>'
      )
      .replace(/([\n\r]|^)(\s*)}(,|)/g, '$1$2}$3</span>');
    json = json
      .replace(
        /(<\/span>|^)(\s*)\[/g,
        '$1<span class="group group--inline">$2<span class="group-handle">[</span>'
      )
      .replace(/([\n\r]|^)(\s*)](,|)/g, '$2]$3</span>');
    return json;
  },

  getStyleValue: function (variable) {
    var value = window
      .getComputedStyle(document.documentElement)
      .getPropertyValue(variable);
    if (value) {
      return value.trim();
    }
    return '';
  },

  // returns cross-browser CSS property name
  getCSSProperty: function (propertyName) {
    var properties;

    switch (propertyName) {
      case 'transform':
        properties = [
          'transform',
          'msTransform',
          'webkitTransform',
          'mozTransform',
          'oTransform',
        ];
        break;
    }

    function getSupportedPropertyName(properties) {
      for (var i = 0; i < properties.length; i++) {
        if (typeof document.body.style[properties[i]] != 'undefined') {
          return properties[i];
        }
      }
      return null;
    }

    return getSupportedPropertyName(properties);
  },

  getBottomOffsetFromViewportTop: function (el) {
    var rect = el.getBoundingClientRect();
    return rect.top + rect.height;
  },

  errorTippy: function (target, message) {
    var $el = $(target);
    var tip = tippy($el[0], {
      showOnInit: true,
      content: message,
      theme: 'light',
      animation: 'shift-away',
      arrow: true,
      delay: [0, 1000],
      onHidden: function (e) {
        e.destroy();
      },
    });
  },

  showError: function (message) {
    iziToast.show({
      message: message,
      color: 'red',
      position: 'bottomCenter',
    });
  },
};

if ('tinybind' in window) {
  tinybind.formatters.replace = function (value, search, replace) {
    return value.replace(search, replace);
  };

  tinybind.formatters.handle = function (string) {
    return theme.utils.handleize(string);
  };

  tinybind.formatters.startsWith = function (value, prefix) {
    return value.indexOf(prefix) === 0;
  };

  tinybind.formatters.endsWith = function (value, suffix) {
    return value.indexOf(suffix, value.length - suffix.length) !== -1;
  };

  tinybind.formatters.gte = function (a, b) {
    return a >= b;
  };

  tinybind.formatters.or = function (a, b) {
    return a || b;
  };

  tinybind.formatters.and = function (a, b) {
    return a && b;
  };

  tinybind.formatters.size = function (a) {
    return _.size(a);
  };

  tinybind.formatters.length = tinybind.formatters.size;

  tinybind.formatters.stripHtml = function (html) {
    var parsedHtml = new DOMParser().parseFromString(html, 'text/html');
    return parsedHtml.body.textContent || '';
  };

  tinybind.formatters.escape = function (string) {
    return JSON.stringify(string).replace(/(^"|"$)/g, '');
  };

  tinybind.formatters.json = function (a) {
    return JSON.stringify(a);
  };

  tinybind.formatters.log = function (value) {
    console.log(value);
    return value;
  };

  tinybind.formatters.format_tel = function (value) {
    return value.replace(/\ /g, '');
  };

  tinybind.formatters.array_position = function (array, value) {
    return value >= 0 ? array[value] : array[array.length + value];
  };

  tinybind.formatters.percentage_of = function (a, b) {
    return (b / a) * 100;
  };

  tinybind.formatters.contains = function (a, b) {
    return a.indexOf(b) > -1;
  };

  tinybind.formatters.containsAny = function (a, b) {
    var i, j;
    i = a.length;
    while (i--) {
      j = b.length;
      while (j--) {
        if (a[i] == b[j]) {
          return true;
        }
      }
    }
    return false;
  };

  tinybind.formatters.imageExists = function (a) {
    return a && a.indexOf('no-image') == -1;
  };

  tinybind.formatters.highlight = function (a, b) {
    if (b && a) {
      return theme.utils.highlightSubString(b, a);
    }
    return;
  };

  tinybind.formatters.img = function (image, alt, maxWidth, maxHeight) {
    if (!image) {
      return;
    }

    var imgTemplateURL, imgString, imgUrl;

    imgUrl = typeof image == 'string' ? image : image.src;

    imgTemplateURL = slate.Image.getSizedImageUrl(imgUrl, '{width}x');

    maxWidth = maxWidth
      ? (image.width ? image.width + 'px' : false) ||
        (typeof maxWidth == 'string' ? maxWidth : maxWidth + 'px')
      : 'none';
    maxHeight = maxHeight
      ? (image.height ? image.height + 'px' : false) ||
        (typeof maxHeight == 'string' ? maxHeight : maxHeight + 'px')
      : 'none';

    alt = alt || null;

    imgString =
      '<img src="data:image/gif;base64,R0lGODlhAQABAAAAACH5BAEKAAEALAAAAAABAAEAAAICTAEAOw==" class="lazyload" style="max-width: ' +
      maxWidth +
      '; max-height: ' +
      maxHeight +
      ';" data-sizes="auto" data-src="' +
      imgTemplateURL +
      '" alt="' +
      alt +
      ' "/>';

    return imgString;
  };

  tinybind.formatters.map = function (a, b) {
    return _.map(a, b);
  };

  tinybind.formatters.has_line_item = function (a, handle) {
    return a && a.some((v) => v.handle == handle);
  };

  tinybind.formatters.has_ignored_options = function (a, ignore) {
    return a
      .reduce(
        (a, v) =>
          a.push(
            ...v.options_with_values.map((v) =>
              Object.fromEntries(
                Object.entries(v).map(([name, value]) => [
                  name,
                  value.toLowerCase(),
                ])
              )
            )
          ) && a,
        []
      )
      .some((v) =>
        ignore.some((t) => v.name == t.name && v.value.includes(t.value))
      );
  };

  tinybind.binders.selected = function (el, value) {
    if (value) {
      el.selected = 'selected';
    }
  };

  tinybind.binders.checked = function (el, value) {
    value ? (el.checked = true) : (el.checked = false);
  };

  tinybind.binders['product-grid-item'] = function (el, product) {
    var gridIndex = el.dataset.index;
    var animateIn =
      typeof el.dataset.animateIn != 'undefined' ? el.dataset.animateIn : true;
    var options = {
      animateIn: animateIn == 'true' ? true : false,
    };
    new theme.ProductGridItem(el, product, gridIndex, options);
  };

  tinybind.binders.transformx = function (el, value) {
    el.style[theme.utils.getCSSProperty('transform')] =
      'translateX(' + value + ')';
  };

  tinybind.binders['scroll-to'] = function (el, value) {
    var parent;

    if (value) {
      parent = el.parentElement;
      $(parent).scrollTo(el, {
        duration: 500,
        interrupt: !isMobile.apple.device,
        offset: -20,
      });
    }
  };

  tinybind.formatters.debug = function (a) {
    debugger;
    return a;
  };
}

window.theme = window.theme || {};
window.theme.drawers = window.theme.drawers || {};
/*============================================================================
  Drawer modules
==============================================================================*/
theme.Drawers = (function () {
  if ('Hammer' in window && isMobile.any) {
    theme.pageSwipeObject = new Hammer.Manager(
      document.getElementById('PageContainer'),
      {
        touchAction: 'auto',
        inputClass: Hammer.SUPPORT_POINTER_EVENTS
          ? Hammer.PointerEventInput
          : Hammer.TouchMouseInput,
        recognizers: [
          [
            Hammer.Swipe,
            {
              direction: Hammer.DIRECTION_HORIZONTAL,
            },
          ],
        ],
      }
    );

    theme.pageSwipeObject.on('swiperight', function (evt) {
      if ($('body').hasClass('js-drawer-open-right')) {
        var $drawer = $('.drawer.drawer--right');
        theme[$drawer.attr('id')].close();
        return;
      }

      var $drawer = $('.drawer.drawer--left');
      if (!$drawer.length) {
        return;
      }
      var delta_x = evt.deltaX;
      var final_x = evt.srcEvent.pageX || evt.srcEvent.screenX || 0;
      var startPosition = final_x - delta_x;
      if (startPosition >= 0 && startPosition <= 25) {
        theme[$drawer.attr('id')].open();
      }
      return false;
    });

    theme.pageSwipeObject.on('swipeleft', function (evt) {
      if ($('body').hasClass('js-drawer-open-left')) {
        var $drawer = $('.drawer.drawer--left');
        theme[$drawer.attr('id')].close();
        return;
      }

      var $drawer = $('.drawer.drawer--right');
      if (!$drawer.length) {
        return;
      }

      return; // Do not open ajax cart with swipe right

      // var delta_x = evt.deltaX;
      // var final_x = evt.center.x || 0;
      // var startPosition = final_x + -delta_x;
      // var windowWidthOffset = $(window).width() - 25;
      // if (startPosition >= windowWidthOffset) {
      //   theme[$drawer.attr('id')].open();
      // }
      // return false;
    });
  }

  function Drawer(id, position, options) {
    var defaults = {
      close: '.js-drawer-close',
      open: '.js-drawer-open-' + position,
      openClass: 'js-drawer-open',
      dirOpenClass: 'js-drawer-open-' + position,
      pageContentSelector: '#PageContent',
    };

    this.config = $.extend(defaults, options);
    this.position = position;

    this.nodes = {
      $parent: $('html').add('body'),
      $page: $(this.config.pageContentSelector),
    };

    this.$drawer = $('#' + id);

    this.$drawer.addClass('drawer--' + position);

    if (!this.$drawer.length) {
      return false;
    }

    theme.drawers[id] = this;

    this.drawerIsOpen = false;
    this.init();
  }

  Drawer.prototype.init = function () {
    $(this.config.open).on('click', $.proxy(this.open, this));
    this.$drawer.on('click', this.config.close, $.proxy(this.close, this));
  };

  Drawer.prototype.closeAllDrawers = function (evt) {
    // Close all drawers
    _.forEach(theme.drawers, function (drawer) {
      if (drawer.drawerIsOpen) {
        drawer.close();
      }
    });
  };

  Drawer.prototype.open = function (evt) {
    // Keep track if drawer was opened from a click, or called by another function
    var externalCall = false;

    // Prevent following href if link is clicked
    if (evt) {
      evt.preventDefault();
    } else {
      externalCall = true;
    }

    // Without this, the drawer opens, the click event bubbles up to nodes.$page
    // which closes the drawer.
    if (evt && evt.stopPropagation) {
      evt.stopPropagation();
      // save the source of the click, we'll focus to this on close
      this.$activeSource = $(evt.currentTarget);
    }

    if (this.drawerIsOpen && !externalCall) {
      return this.close();
    }

    this.closeAllDrawers();

    // Run function when draw opens if set
    if (
      this.config.beforeDrawerOpen &&
      typeof this.config.beforeDrawerOpen === 'function'
    ) {
      // if (!externalCall) {
      this.config.beforeDrawerOpen(this);
      // }
    }

    // Add is-transitioning class to moved elements on open so drawer can have
    // transition for close animation
    this.$drawer.prepareTransition();
    this.$drawer.addClass('is-open');

    this.nodes.$parent.addClass(
      this.config.openClass + ' ' + this.config.dirOpenClass
    );
    this.drawerIsOpen = true;

    if (this.$drawer.attr('id') == 'MobileNavDrawer') {
      theme.utils.lockPageScroll(this.$drawer.find('.scroll-enabled').get(0));

    }
    else {
      theme.utils.lockPageScroll(this.$drawer.get(0));

    }


    // Set focus on drawer
    slate.a11y.trapFocus({
      $container: this.$drawer,
      namespace: 'drawer_focus',
    });

    // Run function when draw opens if set
    if (
      this.config.onDrawerOpen &&
      typeof this.config.onDrawerOpen === 'function'
    ) {
      if (!externalCall) {
        this.config.onDrawerOpen(this);
      }
    }

    if (this.$activeSource && this.$activeSource.attr('aria-expanded')) {
      this.$activeSource.attr('aria-expanded', 'true');
    }

    this.bindEvents();

    return this;
  };

  Drawer.prototype.close = function () {
    if (!this.drawerIsOpen) {
      // don't close a closed drawer
      return;
    }

    // deselect any focused form elements
    $(document.activeElement).trigger('blur');

    // Ensure closing transition is applied to moved elements, like the nav
    this.$drawer.prepareTransition();
    this.$drawer.removeClass('is-open');

    this.nodes.$parent.removeClass(
      this.config.dirOpenClass + ' ' + this.config.openClass
    );

    this.drawerIsOpen = false;

    theme.utils.unlockPageScroll();

    // Remove focus on drawer
    slate.a11y.removeTrapFocus({
      $container: this.$drawer,
      namespace: 'drawer_focus',
    });

    // Run function when draw opens if set
    if (
      this.config.onDrawerClose &&
      typeof this.config.onDrawerClose === 'function'
    ) {
      this.config.onDrawerClose();
    }

    this.unbindEvents();
  };

  Drawer.prototype.bindEvents = function () {
    this.nodes.$parent.on(
      'keyup.drawer',
      $.proxy(function (evt) {
        // close on 'esc' keypress
        if (evt.keyCode === 27) {
          this.close();
          return false;
        } else {
          return true;
        }
      }, this)
    );

    // Lock scrolling on mobile
    // this.nodes.$page.on('touchmove.drawer', function() {
    //   return false;
    // });

    this.nodes.$page.on(
      'click.drawer',
      $.proxy(function () {
        if (!this.$drawer[0].contains(event.target)) {
          this.close();
        }
      }, this)
    );
  };

  Drawer.prototype.unbindEvents = function () {
    this.nodes.$page.off('.drawer');
    this.nodes.$parent.off('.drawer');
  };

  Drawer.prototype.getProperties = function () {
    var header, headerLowerHeight, offsetTop;

    if (document.body.classList.contains('show-product-sticky')) {
      var productSticky = document.querySelector('.product-sticky');
      offsetTop = theme.utils.getBottomOffsetFromViewportTop(productSticky);
    } else if (document.body.classList.contains('show-header-lower')) {
      var headerLower = document.querySelector('.site-header-lower');
      offsetTop = theme.utils.getBottomOffsetFromViewportTop(headerLower);
    } else {
      // Calc height of visible header elements
      header = document.querySelector('.header');
      offsetTop = theme.utils.getBottomOffsetFromViewportTop(header);
    }

    return {
      top: Math.floor(offsetTop) + 'px',
      height: 'calc(100% - ' + Math.floor(offsetTop) + 'px)',
    };
  };

  return Drawer;
})();

window.theme = window.theme || {};

theme.Index = function (last, first) {
  var self = {
      version: '1.0.5',
      loop: false,
      removed: [],
      added: [],
      active: [],
      first: first || 0,
      last: last,
      span: last - (first || 0) + 1,
      back: [],

      set: function (index) {
        self.curr = clip(index);

        // set active indices
        var active = [self.curr];
        (self.prev = self.curr - 1) < self.first || active.unshift(self.prev);
        (self.next = self.curr + 1) > self.last || active.push(self.next);

        self.prev = clip(self.prev);
        self.next = clip(self.next);

        // save to self
        if (typeof _ === 'function') {
          // features only available with Underscore

          (self.removed = _.difference(self.active, active)),
            (self.added = _.difference(active, self.active));
        }
        self.active = active;

        // direction
        if (self.back[0])
          self.direction = self.curr > self.back[0].prev ? 1 : -1;

        // keep a history of past indices
        self.back.unshift({
          prev: self.prev,
          curr: self.curr,
          next: self.next,
        });

        return self;
      },
    },
    clip = function (index) {
      if (self.loop) {
        if (index > self.last) return self.first;
        else if (index < self.first) return self.last;
        else return index;
      } else return Math.min(Math.max(index, self.first), self.last);
    };

  return self;
};

window.theme = window.theme || {};

theme.Modal = (function () {
  var config = {};

  function Modal(content, options) {
    this.modalContent = content;
    this.options = options || {};
    this.modal = this._createNewModal();
  }

  Modal.prototype = _.extend(Modal.prototype, {
    _createNewModal: function () {
      var featherlightOptions = this.options.featherlightOptions;
      var modal = $.odModal($(this.modalContent), featherlightOptions);

      if (this.options.positionX || this.options.positionY) {
        modal.$instance.addClass('od-modal--' + this.options.positionX);
        modal.$instance.addClass('od-modal--' + this.options.positionY);
      }

      return modal;
    },
  });

  return Modal;
})();

(function () {
  var selectors = {
    tabHandles: '.tabs-menu a',
  };

  var classes = {
    qtySelector: 'js-qty-select',
  };

  var $tabHandles = $(selectors.tabHandles);

  if (!$tabHandles.length) {
    return;
  }

  $(selectors.tabHandles).click(function (e) {
    e.preventDefault();
    var $this = $(this);
    $this.parent().addClass('current');
    $this.parent().siblings().removeClass('current');
    var tab = $this.attr('href');
    $('.tab-content').not(tab).css('display', 'none');
    $(tab).fadeIn();
  });
})();

window.theme = window.theme || {};

// new theme.TabAccordions('.tabs, .accordion', {
//   hashWatch: true,
//   pauseMedia: true,
//   responsiveSwitch: 'tablist',
//   saveState: sessionStorage,
// });
//

// <div class="tabs minimal hide-title">

//   <section>
//     <h1>Title 1</h1>
//     <div>Section 1</div>
//   </section>

//   <section>
//     <h1>Title 2</h1>
//     <div>Section 3<br>Section 3<br>Section 3<br>Section 3<br>Section 3<br>Section 3<br></div>
//   </section>

//   <section>
//     <h1>Title 3</h1>
//     <div>Section 3</div>
//   </section>

// </div>

theme.TabAccordions = (function () {
  function TabAccordion(element, options) {
    var count = 0;
    var defaults = {
      namespace: 'ODTabAccordion',
    };

    this.$element = $(element);

    if (!this.$element.length) {
      return false;
    }

    this.config = $.extend(defaults, options);
    this.namespace = this.config.namespace + '-' + count++;
    this.type =
      (this.$element.hasClass('accordion') && 'accordion') ||
      (this.$element.hasClass('tabs') && 'tabs');
    return this.create();
  }

  TabAccordion.prototype.create = function () {
    this.$panels = this.$element.children();
    this.$tabs = this.$panels.children(':first-child');

    if (this.index) var prev = this.index.curr;
    (this.index = theme.Index(this.$panels.length - 1)).loop = true; // <- index looping for keyboard accessibility
    if (prev) this.index.set(prev);

    if (this.type === 'tabs')
      this.$element.prepend(
        (this.$tabs = this.tabsCreateTablist(this.$tabs).children()).end()
      );

    this.$tablist = (this.type === 'tabs'
      ? this.$tabs.parent()
      : this.$element
    ).attr('role', 'tablist');

    this.$tabs.attr({
      id: function (index) {
        return this.id || this.namespace + '-tab-' + index;
      },
      role: 'tab',
    });

    var self = this;

    (this.$content = this.$panels.map(function (index) {
      return $(this)
        .attr({
          'aria-labelledby': self.$tabs[index].id,
          id: self.id || self.namespace + '-panel-' + index,
          role: 'tabpanel',
        })
        .children()
        .slice(1)
        .wrapAll('<div><div></div></div>')
        .parent()
        .parent()
        .get();
    })).each($.proxy(this.collapse, this));

    $(window).on(
      'resize.' + this.namespace,
      $.debounce(250, $.proxy(this.resize, this))
    );

    this.$element
      .attr({
        id: this.$element.id || this.namespace,
        tabindex: 0,
      })
      .on(
        'click.' + this.namespace,
        (this.type === 'accordion' && '> * > :first-child') ||
          '> :first-child > *',
        function (event) {
          self.goTo(self.$tabs.index($(event.target).closest(self.$tabs)));
        }
      )
      .on('keydown.' + this.namespace, function (event) {
        // event.target should be the element and not a descendant
        if (event.target !== self.$element) return;

        var match = {
          37: 'prev',
          38: 'prev',
          39: 'next',
          40: 'next',
        }[event.keyCode];

        if (match) {
          event.preventDefault();

          self.goTo(self.index[match]);
        }
      })
      .trigger('create');

    if (this.config.saveState)
      this.extensions.saveState.bind(this, this.config.saveState) &&
        this.extensions.saveState();
    if (this.config.responsiveSwitch)
      this.extensions.responsiveSwitch.bind(
        this,
        this.config.responsiveSwitch
      ) && this.extensions.responsiveSwitch();
    if (this.config.hashWatch) this.extensions.hashWatch.call(this);
    if (this.config.pauseMedia) this.extensions.pauseMedia.call(this);

    if (typeof this.index.curr !== 'number') this.index.set(0);

    setTimeout(function () {
      self.$element.addClass('transition');
    });

    return this.expand(this.index.curr);
  };

  TabAccordion.prototype.destroy = function (keepData) {
    if (this.type === 'tabs') {
      this.$element.height('auto');
      this.$tablist.remove();
    } else {
      this.$tabs
        .removeAttr('role')
        .filter('[id^="' + this.namespace + '"]')
        .removeAttr('id');
      this.$tablist.removeAttr('role');
    }

    this.$panels
      .removeAttr('aria-expanded aria-labelledby role')
      .filter('[id^="' + this.namespace + '"]')
      .removeAttr('id');

    this.$content.children().children().unwrap().unwrap();

    if (!keepData)
      this.$element
        .removeData(namespace)
        .removeData('responsiveBreakpoint.' + this.namespace);

    this.$element
      .add([window, document.body])
      .off('.' + this.namespace)
      .end()
      .removeAttr('aria-activedescendant tabindex')
      .removeClass(this.type)
      .filter('[id^="' + this.namespace + '"]')
      .removeAttr('id')
      .end()
      .trigger('destroy');

    return this;
  };

  TabAccordion.prototype.resize = function () {
    if (this.type === 'tabs')
      this.$element.height(
        this.$tablist.outerHeight() +
          this.$panels.eq(this.index.curr).outerHeight()
      );
    else if (
      this.type === 'accordion' &&
      this.$panels[this.index.curr].ariaExpanded
    )
      this.$content
        .eq(this.index.curr)
        .height(this.$content.eq(this.index.curr).children().outerHeight());

    return this;
  };

  TabAccordion.prototype.expand = function (index) {
    var $panel = this.$panels
      .eq(index)
      .attr('aria-expanded', (this.$panels[index].ariaExpanded = true));

    if (this.resize().type === 'tabs') this.$tabs.eq(index).addClass('current');

    this.$element
      .attr('aria-activedescendant', this.$panels[this.index.curr].id)
      .trigger('expand', [index, $panel]);

    return this;
  };

  TabAccordion.prototype.collapse = function (index) {
    var $panel = this.$panels
      .eq(index)
      .attr('aria-expanded', (this.$panels[index].ariaExpanded = false));

    if (this.type === 'tabs') {
      this.$tabs.eq(index).removeClass('current');
    } else {
      this.$content.eq(index).height(0);
    }

    this.$element.trigger('collapse', [index, $panel]);

    return this;
  };

  TabAccordion.prototype.goTo = function (index) {
    if (this.index.curr !== index && typeof this.index.curr === 'number')
      this.collapse(this.index.curr);
    this.index.set(index);

    return this[
      this.type === 'accordion' && this.$panels.eq(index).prop('ariaExpanded')
        ? 'collapse'
        : 'expand'
    ](this.index.curr);
  };

  TabAccordion.prototype.tabsCreateTablist = function (titles) {
    if (typeof this.config.tabsCreateTablist === 'function') {
      return this.config.tabsCreateTablist();
    }

    for (var i = 0, li = ''; i < titles.length; i++)
      li += '<li>' + titles[i].innerHTML + '</li>';
    return $('<ul>' + li + '</ul>');
  };

  TabAccordion.prototype.extensions = {
    hashWatch: function () {
      var that = {
        changeHash: function (hash, $target) {
          var id = $target[0].id;

          $target[0].id = '';
          location.hash = hash;
          $target[0].id = id;

          return that;
        },

        expand: function (hash, event) {
          var $target = this.$element.find(hash);

          if ($target.length) {
            var $panel = $target.closest(this.$panels);

            if ($panel.length) {
              if (event) event.preventDefault();

              this.goTo(this.$panels.index($panel));
              that.changeHash(hash, $target);

              if (event)
                setTimeout(function () {
                  $html.add(document.body).animate({
                    scrollTop: $target.offset().top,
                  });
                }, 250);
            }
          }

          return that;
        },
      };

      // hash anchor activation
      $(document.body)
        .on(
          'click.' + this.namespace,
          'a[href^="#"]:not([href="#"])',
          function (event) {
            that.expand.call(self, $(event.target).attr('href'), event);
          }
        )

        // navigation e.g. back button
        .on('hashchange.' + this.namespace, function () {
          that.expand.call(self, location.hash);
        });

      return that.expand.call(this, location.hash);
    },

    saveStateLoaded: false,
    saveState: function (storage) {
      if (typeof storage !== 'object') return;

      var state = {
        remove: function () {
          storage.removeItem(this.namespace);
        },

        load: function () {
          var item = storage.getItem(this.namespace),
            data = JSON.parse(item);

          if (data && data.current) this.index.set(data.current);

          this.extensions.saveStateLoaded = true;
        },

        save: function () {
          storage.setItem(
            this.namespace,
            JSON.stringify({
              current: this.index.curr,
              expanded: this.$panels[this.index.curr].ariaExpanded,
            })
          );
        },
      };

      // load only once per instance per page load
      if (!this.extensions.saveStateLoaded) state.load();

      $(window).on('unload.' + this.namespace, state.save);

      return state;
    },

    responsiveSwitch: function (breakpoint) {
      if (breakpoint === 'tablist') {
        if (this.type === 'tabs')
          this.$element.data(
            'responsiveBreakpoint.' + this.namespace,
            (breakpoint = getTablistWidth())
          );
        else
          breakpoint = this.$element.data(
            'responsiveBreakpoint.' + this.namespace
          );
      }

      function getTablistWidth() {
        for (var i = 0, width = 0; i < this.$tabs.length; i++)
          width += this.$tabs.eq(i).outerWidth(true);
        return width;
      }

      function switchTo(type) {
        var current = this.index.curr,
          expanded = this.$panels[current].ariaExpanded;

        this.destroy(true);

        this.$element.addClass((this.type = type));

        this.index.set(current);
        this.create();

        this.$element.trigger('typechange', type);
      }

      function checkBreakpoint() {
        var type =
          this.$element.outerWidth() <= breakpoint ? 'accordion' : 'tabs';
        if (this.type !== type) switchTo(type);
      }

      $(window).on(
        'resize.' + this.namespace,
        $.debounce(250, checkBreakpoint)
      );
    },

    pauseMedia: function () {
      if (
        typeof Modernizr === 'undefined' ||
        !Modernizr.audio ||
        !Modernizr.video ||
        !this.$element.find('audio, video').length
      )
        return;

      this.$element.on('collapse.' + this.namespace, function (
        event,
        index,
        $panel
      ) {
        $panel.find('audio, video').each(function () {
          this.pause();
        });
      });
    },
  };

  return TabAccordion;
})();

window.theme = window.theme || {};
window.theme.tabsGroups = window.theme.tabsGroups || {};

/*============================================================================
  TAB GROUPS
==============================================================================*/

theme.TabsGroup = (function () {
  var selectors = {
    container: '.tabs-group',
    tab: '.tabs-group__tab',
  };

  var defaultOptions = {
    activeTab: 1,
    tabsActiveClass: 'tabs-group--active',
    navContainerClass: 'tabs-group__nav',
    tabNavItemClass: 'tabs-group__nav-item',
    accordionNavItemClass: 'tabs-group__accordion-nav-item',
    breakpoint: 990,
    transitionDuration: 0.5,
  };

  function TabsGroup(el, options) {
    this.$tabsGroup = $(el);

    if (!this.$tabsGroup.length) {
      return;
    }

    this.options = _.defaults(options, defaultOptions);

    this.config = {
      mediaQueryAccordion:
        'screen and (max-width: ' + this.options.breakpoint + 'px)',
      mediaQueryTabs:
        'screen and (min-width:  ' + (this.options.breakpoint + 1) + 'px)',
    };

    this.$tabs = this.$tabsGroup.find(selectors.tab);
    this.$navContainer = $('<div></div>').addClass(
      this.options.navContainerClass
    );

    // Set initial tab states
    for (var j = this.$tabs.length - 1; j >= 0; j--) {
      var $tab = $(this.$tabs[j]);
      var tabId = $tab.data('tab');
      var tabTitle = $tab.data('tabTitle');

      var $navItem = $('<div></div>')
        .attr('data-target', tabId)
        .attr('data-target-title', tabTitle)
        .html(tabTitle);

      if (tabId == this.options.activeTab) {
        this.activeTab = tabId;
        $tab.attr('data-active', 'true');
        $navItem.attr('data-active', 'true');
      } else {
        $tab.attr('data-active', 'false');
        $navItem.attr('data-active', 'false');
      }

      var $tabNavItem = $navItem;
      var $accordionNavItem = $navItem.clone();

      $tabNavItem.addClass(this.options.tabNavItemClass);
      this.$navContainer.prepend($tabNavItem);

      $accordionNavItem
        .addClass(this.options.accordionNavItemClass)
        .insertBefore($tab);
    }

    this.$tabsGroup.prepend(this.$navContainer);
    this.$navItems = this.$tabsGroup.find('[data-target]');

    var self = this;

    enquire.register(this.config.mediaQueryAccordion, {
      match: function () {
        self.$tabsGroup.attr('data-tabs-type', 'accordion');
      },
    });

    enquire.register(this.config.mediaQueryTabs, {
      match: function () {
        self.$tabsGroup.attr('data-tabs-type', 'tabs');
      },
    });

    // Bind nav click events
    $(this.$navItems).on('click', function () {
      var target = $(this).data('target');

      if (self.activeTab == target) {
        self._closeAll();
      } else {
        self._goTo(target);
        self.activeTab = target;
      }
    });

    $(this.$tabsGroup).addClass(this.options.tabsActiveClass);
  }

  TabsGroup.prototype = $.extend({}, TabsGroup.prototype, {
    _closeAll: function () {
      var self = this;

      if (self.$tabsGroup.attr('data-tabs-type') != 'accordion') {
        return;
      }

      var $activeTab = $(
        '[data-tab="' + self.activeTab + '"]',
        self.$tabsGroup
      );

      var animate = false;
      if ($(window).width() < this.options.breakpoint) {
        animate = true;
      }

      var height = {
        active: {},
      };

      if (animate) {
        height.active.current = $activeTab.height();
        $activeTab.css('height', height.active.current);
      }

      $(self.$tabs).attr('data-active', 'false');
      $(self.$navItems).attr('data-active', 'false');

      if (animate) {
        height.active.new = 0;

        $activeTab.height(height.active.current);

        $activeTab.height(height.active.new);

        setTimeout(function () {
          $activeTab.css('height', '');
        }, self.options.transitionDuration * 1000);
      }

      self.activeTab = false;
    },
    _goTo: function (target) {
      var self = this;

      this.$tabsGroup.trigger({
        type: 'tabChange',
        tabIndex: target,
      });

      var $tab = $('[data-tab="' + target + '"]', self.$tabsGroup);
      var $activeTab = $(
        '[data-tab="' + self.activeTab + '"]',
        self.$tabsGroup
      );

      var animate = false;
      if ($(window).width() < this.options.breakpoint) {
        animate = true;
      }

      var height = {
        target: {},
        active: {},
      };

      if (animate) {
        height.target.current = 0;
        $tab.css('height', height.target.current);

        height.active.current = $activeTab.height();
        $activeTab.css('height', height.active.current);
      }

      $(self.$tabs).attr('data-active', 'false');
      $(self.$navItems).attr('data-active', 'false');

      var $target = self.$tabsGroup.find('[data-tab=' + target + ']');
      $($target).attr('data-active', 'true');

      var $targetNav = self.$tabsGroup.find('[data-target=' + target + ']');
      $($targetNav).attr('data-active', 'true');

      if (animate) {
        height.target.new = $tab.css('height', 'auto').get(0).scrollHeight;
        height.active.new = 0;

        $tab.height(height.target.current);
        $activeTab.height(height.active.current);

        $tab.height(height.target.new);
        $activeTab.height(height.active.new);

        setTimeout(function () {
          $tab.css('height', '');
          $activeTab.css('height', '');

          $(window).scrollTo($target, {
            duration: self.options.transitionDuration * 1000,
            interrupt: !isMobile.apple.device,
            offset: -100,
          });
        }, self.options.transitionDuration * 1000);
      }

      self.activeTab = target;
    },
  });

  return TabsGroup;
})();

window.theme = window.theme || {};
window.accordions = window.accordions || {};

theme.SimpleAccordion = (function () {
  var defaults = {
    activeClass: 'active',
    accordionClass: 'simple-accordion',
    accordionTitleClass: 'simple-accordion__title',
  };

  var selectors = {
    accordion: '[data-simple-accordion]',
    title: '.' + defaults.accordionTitleClass,
  };

  function SimpleAccordion(el) {
    this.$el = $(el);

    var mediaQuery = this.$el.data('simpleAccordion');

    if (mediaQuery) {
      this.mediaQuery = theme.settings.mediaQuery[mediaQuery];
    }

    var styleValue =
      theme.utils.getStyleValue('--accordion-transition-duration') || '0.5s';

    this.animationDuration = styleValue.replace('s', '') * 1000;

    this.$titles = this.$el.find(selectors.title);
    if (!this.$titles.length) {
      this.$titles = this.$el.children().first();
      this.$titles.addClass(defaults.accordionTitleClass);
    }

    var self = this;

    if (self.mediaQuery) {
      _registerBreakpoints(self.mediaQuery);
    } else {
      initAccordion();
    }

    function initAccordion() {
      self.$el.addClass(defaults.accordionClass);
      self.$titles.on('click.accordion', _openClose);
    }

    function destroyAccordion() {
      self.$el.removeClass(defaults.accordionClass);
      self.$titles.off('click.accordion');
    }

    function _registerBreakpoints(mediaQuery) {
      enquire.register(mediaQuery, {
        match: function () {
          initAccordion();
        },
        unmatch: function () {
          destroyAccordion();
        },
      });
    }

    function _openClose() {
      var $currentTitle = $(this);

      var $target = $(this).next();
      var $active = self.$titles.filter('.' + defaults.activeClass).next();

      var close = false;
      if ($target[0] == $active[0]) {
        close = true;

        // If target is a link and accordion is open then go to link
        // if (event.target.href || event.currentTarget.href) {
        //   window.location.href = event.target.href || event.currentTarget.href;
        //   return;
        // }
      }

      event.preventDefault();

      self.$titles.removeClass(defaults.activeClass);

      var height = {
        target: {},
        active: {},
      };

      height.target.current = $target.height();
      height.active.new = 0;
      height.active.current = $active.height();

      $active.height(height.active.current);

      if (!close) {
        $(this).addClass(defaults.activeClass);
        $target.height(height.target.current);
        $target.addClass(defaults.activeClass);
      }

      $active.removeClass(defaults.activeClass);

      // if (!close) {
      $target.height('auto');
      $active.height('auto');
      $active.height(height.active.new);
      height.target.new = $target.get(0).scrollHeight;
      $target.offset();
      $active.offset();
      $currentTitle.trigger('accordionTransitionHeightCalc');
      $active.height('auto');
      $active.height(height.active.current);
      $target.height(height.target.current);
      $target.height(height.target.new);
      // }

      $active.height(height.active.new);

      setTimeout(function () {
        $target.height('');
        $active.height('');
        $currentTitle.trigger('accordionTransitionEnd');
      }, self.animationDuration);

      return;
    }
  }

  (function init() {
    var $accordions = $(selectors.accordion);
    if (!$accordions.length) {
      return;
    }
    for (var i = $accordions.length - 1; i >= 0; i--) {
      window.accordions[i] = new SimpleAccordion($accordions[i]);
    }
  })();

  return SimpleAccordion;
})();

/*============================================================================
  Quantity Selectors
==============================================================================*/
window.theme = window.theme || {};

theme.QuantitySelector = (function () {
  var selectors = {
    qtyInputs: 'input[type="number"]',
    excludeInputs:
      '#cart input[type="number"], .js-qty-select input[type="number"], .product-grid-item input[type="number"]',
    qtySelector: '.js-qty-select',
    qtyButtonAdd: '.js-qty-select-add',
    qtyButtonSubtract: '.js-qty-select-sub',
  };

  var classes = {
    qtySelector: 'js-qty-select',
    qtyButtonAdd: 'js-qty-select-add',
    qtyButtonSubtract: 'js-qty-select-sub',
  };

  var defaults = {
    template: 'quantity-selector',
    formatAsSize: false,
  };

  function QuantitySelector(inputEl, userOptions) {
    if (!inputEl) {
      return false;
    }

    this.inputEl = inputEl;

    var parent, template, el, options;

    options = _.defaults(userOptions, defaults);

    parent = inputEl.parentNode;
    template = theme.utils.getTemplate(options.template);
    el = theme.utils.createElementFromHTML(template);

    this.data = {
      formatAsSize: options.variantSize ? options.formatAsSize : false,
      variantSize: options.variantSize,
    };

    this.data.input = {
      value: inputEl.value ? parseInt(inputEl.value) : 0,
      id: inputEl.id,
      class: inputEl.classList.toString(),
      max: inputEl.max ? parseInt(inputEl.max) : 10000,
      min: inputEl.min ? parseInt(inputEl.min) : 0,
      name: inputEl.name,
      pattern: inputEl.pattern,
    };

    inputEl.classList.add('hidden');
    parent.appendChild(el);

    tinybind.bind(el, {
      data: this.data,
      methods: {
        subtract: this.subtract.bind(this),
        add: this.add.bind(this),
      },
    });
  }

  QuantitySelector.prototype = _.extend({}, QuantitySelector.prototype, {
    subtract: function () {
      event.preventDefault();
      this.set(this.data.input.value - 1);
    },

    add: function () {
      event.preventDefault();
      this.set(this.data.input.value + 1);
    },

    set: function (value) {
      // #todo
      var updateEvent;

      if (this.data.input.value < this.data.input.min) {
        value = this.data.input.min;
      } else if (this.data.input.value > this.data.input.max) {
        value = this.data.input.max;
      }

      this.data.quantity = value;
      this.data.input.value = value;
      this.inputEl.value = value;

      $(this.inputEl).trigger('valueUpdated', value);
    },
  });

  return QuantitySelector;
})();

(function () {
  var classes = {
    notificationHidden: 'notification-message--hidden',
  };

  var queryParams = theme.utils.getQueryParams();

  if (queryParams === undefined || queryParams.status === undefined) {
    return;
  }

  $('[data-notification="' + queryParams.status + '"]').removeClass(
    classes.notificationHidden
  );
})();

/*
 * Currency tools
 *
 * Copyright (c) 2015 Caroline Schnapp (mllegeorgesand@gmail.com)
 * Licensed under the MIT license:
 * http://www.opensource.org/licenses/mit-license.php
 *
 */

if (typeof Currency === 'undefined') {
  var Currency = {};
}

Currency.cookie = {
  configuration: {
    expires: 365,
    path: '/',
    domain: window.location.hostname,
  },
  name: 'currency',
  write: function (currency) {
    localStorage.setItem(this.name, currency);
  },
  read: function () {
    return localStorage.getItem(this.name);
  },
  destroy: function () {
    localStorage.removeItem(this.name);
  },
};

Currency.moneyFormats = {
  USD: {
    money_format: '${{amount}}',
    money_with_currency_format: '${{amount}} USD',
  },
  EUR: {
    money_format: '&euro;{{amount}}',
    money_with_currency_format: '&euro;{{amount}} EUR',
  },
  GBP: {
    money_format: '&pound;{{amount}}',
    money_with_currency_format: '&pound;{{amount}} GBP',
  },
  CAD: {
    money_format: '${{amount}}',
    money_with_currency_format: '${{amount}} CAD',
  },
  ALL: {
    money_format: 'Lek {{amount}}',
    money_with_currency_format: 'Lek {{amount}} ALL',
  },
  DZD: {
    money_format: 'DA {{amount}}',
    money_with_currency_format: 'DA {{amount}} DZD',
  },
  AOA: {
    money_format: 'Kz{{amount}}',
    money_with_currency_format: 'Kz{{amount}} AOA',
  },
  ARS: {
    money_format: '${{amount_with_comma_separator}}',
    money_with_currency_format: '${{amount_with_comma_separator}} ARS',
  },
  AMD: {
    money_format: '{{amount}} AMD',
    money_with_currency_format: '{{amount}} AMD',
  },
  AWG: {
    money_format: 'Afl{{amount}}',
    money_with_currency_format: 'Afl{{amount}} AWG',
  },
  AUD: {
    money_format: '${{amount}}',
    money_with_currency_format: '${{amount}} AUD',
  },
  BBD: {
    money_format: '${{amount}}',
    money_with_currency_format: '${{amount}} Bds',
  },
  AZN: {
    money_format: 'm.{{amount}}',
    money_with_currency_format: 'm.{{amount}} AZN',
  },
  BDT: {
    money_format: 'Tk {{amount}}',
    money_with_currency_format: 'Tk {{amount}} BDT',
  },
  BSD: {
    money_format: 'BS${{amount}}',
    money_with_currency_format: 'BS${{amount}} BSD',
  },
  BHD: {
    money_format: '{{amount}}0 BD',
    money_with_currency_format: '{{amount}}0 BHD',
  },
  BYR: {
    money_format: 'Br {{amount}}',
    money_with_currency_format: 'Br {{amount}} BYR',
  },
  BZD: {
    money_format: 'BZ${{amount}}',
    money_with_currency_format: 'BZ${{amount}} BZD',
  },
  BTN: {
    money_format: 'Nu {{amount}}',
    money_with_currency_format: 'Nu {{amount}} BTN',
  },
  BAM: {
    money_format: 'KM {{amount_with_comma_separator}}',
    money_with_currency_format: 'KM {{amount_with_comma_separator}} BAM',
  },
  BRL: {
    money_format: 'R$ {{amount_with_comma_separator}}',
    money_with_currency_format: 'R$ {{amount_with_comma_separator}} BRL',
  },
  BOB: {
    money_format: 'Bs{{amount_with_comma_separator}}',
    money_with_currency_format: 'Bs{{amount_with_comma_separator}} BOB',
  },
  BWP: {
    money_format: 'P{{amount}}',
    money_with_currency_format: 'P{{amount}} BWP',
  },
  BND: {
    money_format: '${{amount}}',
    money_with_currency_format: '${{amount}} BND',
  },
  BGN: {
    money_format: '{{amount}} лв',
    money_with_currency_format: '{{amount}} лв BGN',
  },
  MMK: {
    money_format: 'K{{amount}}',
    money_with_currency_format: 'K{{amount}} MMK',
  },
  KHR: {
    money_format: 'KHR{{amount}}',
    money_with_currency_format: 'KHR{{amount}}',
  },
  KYD: {
    money_format: '${{amount}}',
    money_with_currency_format: '${{amount}} KYD',
  },
  XAF: {
    money_format: 'FCFA{{amount}}',
    money_with_currency_format: 'FCFA{{amount}} XAF',
  },
  CLP: {
    money_format: '${{amount_no_decimals}}',
    money_with_currency_format: '${{amount_no_decimals}} CLP',
  },
  CNY: {
    money_format: '&#165;{{amount}}',
    money_with_currency_format: '&#165;{{amount}} CNY',
  },
  COP: {
    money_format: '${{amount_with_comma_separator}}',
    money_with_currency_format: '${{amount_with_comma_separator}} COP',
  },
  CRC: {
    money_format: '&#8353; {{amount_with_comma_separator}}',
    money_with_currency_format: '&#8353; {{amount_with_comma_separator}} CRC',
  },
  HRK: {
    money_format: '{{amount_with_comma_separator}} kn',
    money_with_currency_format: '{{amount_with_comma_separator}} kn HRK',
  },
  CZK: {
    money_format: '{{amount_with_comma_separator}} K&#269;',
    money_with_currency_format: '{{amount_with_comma_separator}} K&#269;',
  },
  DKK: {
    money_format: '{{amount_with_comma_separator}}',
    money_with_currency_format: 'kr.{{amount_with_comma_separator}}',
  },
  DOP: {
    money_format: 'RD$ {{amount}}',
    money_with_currency_format: 'RD$ {{amount}}',
  },
  XCD: {
    money_format: '${{amount}}',
    money_with_currency_format: 'EC${{amount}}',
  },
  EGP: {
    money_format: 'LE {{amount}}',
    money_with_currency_format: 'LE {{amount}} EGP',
  },
  ETB: {
    money_format: 'Br{{amount}}',
    money_with_currency_format: 'Br{{amount}} ETB',
  },
  XPF: {
    money_format: '{{amount_no_decimals_with_comma_separator}} XPF',
    money_with_currency_format:
      '{{amount_no_decimals_with_comma_separator}} XPF',
  },
  FJD: {
    money_format: '${{amount}}',
    money_with_currency_format: 'FJ${{amount}}',
  },
  GMD: {
    money_format: 'D {{amount}}',
    money_with_currency_format: 'D {{amount}} GMD',
  },
  GHS: {
    money_format: 'GH&#8373;{{amount}}',
    money_with_currency_format: 'GH&#8373;{{amount}}',
  },
  GTQ: {
    money_format: 'Q{{amount}}',
    money_with_currency_format: '{{amount}} GTQ',
  },
  GYD: {
    money_format: 'G${{amount}}',
    money_with_currency_format: '${{amount}} GYD',
  },
  GEL: {
    money_format: '{{amount}} GEL',
    money_with_currency_format: '{{amount}} GEL',
  },
  HNL: {
    money_format: 'L {{amount}}',
    money_with_currency_format: 'L {{amount}} HNL',
  },
  HKD: {
    money_format: '${{amount}}',
    money_with_currency_format: 'HK${{amount}}',
  },
  HUF: {
    money_format: '{{amount_no_decimals_with_comma_separator}}',
    money_with_currency_format:
      '{{amount_no_decimals_with_comma_separator}} Ft',
  },
  ISK: {
    money_format: '{{amount_no_decimals}} kr',
    money_with_currency_format: '{{amount_no_decimals}} kr ISK',
  },
  INR: {
    money_format: 'Rs. {{amount}}',
    money_with_currency_format: 'Rs. {{amount}}',
  },
  IDR: {
    money_format: '{{amount_with_comma_separator}}',
    money_with_currency_format: 'Rp {{amount_with_comma_separator}}',
  },
  ILS: {
    money_format: '{{amount}} NIS',
    money_with_currency_format: '{{amount}} NIS',
  },
  JMD: {
    money_format: '${{amount}}',
    money_with_currency_format: '${{amount}} JMD',
  },
  JPY: {
    money_format: '&#165;{{amount_no_decimals}}',
    money_with_currency_format: '&#165;{{amount_no_decimals}} JPY',
  },
  JEP: {
    money_format: '&pound;{{amount}}',
    money_with_currency_format: '&pound;{{amount}} JEP',
  },
  JOD: {
    money_format: '{{amount}}0 JD',
    money_with_currency_format: '{{amount}}0 JOD',
  },
  KZT: {
    money_format: '{{amount}} KZT',
    money_with_currency_format: '{{amount}} KZT',
  },
  KES: {
    money_format: 'KSh{{amount}}',
    money_with_currency_format: 'KSh{{amount}}',
  },
  KWD: {
    money_format: '{{amount}}0 KD',
    money_with_currency_format: '{{amount}}0 KWD',
  },
  KGS: {
    money_format: 'лв{{amount}}',
    money_with_currency_format: 'лв{{amount}}',
  },
  LVL: {
    money_format: 'Ls {{amount}}',
    money_with_currency_format: 'Ls {{amount}} LVL',
  },
  LBP: {
    money_format: 'L&pound;{{amount}}',
    money_with_currency_format: 'L&pound;{{amount}} LBP',
  },
  LTL: {
    money_format: '{{amount}} Lt',
    money_with_currency_format: '{{amount}} Lt',
  },
  MGA: {
    money_format: 'Ar {{amount}}',
    money_with_currency_format: 'Ar {{amount}} MGA',
  },
  MKD: {
    money_format: 'ден {{amount}}',
    money_with_currency_format: 'ден {{amount}} MKD',
  },
  MOP: {
    money_format: 'MOP${{amount}}',
    money_with_currency_format: 'MOP${{amount}}',
  },
  MVR: {
    money_format: 'Rf{{amount}}',
    money_with_currency_format: 'Rf{{amount}} MRf',
  },
  MXN: {
    money_format: '$ {{amount}}',
    money_with_currency_format: '$ {{amount}} MXN',
  },
  MYR: {
    money_format: 'RM{{amount}} MYR',
    money_with_currency_format: 'RM{{amount}} MYR',
  },
  MUR: {
    money_format: 'Rs {{amount}}',
    money_with_currency_format: 'Rs {{amount}} MUR',
  },
  MDL: {
    money_format: '{{amount}} MDL',
    money_with_currency_format: '{{amount}} MDL',
  },
  MAD: {
    money_format: '{{amount}} dh',
    money_with_currency_format: 'Dh {{amount}} MAD',
  },
  MNT: {
    money_format: '{{amount_no_decimals}} &#8366',
    money_with_currency_format: '{{amount_no_decimals}} MNT',
  },
  MZN: {
    money_format: '{{amount}} Mt',
    money_with_currency_format: 'Mt {{amount}} MZN',
  },
  NAD: {
    money_format: 'N${{amount}}',
    money_with_currency_format: 'N${{amount}} NAD',
  },
  NPR: {
    money_format: 'Rs{{amount}}',
    money_with_currency_format: 'Rs{{amount}} NPR',
  },
  ANG: {
    money_format: '&fnof;{{amount}}',
    money_with_currency_format: '{{amount}} NA&fnof;',
  },
  NZD: {
    money_format: '${{amount}}',
    money_with_currency_format: '${{amount}} NZD',
  },
  NIO: {
    money_format: 'C${{amount}}',
    money_with_currency_format: 'C${{amount}} NIO',
  },
  NGN: {
    money_format: '&#8358;{{amount}}',
    money_with_currency_format: '&#8358;{{amount}} NGN',
  },
  NOK: {
    money_format: 'kr {{amount_with_comma_separator}}',
    money_with_currency_format: 'kr {{amount_with_comma_separator}} NOK',
  },
  OMR: {
    money_format: '{{amount_with_comma_separator}} OMR',
    money_with_currency_format: '{{amount_with_comma_separator}} OMR',
  },
  PKR: {
    money_format: 'Rs.{{amount}}',
    money_with_currency_format: 'Rs.{{amount}} PKR',
  },
  PGK: {
    money_format: 'K {{amount}}',
    money_with_currency_format: 'K {{amount}} PGK',
  },
  PYG: {
    money_format: 'Gs. {{amount_no_decimals_with_comma_separator}}',
    money_with_currency_format:
      'Gs. {{amount_no_decimals_with_comma_separator}} PYG',
  },
  PEN: {
    money_format: 'S/. {{amount}}',
    money_with_currency_format: 'S/. {{amount}} PEN',
  },
  PHP: {
    money_format: '&#8369;{{amount}}',
    money_with_currency_format: '&#8369;{{amount}} PHP',
  },
  PLN: {
    money_format: '{{amount_with_comma_separator}} zl',
    money_with_currency_format: '{{amount_with_comma_separator}} zl PLN',
  },
  QAR: {
    money_format: 'QAR {{amount_with_comma_separator}}',
    money_with_currency_format: 'QAR {{amount_with_comma_separator}}',
  },
  RON: {
    money_format: '{{amount_with_comma_separator}} lei',
    money_with_currency_format: '{{amount_with_comma_separator}} lei RON',
  },
  RUB: {
    money_format: '&#1088;&#1091;&#1073;{{amount_with_comma_separator}}',
    money_with_currency_format:
      '&#1088;&#1091;&#1073;{{amount_with_comma_separator}} RUB',
  },
  RWF: {
    money_format: '{{amount_no_decimals}} RF',
    money_with_currency_format: '{{amount_no_decimals}} RWF',
  },
  WST: {
    money_format: 'WS$ {{amount}}',
    money_with_currency_format: 'WS$ {{amount}} WST',
  },
  SAR: {
    money_format: '{{amount}} SR',
    money_with_currency_format: '{{amount}} SAR',
  },
  STD: {
    money_format: 'Db {{amount}}',
    money_with_currency_format: 'Db {{amount}} STD',
  },
  RSD: {
    money_format: '{{amount}} RSD',
    money_with_currency_format: '{{amount}} RSD',
  },
  SCR: {
    money_format: 'Rs {{amount}}',
    money_with_currency_format: 'Rs {{amount}} SCR',
  },
  SGD: {
    money_format: '${{amount}}',
    money_with_currency_format: '${{amount}} SGD',
  },
  SYP: {
    money_format: 'S&pound;{{amount}}',
    money_with_currency_format: 'S&pound;{{amount}} SYP',
  },
  ZAR: {
    money_format: 'R {{amount}}',
    money_with_currency_format: 'R {{amount}} ZAR',
  },
  KRW: {
    money_format: '&#8361;{{amount_no_decimals}}',
    money_with_currency_format: '&#8361;{{amount_no_decimals}} KRW',
  },
  LKR: {
    money_format: 'Rs {{amount}}',
    money_with_currency_format: 'Rs {{amount}} LKR',
  },
  SEK: {
    money_format: '{{amount_no_decimals}} kr',
    money_with_currency_format: '{{amount_no_decimals}} kr SEK',
  },
  CHF: {
    money_format: 'SFr. {{amount}}',
    money_with_currency_format: 'SFr. {{amount}} CHF',
  },
  TWD: {
    money_format: '${{amount}}',
    money_with_currency_format: '${{amount}} TWD',
  },
  THB: {
    money_format: '{{amount}} &#xe3f;',
    money_with_currency_format: '{{amount}} &#xe3f; THB',
  },
  TZS: {
    money_format: '{{amount}} TZS',
    money_with_currency_format: '{{amount}} TZS',
  },
  TTD: {
    money_format: '${{amount}}',
    money_with_currency_format: '${{amount}} TTD',
  },
  TND: {
    money_format: '{{amount}}',
    money_with_currency_format: '{{amount}} DT',
  },
  TRY: {
    money_format: '{{amount}}TL',
    money_with_currency_format: '{{amount}}TL',
  },
  UGX: {
    money_format: 'Ush {{amount_no_decimals}}',
    money_with_currency_format: 'Ush {{amount_no_decimals}} UGX',
  },
  UAH: {
    money_format: '₴{{amount}}',
    money_with_currency_format: '₴{{amount}} UAH',
  },
  AED: {
    money_format: 'Dhs. {{amount}}',
    money_with_currency_format: 'Dhs. {{amount}} AED',
  },
  UYU: {
    money_format: '${{amount_with_comma_separator}}',
    money_with_currency_format: '${{amount_with_comma_separator}} UYU',
  },
  VUV: {
    money_format: '${{amount}}',
    money_with_currency_format: '${{amount}}VT',
  },
  VEF: {
    money_format: 'Bs. {{amount_with_comma_separator}}',
    money_with_currency_format: 'Bs. {{amount_with_comma_separator}} VEF',
  },
  VND: {
    money_format: '{{amount_no_decimals_with_comma_separator}}&#8363;',
    money_with_currency_format:
      '{{amount_no_decimals_with_comma_separator}} VND',
  },
  XBT: {
    money_format: '{{amount_no_decimals}} BTC',
    money_with_currency_format: '{{amount_no_decimals}} BTC',
  },
  XOF: {
    money_format: 'CFA{{amount}}',
    money_with_currency_format: 'CFA{{amount}} XOF',
  },
  ZMW: {
    money_format: 'K{{amount_no_decimals_with_comma_separator}}',
    money_with_currency_format:
      'ZMW{{amount_no_decimals_with_comma_separator}}',
  },
};

Currency.formatMoney = function (cents, format) {
  if (typeof Shopify.formatMoney === 'function') {
    return Shopify.formatMoney(cents, format);
  }
  if (typeof cents == 'string') {
    cents = cents.replace('.', '');
  }
  var value = '';
  var placeholderRegex = /\{\{\s*(\w+)\s*\}\}/;
  var formatString = format || '${{amount}}';
  function defaultOption(opt, def) {
    return typeof opt == 'undefined' ? def : opt;
  }
  function formatWithDelimiters(number, precision, thousands, decimal) {
    precision = defaultOption(precision, 2);
    thousands = defaultOption(thousands, ',');
    decimal = defaultOption(decimal, '.');
    if (isNaN(number) || number == null) {
      return 0;
    }
    number = (number / 100.0).toFixed(precision);
    var parts = number.split('.'),
      dollars = parts[0].replace(/(\d)(?=(\d\d\d)+(?!\d))/g, '$1' + thousands),
      cents = parts[1] ? decimal + parts[1] : '';
    return dollars + cents;
  }
  switch (formatString.match(placeholderRegex)[1]) {
    case 'amount':
      value = formatWithDelimiters(cents, 2);
      break;
    case 'amount_no_decimals':
      value = formatWithDelimiters(cents, 0);
      break;
    case 'amount_with_comma_separator':
      value = formatWithDelimiters(cents, 2, '.', ',');
      break;
    case 'amount_no_decimals_with_comma_separator':
      value = formatWithDelimiters(cents, 0, '.', ',');
      break;
  }
  return formatString.replace(placeholderRegex, value);
};

Currency.currentCurrency = '';

Currency.format = 'money_with_currency_format';

Currency.convertAll = function (oldCurrency, newCurrency, selector, format) {
  if (newCurrency === undefined) {
    return;
  }

  $(selector || 'span.money').each(function () {
    // If the amount has already been converted, we leave it alone.
    if ($(this).attr('data-currency') === newCurrency) return;
    // If we are converting to a currency that we have saved, we will use the saved amount.
    if ($(this).attr('data-currency-' + newCurrency)) {
      $(this).html($(this).attr('data-currency-' + newCurrency));
    } else {
      // Converting to Y for the first time? Let's get to it!
      var cents = 0.0;
      var oldFormat =
        Currency.moneyFormats[oldCurrency][format || Currency.format] ||
        '{{amount}}';
      var newFormat =
        Currency.moneyFormats[newCurrency][format || Currency.format] ||
        '{{amount}}';
      if (oldFormat.indexOf('amount_no_decimals') !== -1) {
        cents = Currency.convert(
          parseInt(
            $(this)
              .html()
              .replace(/[^0-9]/g, ''),
            10
          ) * 100,
          oldCurrency,
          newCurrency
        );
      } else if (
        oldCurrency === 'JOD' ||
        oldCurrency == 'KWD' ||
        oldCurrency == 'BHD'
      ) {
        cents = Currency.convert(
          parseInt(
            $(this)
              .html()
              .replace(/[^0-9]/g, ''),
            10
          ) / 10,
          oldCurrency,
          newCurrency
        );
      } else {
        cents = Currency.convert(
          parseInt(
            $(this)
              .html()
              .replace(/[^0-9]/g, ''),
            10
          ),
          oldCurrency,
          newCurrency
        );
      }
      var newFormattedAmount = Currency.formatMoney(cents, newFormat);
      $(this).html(newFormattedAmount);
      $(this).attr('data-currency-' + newCurrency, newFormattedAmount);
    }
    // We record the new currency locally.
    $(this).attr('data-currency', newCurrency);
  });
  this.currentFormat =
    Currency.moneyFormats[newCurrency][format || Currency.format] ||
    '{{amount}}';
  this.currentCurrency = newCurrency;
  this.cookie.write(newCurrency);
};

/*============================================================================
  Development Helpers
==============================================================================*/
(function () {
  var isDevelopment =
      window.location.hostname == 'localhost' ||
      $(document.documentElement).hasClass('localhost'),
    debugMode = false;

  if (isDevelopment) {
    console.log(
      'Theme name: ' +
        Shopify.theme.name +
        '. Theme ID: ' +
        Shopify.theme.id +
        '. Theme status: ' +
        (Shopify.theme.role == 'main' ? 'Live' : 'Unpublished') +
        '.'
    );
    if (Shopify.theme.role == 'main') {
      console.warn('Hold up! This is the live theme!');
    }

    document.documentElement.classList.add('localhost');
    // Shopify.designMode = true;

    // Media Query Infobox + Admin Links
    var globeIcon =
      '<svg aria-hidden="true" data-prefix="fas" data-icon="globe" class="svg-inline--fa fa-globe fa-w-16" role="img" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 496 512"><path fill="currentColor" d="M336.5 160C322 70.7 287.8 8 248 8s-74 62.7-88.5 152h177zM152 256c0 22.2 1.2 43.5 3.3 64h185.3c2.1-20.5 3.3-41.8 3.3-64s-1.2-43.5-3.3-64H155.3c-2.1 20.5-3.3 41.8-3.3 64zm324.7-96c-28.6-67.9-86.5-120.4-158-141.6 24.4 33.8 41.2 84.7 50 141.6h108zM177.2 18.4C105.8 39.6 47.8 92.1 19.3 160h108c8.7-56.9 25.5-107.8 49.9-141.6zM487.4 192H372.7c2.1 21 3.3 42.5 3.3 64s-1.2 43-3.3 64h114.6c5.5-20.5 8.6-41.8 8.6-64s-3.1-43.5-8.5-64zM120 256c0-21.5 1.2-43 3.3-64H8.6C3.2 212.5 0 233.8 0 256s3.2 43.5 8.6 64h114.6c-2-21-3.2-42.5-3.2-64zm39.5 96c14.5 89.3 48.7 152 88.5 152s74-62.7 88.5-152h-177zm159.3 141.6c71.4-21.2 129.4-73.7 158-141.6h-108c-8.8 56.9-25.6 107.8-50 141.6zM19.3 352c28.6 67.9 86.5 120.4 158 141.6-24.4-33.8-41.2-84.7-50-141.6h-108z"></path></svg>';
    var pencilIcon =
      '<svg aria-hidden="true" data-prefix="fas" data-icon="pencil-alt" class="svg-inline--fa fa-pencil-alt fa-w-16" role="img" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 512 512"><path fill="currentColor" d="M497.9 142.1l-46.1 46.1c-4.7 4.7-12.3 4.7-17 0l-111-111c-4.7-4.7-4.7-12.3 0-17l46.1-46.1c18.7-18.7 49.1-18.7 67.9 0l60.1 60.1c18.8 18.7 18.8 49.1 0 67.9zM284.2 99.8L21.6 362.4.4 483.9c-2.9 16.4 11.4 30.6 27.8 27.8l121.5-21.3 262.6-262.6c4.7-4.7 4.7-12.3 0-17l-111-111c-4.8-4.7-12.4-4.7-17.1 0zM124.1 339.9c-5.5-5.5-5.5-14.3 0-19.8l154-154c5.5-5.5 14.3-5.5 19.8 0s5.5 14.3 0 19.8l-154 154c-5.5 5.5-14.3 5.5-19.8 0zM88 424h48v36.3l-64.5 11.3-31.1-31.1L51.7 376H88v48z"></path></svg>';
    $('body').append(
      '<div class="dev-helper"><div class="links"><a href="https://shopify.com/admin" title="Admin" target="_blank" rel="noopener noreferrer">' +
        globeIcon +
        '</a><a href="https://shopify.com/admin/themes/' +
        Shopify.theme.id +
        '/editor" title="Customise" target="_blank" rel="noopener noreferrer">' +
        pencilIcon +
        '</a></div><div class="mq" title="' +
        Shopify.theme.name +
        '"><span class="visible-xs">XS</span><span class="visible-sm">SM</span><span class="visible-md">MD</span><span class="visible-lg">LG</span><span class="visible-xl">XL</span></div></div>'
    );

    // Make SCSS debug info easier to see on the frontend
    // Checks to see if the hidden skiplink is showing and, shows a link to the debug output
    try {
      if (
        window.getComputedStyle(
          document.querySelector('a.visually-hidden.skip-link')
        ).position == 'static'
      ) {
        debugMode = true;

        for (var i = 0; i < document.styleSheets.length; i++) {
          if (
            document.styleSheets[i].href &&
            document.styleSheets[i].href.indexOf('/assets/theme.scss.css?') > -1
          ) {
            $('body > *').hide();
            $('body').append('<span>Please wait...</span>');
            // $.get('/collections', function(data){
            //   var scriptString = '<script';
            //   scriptString += data.split('id="theme-js"')[1].split('</script>')[0];
            //   scriptString += '$("body > *").hide(); $("body").append("<span>There was a problem loading styles. Check the customise area in the Shopify admin interface or </span> <a href=\'https://" + shop.permanantDomain + "/services/assets/" + Shopify.theme.id + "/editor_asset/theme.scss.css\' target=\'_blank\' rel=\'noopener noreferrer\'>click here for debug information.</a>");';
            //   scriptString += '</script>';
            //   $('head').append(scriptString);
            // });
            $.get(document.styleSheets[i].href).fail(function (data) {
              $('body').html('<pre>' + data.responseText + '</pre>');
            });
            break;
          }
        }
      }
    } catch (err) {}
  }

  if (
    (debugMode =
      false &&
      (Shopify.theme.role == 'unpublished' ||
        Shopify.designMode ||
        isDevelopment))
  ) {
    var pacifierIcon =
      '<svg aria-hidden="true" focusable="false" role="presentation" class="icon icon--full-color icon-pacifier" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 500 500"><defs><style>.cls-8{fill:none;stroke:#000;stroke-linecap:round;stroke-linejoin:round;stroke-width:20px}</style></defs><title>pacifier</title><path d="M200.06 391.63a71.49 71.49 0 1 1-91.69-91.69 347.93 347.93 0 0 1-27.79-42.84A121.85 121.85 0 1 0 242.9 419.42a347.93 347.93 0 0 1-42.84-27.79z" fill="#faae3b"/><path d="M200.06 391.63c-.17.47-.41.92-.59 1.38.46.26.93.55 1.39.8A121.31 121.31 0 0 1 50 456a121.47 121.47 0 0 0 192.86-36.6 347.93 347.93 0 0 1-42.8-27.77z" fill="#f7991f"/><path d="M182.85 317.15C108.65 242.94 72 159.29 101 130.3l-31.8 31.78c-29 29 7.67 112.64 81.88 186.84s157.86 110.86 186.84 81.88L369.7 399c-28.99 29-112.64-7.65-186.85-81.85z" fill="#7f2424"/><path d="M322.86 251.3a71.18 71.18 0 0 0-7.64 12.42c-23.44 48-45.91 67.22-96 17.1s-30.87-72.6 17.1-96a71.18 71.18 0 0 0 12.42-7.64c-62.5-49.91-123.81-70.83-147.74-46.88-29 29 7.67 112.64 81.87 186.85S340.71 428 369.7 399c23.95-23.93 3.03-85.24-46.84-147.7z" fill="#d73939"/><path d="M322.86 251.3a71.18 71.18 0 0 0-7.64 12.42c-5.78 11.83-11.51 21.91-17.6 29.64 27.69 46.37 36 87.16 17.53 105.66a29.55 29.55 0 0 1-5.24 4.05c26.26 8.56 47.76 8 59.79-4.05 23.95-23.95 3.03-85.26-46.84-147.72zM214.23 197a209.6 209.6 0 0 1 22.05-12.21 71.18 71.18 0 0 0 12.42-7.64c-58.33-46.58-115.64-67.88-142.48-51 26.06 8.51 56.85 26.15 87.93 51 4.02 3.02 11.25 10.31 20.08 19.85z" fill="#be3434"/><path d="M219.18 280.82c50.13 50.12 72.6 30.87 96-17.1 27.76-56.81 77.69-10 139.61-72 76.51-76.51 0-146.59 0-146.59s-70.08-76.51-146.59 0c-61.92 61.92-15.15 111.85-72 139.61-47.89 23.48-67.14 45.95-17.02 96.08z" fill="#fcf1d1"/><path d="M454.83 45.17S410.2-3.45 353.31 15.71c28.41 9.25 47 29.46 47 29.46s76.5 70.08 0 146.59c-61.92 61.92-111.85 15.15-139.61 72-7.05 14.44-14 26.24-21.68 34.37 36.72 26.74 56.12 6.76 76.22-34.37 27.76-56.81 77.69-10 139.61-72 76.49-76.51-.02-146.59-.02-146.59z" fill="#f4ddaa"/><path class="cls-8" d="M182.85 317.15C108.65 242.94 72 159.29 101 130.3l-31.8 31.78c-29 29 7.67 112.64 81.88 186.84s157.86 110.86 186.84 81.88L369.7 399c-28.99 29-112.64-7.65-186.85-81.85z"/><path class="cls-8" d="M219.18 280.82c50.13 50.12 72.6 30.87 96-17.1 27.76-56.81 77.69-10 139.61-72 76.51-76.51 0-146.59 0-146.59s-70.08-76.51-146.59 0c-61.92 61.92-15.15 111.85-72 139.61-47.89 23.48-67.14 45.95-17.02 96.08z"/><path class="cls-8" d="M322.86 251.3a71.18 71.18 0 0 0-7.64 12.42c-23.44 48-45.91 67.22-96 17.1s-30.87-72.6 17.1-96a71.18 71.18 0 0 0 12.42-7.64c-62.5-49.91-123.81-70.83-147.74-46.88-29 29 7.67 112.64 81.87 186.85S340.71 428 369.7 399c23.95-23.93 3.03-85.24-46.84-147.7zm-122.8 140.33a71.49 71.49 0 1 1-91.69-91.69 347.93 347.93 0 0 1-27.79-42.84A121.85 121.85 0 1 0 242.9 419.42a347.93 347.93 0 0 1-42.84-27.79z"/></svg>';
    var dummyLinkTooltip =
      '<div class="hidden"><div id="dummy-link-tooltip">' +
      pacifierIcon +
      ' This is a dummy link.</div></div>';
    $('body').append(dummyLinkTooltip);

    tippy('a[href="#"]:not(.btn):not("#CartDrawer a")', {
      content: document.getElementById('dummy-link-tooltip'),
      size: 'small',
      animation: 'shift-toward',
      placement: 'right',
      trigger: 'mouseenter focus',
    });

    tippy('a[href="#"].btn', {
      content: document.getElementById('dummy-link-tooltip'),
      size: 'small',
      animation: 'shift-toward',
      placement: 'right',
      trigger: 'click',
    });
  }

  // Pretty variable dump outputs
  var elems = document.getElementsByClassName('vardump');
  for (var i = 0; i < elems.length; i++) {
    var json = JSON.stringify(JSON.parse(elems[i].dataset.json), undefined, 2);
    elems[i].innerHTML = theme.utils.syntaxHighlight(json);
  }

  tippy('.vardump', {
    content: 'Click items to copy',
    trigger: 'mouseenter',
    theme: 'light',
    placement: 'bottom-end',
    offset: '-20, -50',
    distance: 0,
    animation: 'fade',
  });

  $('.vardump span:not(.group):not(.group-handle)').on('click', function () {
    var $this = $(this);
    var $elem = $(
      '<input value="' +
        $this.text().replace(/^"/, '').replace(/"$/, '') +
        '" />'
    ).appendTo('body');
    $elem.select();
    document.execCommand('copy');
    $elem.remove();

    tippy(this, {
      content: 'Copied to clipboard!',
      trigger: 'manual',
      theme: 'light',
      showOnInit: true,
      onShown: function (tip) {
        window.setTimeout(function () {
          tip.hide();
        }, 2000);
      },
      onHidden: function (tip) {
        tip.destroy();
      },
    });
  });

  $('.vardump span.group-handle').on('click', function () {
    $(this).parent('.group').toggleClass('closed');
  });
})();

/*============================================================================
  Scroll to utility
==============================================================================*/
window.theme = window.theme || {};

theme.scrollTo = (function () {
  var options = {
    scrollTo: {
      duration: 700,
      interrupt: !isMobile.apple.device, // Don't allow interupt on iOS
      offset: -120,
    },
  };

  function init() {
    $('a[href^="#"]').click(function (e) {
      e.preventDefault();
      target(this.hash);
    });

    if (document.location.search && theme.utils.getQueryParams().scrollto) {
      $(window)
        .stop(true)
        .scrollTo(
          '#' + theme.utils.getQueryParams().scrollto,
          options.scrollTo
        );
      history.replaceState(
        null,
        '',
        theme.utils.updateQueryStringParameter('scrollto', null)
      );
    }
  }

  function target(hash) {
    $(window).stop(true).scrollTo(hash, options.scrollTo);
  }

  init();

  return {
    target: target,
  };
})();
/*============================================================================
  Quantity Selectors
==============================================================================*/
window.theme = window.theme || {};

theme.ProductGridItem = (function () {
  var defaults = {
    animateIn: true,
    animateDelay: 75,
    animateDuration: 300,
    reflectCart: isMobile.any,
  };

  var selectors = {
    wishlistButton: '.add-to-wishlist',
    productJSON: '[data-product-grid-item-json]',
    quantitySelector: '.product-grid-item__quantity-selector',
  };

  var template = theme.utils.getTemplate('product-grid-item');

  function ProductGridItem(container, product, gridIndex, options) {
    var replaceTemplace = product ? true : false;

    this.container = container;
    this.gridIndex = gridIndex;
    this.options = _.defaults(options, defaults);

    var productdata = container.querySelector(selectors.productJSON);
    this.product = product || JSON.parse(productdata.innerHTML);

    this.selectedVariant =
      this.product.variants && this.product.variants.length
        ? this.product.variants[0]
        : null;
    if (this.selectedVariant) {
      this.SelectedVariantCache = new theme.SelectedVariantCache(
        this.selectedVariant.id
      );
    }

    if (replaceTemplace) {
      this.container.innerHTML = template;
    }

    tinybind.bind(this.container, {
      product: this.product,
      variant: this.selectedVariant,
      selected: this.SelectedVariantCache,
      options: this.options,
      settings: theme.settings,
      methods: {
        addToCart: this.addToCart.bind(this),
        toggleActive: this.toggleActive.bind(this)
      },
    });

    this.container.style.height = '100%';
    
    this.initQuantitySelectors();
    this.animateIn();

    this._bindWishlist();

    return this;
  }

  ProductGridItem.prototype = $.extend({}, ProductGridItem.prototype, {
    initQuantitySelectors: function () {
      var self = this;

      var quantitySelectorEl = this.container.querySelector(
        selectors.quantitySelector
      );

      if (!quantitySelectorEl) {
        return;
      }

      var quantitySelectorOptions = {
        formatAsSize: true,
        variantTitle: this.selectedVariant.option1,
        reflectCart: this.options.reflectCart,
      };

      this.quantitySelector = new theme.QuantitySelector(
        quantitySelectorEl,
        quantitySelectorOptions
      );

      if (this.options.reflectCart) {
        $(this.quantitySelector.inputEl).on('addQuantity', function (
          event,
          value
        ) {
          self.addToCart(value);
        });

        $(this.quantitySelector.inputEl).on('subtractQuantity', function (
          event,
          value
        ) {
          self.updateCart(value);
        });
      }

      this.SelectedVariantCache.addQuantitySelector(this.quantitySelector);
    },
    toggleActive: function(){
      var self = this;
      // self.container.classList.toggle('active');
    },
    animateIn: function () {
      if (!this.options.animateIn) {
        return;
      }

      var loadedProducts = theme.current.collection.loadedProducts || 0,
        delay = (this.gridIndex - loadedProducts) * this.options.animateDelay,
        duration = this.options.animateDuration;

      if ('anime' in window) {
        anime({
          targets: [this.container],
          translateY: [15, 0],
          opacity: [0, 1],
          duration: duration,
          easing: 'easeInOutCubic',
          delay: delay,
        });
      }
    },

    addToCart: function (quantity) {
      var self = this;

      if (typeof quantity != 'number') {
        quantity = this.SelectedVariantCache.quantity;
      }

      this.container.classList.add('loading');
      this.quantitySelector.toggleLoadState(true);

      document.body.classList.add('cart-loading--opens-drawer');

      CartJS.addItem(
        this.selectedVariant.id,
        quantity,
        {},
        {
          success: function (data, textStatus, jqXHR) {
            self.quantitySelector.toggleLoadState(false);
            self.container.classList.remove('loading');
            // theme.MiniCart.show(data);
          },
          error: function (jqXHR, textStatus, errorThrown) {
            self.quantitySelector.toggleLoadState(false);
            // theme.utils.showError(errorThrown);
            self.container.classList.remove('loading');
          },
        }
      );
    },

    updateCart: function (quantity) {
      var self = this;

      this.quantitySelector.toggleLoadState(true);

      var newQuantity = this.SelectedVariantCache.cartQuantity - quantity;

      CartJS.updateItemById(
        this.selectedVariant.id,
        newQuantity,
        {},
        {
          success: function (data, textStatus, jqXHR) {
            self.quantitySelector.toggleLoadState(false);
            // theme.MiniCart.show(data);
          },
          error: function (jqXHR, textStatus, errorThrown) {
            self.quantitySelector.toggleLoadState(false);
            // theme.utils.showError(errorThrown);
          },
        }
      );
    },

    _bindWishlist: function () {
      var wishlistButton = this.container.querySelector(
        selectors.wishlistButton
      );
      if (wishlistButton) {
        theme.wishlist.addButton(wishlistButton);
      }
    },
  });

  return ProductGridItem;
})();

window.theme = window.theme || {};

theme.current.selected = theme.current.selected || [];

theme.SelectedVariantCache = (function () {
  var defaults = {
    quantity: 1,
  };

  function SelectedVariantCache(variantId) {
    if (!variantId) {
      return false;
    }

    this.id = variantId;

    // Check for existing cache
    var existingCaches = theme.current.selected;

    for (var i = 0; i < existingCaches.length; i++) {
      if (existingCaches[i].id == this.id) {
        return existingCaches[i];
      }
    }

    this.quantity = defaults.quantity;

    this.cartQuantity = this._getCartQuantity();

    this.quantitySelectors = [];

    this._restore();
    theme.current.selected.push(this);

    return this;
  }

  SelectedVariantCache.prototype = _.extend(
    {},
    SelectedVariantCache.prototype,
    {
      _getCartQuantity: function () {
        var count = 0;

        for (var i = 0; i < CartJS.cart.items.length; i++) {
          var lineItem = CartJS.cart.items[i];
          if (lineItem.id == this.id) {
            count += lineItem.quantity;
          }
        }

        return count;
      },

      refreshCartQuantity: function () {
        this.cartQuantity = this._getCartQuantity();
        this._updateQuantitySelectors();

        return this.cartQuantity;
      },

      add: function () {
        this.quantity += 1;
        this._save();
        this._updateQuantitySelectors();
      },

      subtract: function () {
        this.quantity -= 1;
        this._save();
        this._updateQuantitySelectors();
      },

      set: function (value) {
        if (this.quantity == value) {
          return;
        }

        this.quantity = value;
        this._save();
        this._updateQuantitySelectors();
      },

      addQuantitySelector: function (quantitySelector) {
        var self = this;

        $(quantitySelector.inputEl).on('valueUpdated', function (event, value) {
          self.set(value);
        });

        this.quantitySelectors.push(quantitySelector);
        this._updateQuantitySelectors();
      },

      _updateQuantitySelectors: function () {
        var self = this;
        for (var i = 0; i < this.quantitySelectors.length; i++) {
          this.quantitySelectors[i].update(this.quantity, this.cartQuantity);
        }
      },

      _save: function () {
        var dataJSON, data, variantIndex, variantData;

        dataJSON = sessionStorage.getItem('selected-variant-cache');
        data = dataJSON ? JSON.parse(dataJSON) : [];

        variantIndex = _.findIndex(data, { id: this.id });

        variantData = {
          id: this.id,
          quantity: this.quantity,
        };

        if (variantIndex > -1) {
          data[variantIndex] = variantData;
        } else {
          data.push(variantData);
        }

        sessionStorage.setItem('selected-variant-cache', JSON.stringify(data));
      },

      _restore: function () {
        var dataJSON, data, variantIndex, variantData;

        dataJSON = sessionStorage.getItem('selected-variant-cache');
        data = dataJSON ? JSON.parse(dataJSON) : [];

        variantData = _.find(data, { id: this.id });

        if (variantData) {
          this.set(variantData.quantity);
        }
      },
    }
  );

  return SelectedVariantCache;
})();

/*============================================================================
  Wishlist
  For Wishlist King App
==============================================================================*/
window.theme = window.theme || {};

theme.wishlist = (function () {
  var selectors = {
    addToWishlist: '.add-to-wishlist',
  };

  var cache = {
    buttons: [],
  };

  // Keep a reference to "add to wishlist" buttons
  function _cacheButtons() {
    var buttons = document.querySelectorAll(selectors.addToWishlist);
    var i = buttons.length;

    while (i--) {
      cache.buttons.push(buttons[i]);
    }
  }

  // Set button initial state
  function _setInitialState(el) {
    var productId, product;

    productId = el.dataset.productId;
    product = Appmate.wk.getProduct(productId);

    if (product) {
      el.dataset.inWishlist = true;
    }
  }

  // Bind event
  function _bind(el) {
    el.addEventListener('click', _toggleProduct);
  }

  // Unbind event
  function _unbind(el) {
    el.removeEventListener('click', _toggleProduct);
  }

  // Add or remove product from wishlist
  function _toggleProduct() {
    var el, productId, oldState, newState;

    el = event.currentTarget;
    productId = el.dataset.productId;

    oldState = el.dataset.inWishlist == 'true' ? true : false;
    newState = !oldState;

    el.classList.add('loading');

    NProgress.start();

    if (!productId) {
      console.error(new Error('No product id'));
      return;
    }

    Appmate.wk
      .toggleProduct(productId)
      .then(function (data) {
        // Update all elements with same product-id
        _.forEach(cache.buttons, function (elem, i) {
          if (elem.dataset.productId == productId) {
            elem.dataset.inWishlist = newState;
          }
        });

        el.classList.remove('loading');

        NProgress.done();
      })
      .catch(function (err) {
        el.dataset.inWishlist = oldState;
        console.error(err);

        el.classList.remove('loading');
        NProgress.done();
      });
  }

  // Initialise and prepare buttons
  function init() {
    cache.isInit = true;
    _prepare();
    _bindViews();
  }

  function _bindViews() {
    tinybind.bind($('[data-wishlist-view]'), {
      data: {
        wishlists: Appmate.wk.collection.items,
      },
    });
  }

  // set initial state and bind
  function _prepare() {
    _cacheButtons();

    _.forEach(cache.buttons, function (el, i) {
      _bind(el);
      _setInitialState(el);
    });
  }

  // Clear events and reinitialise
  function update() {
    if (!cache.isInit) {
      return;
    }

    _.forEach(cache.buttons, function (el, i) {
      _unbind(el);
    });

    _prepare();
  }

  function addButton(el) {
    cache.buttons.push(el);

    if (cache.isInit) {
      _bind(el);
      _setInitialState(el);
    }
  }

  // Load wishlist JS
  loadJS('https://az814789.vo.msecnd.net/toolkit/1.4.21/appmate.js');

  return {
    init: init,
    update: update,
    addButton: addButton,
  };
})();

/*================ Modules ================*/
window.theme = window.theme || {};

theme.AjaxCart = (function () {
  var selectors = {
    addToCartBtn: '[type="submit"]',
    addToCartForm: 'form[action="/cart/add"]',
    cartCount: '.site-header__cart',
    cartToggle: '.cart__toggle',
    cartDrawer: '.cart-drawer',
    cartDrawerOpen: '.cart-drawer--open',
    cartDrawerTabs: '.cart-drawer__tabs',
  };

  var settings = {
    // 'aboveForm' for top of add to cart form,
    // 'belowForm' for below the add to cart form,
    // 'nextButton' for next to add to cart button and
    // 'afterBody' for after the main body content (used for fixed notifications).
    feedbackPosition: 'afterBody',
  };

  var options = {
    requestBodyClass: 'cart-loading',
    moneyFormat: window.shop.moneyFormat,
    moneyWithCurrencyFormat: window.shop.moneyWithCurrencyFormat,
    weightUnit: 'kg', // g, kg, oz, lb
    weightPrecision: 0,
    tinybindModels: {
      customer: window.shop.customer,
      cartGifts: window.shop.cartGifts,
    },
    errorHandling: {
      cartError: function () {
        $('.cart-loader.loading').removeClass('loading');
        if (this.description) {
          showFeedback('error', this.description);
        }
      },
    },
  };

  var cache = {
    previousCartItems: [],
    updatedItems: [],
  };

  function init() {
    if (!$(selectors.cartDrawer).length) {
      return;
    }

    var $tabsGroup = $(selectors.cartDrawerTabs);
    $.each($tabsGroup, function (index, tabsGroup) {
      window.theme.tabsGroups[tabsGroup] = new theme.TabsGroup(tabsGroup, {
        breakpoint: 0,
      });
    });

    $(document).on(
      'click',
      '[data-add-to-cart], [data-cart-add], [data-cart-update], [data-cart-update-id], [data-cart-remove]',
      function (evt) {
        var $this = $(this);
        var progressElementSelector = $this.data('progress-element');
        var $progressElement = progressElementSelector
          ? $(progressElementSelector)
          : $this;

        if (!$this.is('.disabled')) {
          if ($progressElement.length) {
            $progressElement.addClass('cart-loader loading');
          }

          if ($this.is('[data-opens-cart-drawer]')) {
            $('body').addClass('cart-loading--opens-drawer');
          }
        } else {
          evt.preventDefault();
          evt.stopPropagation();

          $progressElement.addClass('error');
          window.setTimeout(function () {
            $progressElement.removeClass('error');
          }, 1500);

          var highlightElements = $this.data('enable-requirements');
          if (highlightElements) {
            theme.utils.flash(highlightElements);
          }
        }
      }
    );

    initDrawer();

    $(selectors.cartDrawerOpen).on('click', function (e) {
      e.preventDefault();
      e.stopPropagation();
      openCartDrawer();
    });

    cache.closeTooltip = tippy('.cart-drawer', {
      target: '.cart-drawer-item__remove--button, .cart-drawer__close',
      theme: 'light',
      placement: 'left',
      animation: 'shift-away',
      arrow: true,
      offset: 0,
      distance: 5,
      trigger: 'mouseenter',
      lazy: false,
      onShow: function (instance) {
        if (isMobile.any) {
          return false;
        }
      },
    });

    CartJS.init(window.shop.cart, options);

    $('#cart-drawer-note, #cart-note').on('blur', function () {
      var note = $(this).val();
      if (note) {
        CartJS.setNote(note);
      } else {
        CartJS.setNote('');
      }
    });

    $('.cart-drawer__submit').click(function () {
      $(document.body).addClass('checkout-activated');
    });

    $(document).on('cart.requestStarted', function (event, cart) {
      cache.previousCartItems = _.values(
        _.omit(cart.items, _.functions(cart.items))
      );

      if ('NProgress' in window) {
        NProgress.start();
      }
    });

    $(document).on('cart.requestComplete', function (event, cart) {
      if ('NProgress' in window) {
        NProgress.done();
      }

      $('.cart-loader.loading').removeClass('loading');

      // cache.updatedItems = theme.utils.difference(_.values(_.omit(cart.items, _.functions(cart.items))), cache.previousCartItems);
      // _.remove(cache.updatedItems, _.isEmpty);

      cache.updatedItems = cart.updatedLineItems;

      if (!cache.updatedItems.length && cart.items.length > 0) {
        // showFeedback('error', theme.strings.quantityUnavailable);
      }

      shop.cart = cart;

      if (theme.Favicon !== undefined) {
        if (cart.item_count > 0) {
          theme.Favicon.set(cart.item_count);
        } else {
          theme.Favicon.reset();
        }
      }

      var opensDrawer = $('body').is('.cart-loading--opens-drawer');

      if (opensDrawer !== undefined && opensDrawer) {
        if (
          (theme.cartQueue === undefined || theme.cartQueue.length == 0) &&
          theme.cartQueueProcessing == false
        ) {
          if (!theme.CartDrawer.drawerIsOpen) {
            $('body').removeClass('cart-loading--opens-drawer');

            // openCartDrawer();

            _.each(cache.updatedItems, function (updatedItem) {
              var lineItem, previousItem;
              lineItem = _.find(cart.items, { id: updatedItem.id });

              if (lineItem) {
                previousItem = _.find(cache.previousCartItems, {
                  id: lineItem.id,
                });
              }

              if (!previousItem || lineItem.quantity > previousItem.quantity) {
                showMiniCart(lineItem);
              }
            });
          }
        }
      }

      if (theme.CartDrawer.drawerIsOpen && cart.item_count < 1) {
        window.setTimeout(function () {
          theme.CartDrawer.close();
        }, 2500);
      }

      // Update selector caches
      for (var i = 0; i < theme.current.selected.length; i++) {
        theme.current.selected[i].refreshCartQuantity();
      }

      matchTargetQuantity(cart);

      var giftWrappingIgnore = theme.current.gift_wrapping ? theme.current.gift_wrapping.ignore : [];

      (function removeGiftWrap(cart, ignore) {
        if (!cart.items) return;

        const has_ignored_options = cart.items
          .reduce(
            (a, v) =>
              a.push(
                ...v.options_with_values.map((v) =>
                  Object.fromEntries(
                    Object.entries(v).map(([name, value]) => [
                      name,
                      value.toLowerCase(),
                    ])
                  )
                )
              ) && a,
            []
          )
          .some((v) =>
            ignore.some((t) => v.name == t.name && v.value.includes(t.value))
          );

        has_ignored_options &&
          CartJS.cart.items.map(
            (v) =>
              v.variant_id == theme.current.gift_wrapping.variant_id &&
              CartJS.removeItem(v.line_number)
          );
      })(cart, giftWrappingIgnore);
    });

    matchTargetQuantity(CartJS.cart);
  }

  // Update items to match target quantity
  function matchTargetQuantity(cart) {
    _.each(cart.items, function (lineItem, index) {
      if (
        lineItem.properties &&
        lineItem.properties._target_quantity &&
        lineItem.quantity != lineItem.properties._target_quantity
      ) {
        console.info(
          'Setting line quantity to ' + lineItem.properties._target_quantity
        );
        CartJS.updateItem(
          lineItem.line_number,
          lineItem.properties._target_quantity
        );
      }
    });
  }

  function showMiniCart(lineItem) {
    theme.MiniCart.show(lineItem);
  }

  function initDrawer() {
    $('#MainContent').addClass('drawer-page-content');
    $('.js-drawer-open-top')
      .attr('aria-controls', 'CartDrawer')
      .attr('aria-expanded', 'false');

    theme.CartDrawer = new theme.Drawers('CartDrawer', 'right', {
      onDrawerOpen: cartDrawerOpen,
      onDrawerClose: cartDrawerClose,
      beforeDrawerOpen: function (drawer) {
        theme.MiniCart.close({
          direction: 'left',
        });
      },
    });
  }

  function cartDrawerOpen() {
    // $(selectors.cartToggle).addClass(settings.cartDrawerOpen);
    if (cache.closeTooltip) {
      for (var i = cache.closeTooltip.length - 1; i >= 0; i--) {
        cache.closeTooltip[i].enable();
      }
    }
  }

  function cartDrawerClose() {
    // $(selectors.cartToggle).removeClass(settings.cartDrawerOpen);
    if (cache.closeTooltip) {
      for (var i = cache.closeTooltip.length - 1; i >= 0; i--) {
        cache.closeTooltip[i].hide();
        cache.closeTooltip[i].disable();
      }
    }
  }

  function openCartDrawer() {
    console.log("openCartDrawer")
    if (isMobile.any) {
      console.info('Navigating to cart page');
      window.location.href = '/cart';
    } else {
      theme.CartDrawer.open();
    }
  }

  function showFeedback(status, response, $addToCartForm) {
    $('.ajax-cart-feedback').remove();
    var feedback =
      '<div class="ajax-cart-feedback ' + status + '">' + response + '</div>';

    if ($addToCartForm !== undefined && $addToCartForm.length > 0) {
      switch (settings.feedbackPosition) {
        case 'aboveForm':
          $addToCartForm.before(feedback);
          break;
        case 'belowForm':
          $addToCartForm.after(feedback);
          break;
        case 'afterBody':
          $(document.body).append(feedback);
          break;
        case 'nextButton':
        default:
          $addToCartForm.find(selectors.addToCartBtn).after(feedback);
          break;
      }
    } else {
      theme.utils.showError(response);
    }

    var $feedbackElement = $('.ajax-cart-feedback');

    $feedbackElement.offset(); // redraw
    $feedbackElement.addClass('active');
    window.setTimeout(function () {
      $feedbackElement.removeClass('active');
    }, 6500);
  }

  return {
    init: init,
    openCartDrawer: openCartDrawer,
  };
})();

theme.AjaxCart.init();

theme.cartQueue = [];
theme.cartQueueProcessing = false;
theme.processCartQueue = function () {
  // If there's something in the queue, process it
  if (theme.cartQueue.length) {
    theme.cartQueueProcessing = true;
    var request = theme.cartQueue.shift();
    var requestType = request.type || 'add';

    if (requestType == 'add') {
      CartJS.addItem(request.variant_id, request.quantity, request.properties, {
        success: function (data, textStatus, jqXHR) {
          theme.processCartQueue();
        },
      });
    } else if (requestType == 'update') {
      CartJS.updateItem(
        line_number,
        quantity,
        (properties = {}),
        (options = {})
      );
    } else {
      // CartJS.removeItem(line_number, options = {})
    }

    ShopifyAPI.addItem(
      request.variant_id,
      request.quantity,
      request.properties,
      ShopifyAPI.processQueue,
      requestType
    );
  } else {
    theme.cartQueueProcessing = false;
  }
};

window.theme = window.theme || {};

theme.MiniCart = (function () {
  var selectors = {};

  var settings = {};

  var options = {};

  var cache = {
    toasts: [],
  };

  function MiniCart() {}

  MiniCart.prototype = _.extend({}, MiniCart.prototype, {
    show: function (lineItem) {
      // this.close();

      iziToast.success({
        animateInside: false,
        backgroundColor: 'var(--color-body)',
        close: false,
        displayMode: 2,
        id: null,
        message: theme.strings.itemAddedToCart,
        position: 'topRight',
        progressBarColor: 'var(--color-primary)',
        theme: 'mini-cart',
        timeout: 5000,
        title: lineItem.product_title,
        transitionIn: 'fadeInLeft',
        buttons: [
          [
            '<button class="btn btn--secondary">My bag <span rv-html="cart.total_price | money | prepend \' - \'"></span></button>',
            function (instance, toast) {
              // window.location.href = '/cart';
              theme.CartDrawer.open();
            },
            false,
          ],
        ],
        onOpening: function (instance, toast) {
          tinybind.bind(toast, {
            cart: CartJS.cart,
          });

          var toastIcon = toast.querySelector('.iziToast-icon');
          if (toastIcon && theme.icons.success) {
            toastIcon.innerHTML = theme.icons.success;
          }
        },
      });
    },

    close: function (options) {
      var toasts = document.querySelectorAll('.iziToast-theme-mini-cart');
      var transitionOut = 'fadeOutLeft';

      if (options && options.direction == 'right') {
        transitionOut = 'fadeOutRight';
      }

      var i = toasts.length;

      while (i--) {
        iziToast.hide(
          {
            transitionOut: transitionOut,
          },
          toasts[i]
        );
      }
    },
  });

  return new MiniCart();
})();

window.theme = window.theme || {};

theme.Header = (function () {
  var selectors = {
    body: 'body',
    navigation: '#SiteNav',
    childDropdown: '.site-nav__dropdown',
    childlistGrid: '.site-nav__childlist-grid',
    featureData: 'script#header-data',
    accountDropdown: '.site-header__account-link--dropdown',
    headerUpper: '.site-header__main',
    headerLower: '.site-header-lower',
    dropdown: '.dropdown',
  };

  function Dropdown(handle, el, gridEl) {
    this.handle = handle;
    this.el = el;
    this.gridEl = gridEl;
  }

  function Header(el) {
    this.el = el;
    this.$el = $(el);
    this.$siteNav = this.$el.find(selectors.navigation);
    this.headerLower = document.querySelector(selectors.headerLower);

    this.headerLowerHiddenByDefault =
      this.headerLower && this.headerLower.classList.contains('retract')
        ? true
        : false;

    this.data = {
      hideLowerHeader: this.headerLowerHiddenByDefault,
      activeMenuItem: null,
    };

    theme.MegaMenuDropdowns = [];

    if (window.pageYOffset > 0) {
      $('.template-index').addClass('sticky-header-active');
    }
    // stop noticebar targeting dropdown position


    
    // var self = this;

    tinybind.bind(el, {
      data: this.data,
      methods: {
        setActiveMenuItemMouseover: this._handleSetActiveMenuItemMouseover.bind(
          this
        ),
        setActiveMenuItemClick: this._handleSetActiveMenuItemClick.bind(this),
        clearActiveMenuItem: this._handleClearActiveMenuItem.bind(this),
      },
    });

    var self = this;

    // this._buildDropdowns();

    if (this.headerLower) {
      this._bindShowHideLowerHeader();
    }

    // new theme.ResponsiveNavList(this.$siteNav, {
    //   overflowItemHtml: '<a href="#" class="site-nav__link site-nav__link--main"><span class="">More</span></a>'
    // });
  }

  Header.prototype = $.extend({}, Header.prototype, {
    _prepareDropdown: function (handle) {
      var dropdown, el, gridEl;

      for (var i = theme.MegaMenuDropdowns.length - 1; i >= 0; i--) {
        if (theme.MegaMenuDropdowns[i].handle == handle) {
          dropdown = theme.MegaMenuDropdowns[i];
          break;
        }
      }

      if (!dropdown) {
        el = this.el.querySelector(
          '.site-nav__dropdown[data-link-handle="' + handle + '"]'
        );
        gridEl = el.querySelector('.site-nav__childlist-grid');
        dropdown = new Dropdown(handle, el, gridEl);
        theme.MegaMenuDropdowns.push(dropdown);
      }

      // if (gridEl && !dropdown.magicGrid) {

      //   dropdown.magicGrid = new MagicGrid({
      //     container: dropdown.gridEl,
      //     static: true,
      //     animate: false,
      //     gutter: 0,
      //     useTransform: true,
      //   });

      //   var accordionTitles = dropdown.gridEl.querySelectorAll('.simple-accordion__title');

      //   if (isMobile.any) {
      //     $(accordionTitles).off('click.accordion');
      //   }

      //   $(accordionTitles).on('accordionTransitionHeightCalc', function() {
      //     dropdown.el.classList.add('accordion-transitioning');
      //     dropdown.magicGrid.positionItems();
      //   });

      //   $(accordionTitles).on('accordionTransitionEnd', function() {
      //     dropdown.el.classList.remove('accordion-transitioning');
      //   });

      // }

      var offset, maxWidth, cols, offsetWidth;

      dropdown.el.style.position = '';

      dropdown.el.style.display = 'block';
      dropdown.el.offsetHeight;

      var gridGutter = 36;

      // if (dropdown.magicGrid) {
      // MagicGrid and sticky full-width dropdowns don't play nice
      // Commenting while we work on adding an option to switch between full/dynamic widths

      // cols = parseInt(dropdown.gridEl.dataset.listLength);
      // offset = theme.utils.getOffset(dropdown.gridEl);
      // maxWidth = window.innerWidth - (gridGutter * 2);
      // dropdown.gridEl.style.maxWidth = '';
      // dropdown.gridEl.classList.remove('at-window-width');
      // offsetWidth = dropdown.gridEl.offsetWidth;

      // if (offsetWidth + offset.left >= (window.innerWidth - gridGutter)) {
      //   dropdown.el.style.position = 'fixed';
      //   dropdown.gridEl.classList.add('at-window-width');
      //   dropdown.el.style.left = Math.max(((window.innerWidth - gridGutter) - offsetWidth) / 2, gridGutter / 2) + 'px';
      // }

      // if (cols < 6) {
      //   // dropdown.el.style.position = 'absolute';
      //   offset = theme.utils.getOffset(dropdown.gridEl);
      //   maxWidth = window.innerWidth - offset.left - gridGutter;
      //   dropdown.gridEl.style.maxWidth = maxWidth;
      // }

      // dropdown.magicGrid.positionItems();
      // }
    },

    _bindShowHideLowerHeader: function () {
      var previousScrollPosition, currentScrollPosition, scrollingUp;

      var self = this;

      $(selectors.headerUpper, this.$el).on('mouseenter', function () {
        self.hideLowerHeader(false);
      });

      function checkScrollDirection() {
        currentScrollPosition = this.scrollY;

        scrollingUp = previousScrollPosition > currentScrollPosition;

        if (currentScrollPosition < 40) {
          document.body.classList.add('scroll-top');
        } else {
          document.body.classList.remove('scroll-top');
        }

        if (currentScrollPosition < 200) {
          self.hideLowerHeader(self.headerLowerHiddenByDefault);
        } else if (scrollingUp) {
          self.hideLowerHeader(false);
        } else {
          self.hideLowerHeader(true);
          self.data.activeMenuItem = '';
        }

        previousScrollPosition = currentScrollPosition;
      }

      self.hideLowerHeader(self.headerLowerHiddenByDefault);

      window.onscroll = _.throttle(checkScrollDirection, 250);
    },

    hideLowerHeader: function (hide) {
      if (
        (theme.current.search && theme.current.search.popupOpen) ||
        $('html').get(0).classList.contains('js-drawer-open')
      ) {
        return;
      }

      if (hide) {
        document.body.classList.remove('show-header-lower');
      } else {
        document.body.classList.add('show-header-lower');
      }
      this.data.hideLowerHeader = hide;
    },

    _handleSetActiveMenuItemMouseover: function () {
      var target = event.currentTarget.dataset.linkHandle;

      if (isMobile.any) {
        return;
      }

      if (this.data.activeMenuItem == target) {
        return;
      }

      if (event.currentTarget.classList.contains('in-dropdown-menu')) {
        return;
      }

      event.preventDefault();

      this.setActiveMenuItem(target);
    },

    _handleSetActiveMenuItemClick: function () {
      var target = event.currentTarget.dataset.linkHandle;

      if (
        !event.currentTarget.classList.contains('in-dropdown-menu') &&
        !isMobile.any
      ) {
        return;
      }

      if (this.data.activeMenuItem == target) {
        return;
      }

      event.preventDefault();

      this.setActiveMenuItem(target);
    },

    _handleClearActiveMenuItem: function () {
      this.setActiveMenuItem();
      // console.error('temp disabled');
    },

    setActiveMenuItem: function (target) {
      var self = this;

      // var targetEl = this.el.querySelector('site-nav__dropdown[data-link-handle=' + target + ']');

      if (target) {
        this._prepareDropdown(target);
        self.data.activeMenuItem = target;
        theme.Drawers.prototype.closeAllDrawers();

        if (theme.CartDrawer.drawerIsOpen) {
          theme.CartDrawer.close();
        }
      } else {
        self.data.activeMenuItem = null;
      }
    },
  });

  return Header;
})();

theme.MobileNavDrawer = (function () {
  var selectors = {
    mobileNavDrawer: '.mobile-nav-drawer',
    accountMobileNavButton: '.js-drawer-open-account',
    mobileNavInner: '.mobile-nav__inner',
    drawerOpenTrigger: '.mobile-nav--open',
  };

  function List(handle, depth, listEl) {
    this.handle = handle;
    this.depth = parseInt(depth);
    this.listEl = listEl;

    listEl.style.display = 'block';
    this.height = height = listEl.offsetHeight + 50 + 'px';
    listEl.style.display = '';
  }

  function MobileNavDrawer() {
    this.el = document.querySelector(selectors.mobileNavDrawer);
    this.inner = document.querySelector(selectors.mobileNavInner);

    this.drawerId = 'MobileNavDrawer';

    if (!this.el) {
      return;
    }

    this.data = {
      depth: 0,
      activeLists: [],
      active: null,
      previous: null,
    };

    this.lists = [];

    this.methods = {
      goToList: this._handleGoToList.bind(this),
    };

    this._createDrawer();
    this._bindView();
  }

  MobileNavDrawer.prototype = _.extend(MobileNavDrawer.prototype, {
    _cacheList: function (handle) {
      var listEl, depth, height, list;

      listEl = this.el.querySelector('[data-list-handle="' + handle + '"]');

      if (!listEl) {
        console.error('Not found');
        return;
      }

      depth = listEl.dataset.depth;
      list = new List(handle, depth, listEl);
      this.lists.push(list);

      return list;
    },

    _getTarget: function () {
      return event.currentTarget.dataset.target;
    },

    _handleGoToList: function () {
      var target = this._getTarget();
      this.transitionTo(target);
    },

    transitionTo: function (handle) {
      var targetList,
        self = this;

      for (var i = this.lists.length - 1; i >= 0; i--) {
        if (this.lists[i].handle == handle) {
          targetList = this.lists[i];
          break;
        }
      }

      if (!targetList) {
        targetList = this._cacheList(handle);
      }

      if (targetList) {
        event.preventDefault();

        // if (this.data.active) {
        //   this.data.active.listEl.style.top = this.el.scrollTop * -1 + 'px';
        // }
        //
        // this.el.classList.add('is-transitioning');

        this._setActiveList(targetList);

        this.el.scrollTop = 0;
        // targetList.listEl.style.top = 0;

        this._setDepth(targetList.depth);
        this._setScrollElementHeight(targetList.height);

        // setTimeout(function() {
        //   self.el.classList.remove('is-transitioning');
        // }, 750);
      } else {
        // The element has no target list but might have a href, so let's follow that link
      }
    },

    /**
     * Force the height of the wrapper to prevent scrolling when not required
     *
     * @param      {String}  height  The desired height
     */
    _setScrollElementHeight: function (height) {
      if (!this.inner) {
        return;
      }

      if (this.data.depth == 0) {
        var mobileNavLists = document.querySelectorAll('.site-nav--mobile-nav');
        var i = mobileNavLists.length;
        height = 0;
        while (i--) {
          height += mobileNavLists[i].offsetHeight;
        }
        height = height + 50 + 'px';
      }

      this.inner.style.height = height;
    },

    _setActiveList: function (list) {
      var depth;

      depth = list.depth;

      for (var i = this.data.activeLists.length - 1; i >= 0; i--) {
        if (this.data.activeLists[i].depth == depth) {
          this.data.activeLists.splice(i, 1);
        }
      }

      this.data.previous = this.data.active;
      this.data.active = list;
      this.data.activeLists.push(list);
    },

    _setDepth: function (depth) {
      this.data.depth = depth;
    },

    /**
     * Init the draw object
     *
     * @return     {object}  the drawer
     */
    _createDrawer: function () {
      var self = this;

      this.drawer = new theme.Drawers(this.drawerId, 'left', {
        beforeDrawerOpen: function (drawer) {
          self._setDepth(0);

          theme.header.hideLowerHeader(true);
          theme.MiniCart.close({
            direction: 'right',
          });

          var drawerProperties = drawer.getProperties();
          var el = drawer.$drawer.get(0);
          el.scrollTop = 0;
          el.style.top = drawerProperties.top;
          el.style.height = drawerProperties.height;
          // theme.utils.forceRedraw(el);
        },
        onDrawerClose: function () {
          theme.header.hideLowerHeader(false);
          self._setDepth(0);
        },
      });

      var drawerOpenTrigger = document.querySelector(
        selectors.drawerOpenTrigger
      );
      drawerOpenTrigger.addEventListener('click', function () {
        theme.drawers[self.drawerId].open(event);
      });
    },

    /**
     * Bind the view
     *
     * @return     {object}  the bound TinyBind view
     */
    _bindView: function () {
      return tinybind.bind(this.el, {
        data: this.data,
        methods: this.methods,
      });
    },

    /**
     * Open the drawer
     */
    open: function () {
      this.drawer.open();
    },

    /**
     * Close the drawer
     */
    close: function () {
      this.drawer.close();
    },
  });

  return new MobileNavDrawer();
})();

// theme.current.collection.products[3].compare_at_price = "15000";
// theme.current.collection.products[2].tags.push('preorder');
// theme.current.collection.products[1].tags.push('new');
// theme.current.collection.products[0].available = false;

window.theme = window.theme || {};

theme.ProductFilter = (function () {
  var selectors = {
    collection: '.collection',
    collectionTitle: '[data-collection-title]',
    collectionDescription: '[data-collection-description]',
    collectionGrid: '.collection-grid',
    collectionGridRow: '.collection-grid .row',
    collectionSection: '#shopify-section-collection',
    pageHeader: '.page-header',
    filterTitle: '.bc-sf-filter-block-title h3',
    filterOptionMenuItem: '.bc-sf-filter-option-block',
    filtersDesktop: '.js-filter',
    filteredProductsContainer: '#bc-sf-filter-products',
    collectionVendorsData: '#collection-vendors-data',
    productGridItem: '.product-grid-item',
  };

  var options = {
    displayCollectionDescription: true,
    animateHeaderHeight: false,
  };

  var cache = {
    headerHeightCurrent: 0,
    headerHeightNew: 0,
    sort: false,
    $vendorSections: {},
    vendorProducts: {},
    vendorData: {},
    viewBound: false,
  };

  function init() {
    if ('BCSfFilter' in window) {
      window.bcsffilter = new BCSfFilter();
      window.bcsffilter.init();

      if (
        theme.current.template.name == 'collection' ||
        theme.current.template.name == 'search'
      ) {
        window.bcsffilter.initFilter();
      }

      window.bcsffilter.initSearchBox();
    } else {
      buildCollectionPage();
    }
  }

  function buildCollectionPage(data, eventType) {
    if (!$(selectors.collection).length) {
      return;
    }

    if (!cache.viewBound) {
      var $collectionSection = $(selectors.collectionSection);

      tinybind.bind($collectionSection, {
        current: theme.current,
        settings: theme.settings,
        strings: theme.strings,
        methods: {},
      });

      cache.viewBound = true;
    }

    cache.sort =
      'BCSfFilter' in window
        ? bcsffilter.queryParams.sort
        : theme.utils.getQueryParam('sort_by');
    $(selectors.collection).attr('data-sort', cache.sort);

    // if ('anime' in window) {
    //   anime({
    //     targets: '.product-grid-item',
    //     translateY: [15, 0],
    //     opacity: [0, 1],
    //     duration: 300,
    //     easing: 'easeInOutCubic',
    //     delay: anime.stagger(100, {grid: [4, 4]})
    //   });
    // }
  }

  return {
    init: init,
    buildCollectionPage: buildCollectionPage,
  };
})();

theme.ProductFilter.init();

window.theme = window.theme || {};

theme.Search = (function () {
  var selectors = {
    search: '.search',
    searchSubmit: '.search__submit',
    searchInput: '.search__input',

    siteHeader: '.site-header',
    siteHeaderSearchToggle: '.js-search-toggle',

    searchHeader: '.search-header',
    searchHeaderInput: '.search-header__input',
    searchHeaderSubmit: '.search-header__submit',

    pageContent: '#PageContent',
  };

  var classes = {
    focus: 'search--focus',
    mobileNavIsOpen: 'js-menu--is-open',
    mobileSearchIsOpen: 'js-search--is-open',
  };

  var searchIsOpen = false;

  function init() {
    if (!$(selectors.siteHeader).length) {
      return;
    }

    $(selectors.searchSubmit).on('click', function (evt) {
      searchIsOpen = false;
      var $el = $(evt.target);
      var $input = $el.parents(selectors.search).find(selectors.searchInput);
      if ($input.val().length === 0) {
        evt.preventDefault();
        searchFocus($input);
      }
    });

    $(selectors.siteHeaderSearchToggle).on('click', activateSearch);

    $(selectors.searchHeaderInput)
      .add(selectors.searchHeaderSubmit)
      .on('focus', activateSearch);
    $(selectors.searchHeaderInput)
      .add(selectors.searchHeaderSubmit)
      .on('blur', deactivateSearch);
  }

  function activateSearch(evt) {
    if (evt.type != 'focus') {
      searchFocus($(selectors.searchInput));
    }
    searchIsOpen = true;

    $(selectors.searchHeader).addClass(classes.focus);
    $(selectors.pageContent).addClass(classes.mobileSearchIsOpen);
  }

  function deactivateSearch() {
    searchIsOpen = false;

    $(selectors.searchHeader).removeClass(classes.focus);
    $(selectors.pageContent).removeClass(classes.mobileSearchIsOpen);
  }

  function toggleSearch() {
    if (searchIsOpen) {
    } else {
      searchFocus($(selectors.searchInput));
      searchIsOpen = true;

      $(selectors.searchHeader).addClass(classes.focus);
      $(selectors.pageContent).addClass(classes.mobileSearchIsOpen);
    }
  }

  function searchFocus($el) {
    $el.focus();
    // set selection range hack for iOS
    $el[0].setSelectionRange(0, $el[0].value.length);
  }

  return {
    init: init,
  };
})();

window.theme = window.theme || {};

theme.Slideshow = (function () {
  this.$slideshow = null;
  var classes = {
    wrapper: 'slideshow-wrapper',
    slideshow: 'slideshow',
    currentSlide: 'slick-current',
    video: 'slideshow__video',
    videoBackground: 'slideshow__video--background',
    closeVideoBtn: 'slideshow__video-control--close',
    pauseButton: 'slideshow__pause',
    isPaused: 'is-paused',
  };
  // #TODO: Make these more global
  var config = {
    mediaQuerySmall: theme.settings.mediaQuery.small,
    mediaQueryMedium: theme.settings.mediaQuery.medium,
    mediaQueryLargeUp: theme.settings.mediaQuery.largeUp,
  };
  var defaults = {
    accessibility: true,
    adaptiveHeight: false,
    arrows: false,
    asNavFor: null,
    autoplay: false,
    autoplaySpeed: 7000,
    centerMode: false,
    centerPadding: '40px',
    dots: false,
    draggable: true,
    fade: false,
    infinite: true,
    rows: 0,
    slidesPerRow: 1,
    slidesToScroll: 1,
    slidesToShow: 1,
    swipeToSlide: true,
    touchThreshold: 20,
  };

  function slideshow(el) {
    this.$slideshow = $(el);

    if (!this.$slideshow.length) {
      return;
    }

    this.$wrapper =
      this.$slideshow.closest('.' + classes.wrapper) || this.parent();
    this.$pause = this.$wrapper.find('.' + classes.pauseButton);
    this.sliderActive = false;
    var elementOptions = this.$slideshow.data();

    defaults.prevArrow =
      '#' + this.$slideshow.attr('id') + ' ~ .slideshow__prev';
    defaults.nextArrow =
      '#' + this.$slideshow.attr('id') + ' ~ .slideshow__next';

    this.settings = {};
    this.settings.all = {
      adaptiveHeight: elementOptions.adaptiveHeight,
      arrows: elementOptions.arrows,
      asNavFor: elementOptions.asNavFor,
      autoplay: elementOptions.autoplay,
      autoplaySpeed: elementOptions.speed,
      centerMode: elementOptions.centerMode,
      centerPadding: elementOptions.centerPadding,
      dots: elementOptions.dots,
      draggable: elementOptions.draggable,
      fade: elementOptions.fade,
      focusOnSelect: elementOptions.focusOnSelect,
      infinite: elementOptions.infinite,
      nextArrow: elementOptions.nextArrow,
      prevArrow: elementOptions.prevArrow,
      rows: elementOptions.rows,
      slidesPerRow: elementOptions.perRow,
      slidesToScroll: elementOptions.slidesScroll,
      slidesToShow: elementOptions.slidesShow,
      waitForAnimate: elementOptions.waitForAnimate,
    };
    this.settings.desktop = {
      adaptiveHeight: elementOptions.adaptiveHeightDesktop,
      arrows: elementOptions.arrowsDesktop,
      autoplay: elementOptions.autoplayDesktop,
      autoplaySpeed: elementOptions.speedDesktop,
      centerMode: elementOptions.centerModeDesktop,
      centerPadding: elementOptions.centerPaddingDesktop,
      dots: elementOptions.dotsDesktop,
      focusOnSelect: elementOptions.focusOnSelectDesktop,
      infinite: elementOptions.infiniteDesktop,
      rows: elementOptions.rowsDesktop,
      slidesPerRow: elementOptions.perRowDesktop,
      slidesToScroll: elementOptions.slidesScrollDesktop,
      slidesToShow: elementOptions.slidesShowDesktop,
      // touchThreshold: 100,
      // swipeToSlide: true,
      // touchMove: true,
    };
    this.settings.tablet = {
      adaptiveHeight: elementOptions.adaptiveHeightTablet,
      arrows: elementOptions.arrowsTablet,
      autoplay: elementOptions.autoplayTablet,
      autoplaySpeed: elementOptions.speedTablet,
      centerMode: elementOptions.centerModeTablet,
      centerPadding: elementOptions.centerPaddingTablet,
      dots: elementOptions.dotsTablet,
      focusOnSelect: elementOptions.focusOnSelectTablet,
      infinite: elementOptions.infiniteTablet,
      rows: elementOptions.rowsTablet,
      slidesPerRow: elementOptions.perRowTablet,
      slidesToScroll: elementOptions.slidesScrollTablet,
      slidesToShow: elementOptions.slidesShowTablet,
    };
    this.settings.mobile = {
      adaptiveHeight: elementOptions.adaptiveHeightMobile,
      arrows: elementOptions.arrowsMobile,
      autoplay: elementOptions.autoplayMobile,
      autoplaySpeed: elementOptions.speedMobile,
      centerMode: elementOptions.centerModeMobile,
      centerPadding: elementOptions.centerPaddingMobile,
      dots: elementOptions.dotsMobile,
      focusOnSelect: elementOptions.focusOnSelectMobile,
      infinite: elementOptions.infiniteMobile,
      rows: elementOptions.rowsMobile,
      slidesPerRow: elementOptions.perRowMobile,
      slidesToScroll: elementOptions.slidesScrollMobile,
      slidesToShow: elementOptions.slidesShowMobile,
    };

    _.defaults(this.settings.desktop, this.settings.all);
    _.defaults(this.settings.desktop, defaults);

    _.defaults(this.settings.tablet, this.settings.all);
    _.defaults(this.settings.tablet, defaults);

    _.defaults(this.settings.mobile, this.settings.all);
    _.defaults(this.settings.mobile, defaults);

    this.$slideshow.on('beforeChange', beforeChange.bind(this));
    this.$slideshow.on('init', slideshowA11y.bind(this));
    // this.$slideshow.slick(this.settings);

    var self = this;

    enquire.register(config.mediaQuerySmall, {
      match: function () {
        if (!elementOptions.disableMobile) {
          initSlider(self.$slideshow, self.settings.mobile);
        } else {
          destroySlider(self.$slideshow);
        }
      },
    });

    enquire.register(config.mediaQueryMedium, {
      match: function () {
        if (!elementOptions.disableTablet) {
          initSlider(self.$slideshow, self.settings.tablet);
        } else {
          destroySlider(self.$slideshow);
        }
      },
    });

    enquire.register(config.mediaQueryLargeUp, {
      match: function () {
        if (!elementOptions.disableDesktop) {
          initSlider(self.$slideshow, self.settings.desktop);
        } else {
          destroySlider(self.$slideshow);
        }
      },
    });

    function initSlider(sliderObj, args) {
      if (self.sliderActive) {
        sliderObj.slick('unslick');
        self.sliderActive = false;
      }

      sliderObj.on('beforeChange.slideshow', function (
        event,
        slick,
        currentSlide,
        nextSlide
      ) {
        slick.$slider.addClass('slick-transitioning');
      });

      sliderObj.on('afterChange.slideshow', function (
        event,
        slick,
        currentSlide,
        nextSlide
      ) {
        slick.$slider.removeClass('slick-transitioning');
      });

      sliderObj.slick(args);
      // sliderObj.on('wheel', (function(e) {
      //   e.preventDefault();
      //   if (e.originalEvent.deltaY < 0) {
      //     $(this).slick('slickNext');
      //   } else {
      //     $(this).slick('slickPrev');
      //   }
      // }));
      self.sliderActive = true;
    }

    function destroySlider(sliderObj) {
      if (self.sliderActive) {
        sliderObj.off('.slideshow');
        sliderObj.slick('unslick');
        self.sliderActive = false;
      }
    }

    this.$pause.on('click', this.togglePause.bind(this));
  }

  function slideshowA11y(event, obj) {
    var $slider = obj.$slider;
    var $list = obj.$list;
    var $wrapper = this.$wrapper;
    var autoplay = this.settings.autoplay;

    // Remove default Slick aria-live attr until slider is focused
    $list.removeAttr('aria-live');

    // When an element in the slider is focused
    // pause slideshow and set aria-live.
    $wrapper.on('focusin', function (evt) {
      if (!$wrapper.has(evt.target).length) {
        return;
      }

      $list.attr('aria-live', 'polite');

      if (autoplay) {
        $slider.slick('slickPause');
      }
    });

    // Resume autoplay
    $wrapper.on('focusout', function (evt) {
      if (!$wrapper.has(evt.target).length) {
        return;
      }

      $list.removeAttr('aria-live');

      if (autoplay) {
        // Manual check if the focused element was the video close button
        // to ensure autoplay does not resume when focus goes inside YouTube iframe
        if ($(evt.target).hasClass(classes.closeVideoBtn)) {
          return;
        }

        $slider.slick('slickPlay');
      }
    });

    // Add arrow key support when focused
    if (obj.$dots) {
      obj.$dots.on('keydown', function (evt) {
        if (evt.which === 37) {
          $slider.slick('slickPrev');
        }

        if (evt.which === 39) {
          $slider.slick('slickNext');
        }

        // Update focus on newly selected tab
        if (evt.which === 37 || evt.which === 39) {
          obj.$dots.find('.slick-active button').focus();
        }
      });
    }
  }

  function beforeChange(event, slick, currentSlide, nextSlide) {
    var $slider = slick.$slider;
    var $currentSlide = $slider.find('.' + classes.currentSlide);
    var $nextSlide = $slider.find(
      '.slideshow__slide[data-slick-index="' + nextSlide + '"]'
    );

    if (isVideoInSlide($currentSlide)) {
      var $currentVideo = $currentSlide.find('.' + classes.video);
      var currentVideoId = $currentVideo.attr('id');
      theme.SlideshowVideo.pauseVideo(currentVideoId);
      $currentVideo.attr('tabindex', '-1');
    }

    if (isVideoInSlide($nextSlide)) {
      var $video = $nextSlide.find('.' + classes.video);
      var videoId = $video.attr('id');
      var isBackground = $video.hasClass(classes.videoBackground);
      if (isBackground) {
        theme.SlideshowVideo.playVideo(videoId);
      } else {
        $video.attr('tabindex', '0');
      }
    }
  }

  function isVideoInSlide($slide) {
    return $slide.find('.' + classes.video).length;
  }

  slideshow.prototype.togglePause = function () {
    var slideshowSelector = getSlideshowId(this.$pause);
    if (this.$pause.hasClass(classes.isPaused)) {
      this.$pause.removeClass(classes.isPaused);
      $(slideshowSelector).slick('slickPlay');
    } else {
      this.$pause.addClass(classes.isPaused);
      $(slideshowSelector).slick('slickPause');
    }
  };

  function getSlideshowId($el) {
    return '#Slideshow-' + $el.data('id');
  }

  return slideshow;
})();

// Youtube API callback
// eslint-disable-next-line no-unused-vars
function onYouTubeIframeAPIReady() {
  theme.SlideshowVideo.loadVideos();
}

theme.SlideshowVideo = (function () {
  var autoplayCheckComplete = false;
  var autoplayAvailable = false;
  var playOnClickChecked = false;
  var playOnClick = false;
  var youtubeLoaded = false;
  var videos = {};
  var videoPlayers = [];
  var videoOptions = {
    ratio: 16 / 9,
    playerVars: {
      // eslint-disable-next-line camelcase
      iv_load_policy: 3,
      modestbranding: 1,
      autoplay: 0,
      controls: 0,
      showinfo: 0,
      wmode: 'opaque',
      branding: 0,
      autohide: 0,
      rel: 0,
    },
    events: {
      onReady: onPlayerReady,
      onStateChange: onPlayerChange,
    },
  };
  var classes = {
    playing: 'video-is-playing',
    paused: 'video-is-paused',
    loading: 'video-is-loading',
    loaded: 'video-is-loaded',
    slideshowWrapper: 'slideshow-wrapper',
    slide: 'slideshow__slide',
    slideBackgroundVideo: 'slideshow__slide--background-video',
    slideDots: 'slick-dots',
    videoChrome: 'slideshow__video--chrome',
    videoBackground: 'slideshow__video--background',
    playVideoBtn: 'slideshow__video-control--play',
    closeVideoBtn: 'slideshow__video-control--close',
    currentSlide: 'slick-current',
    slickClone: 'slick-cloned',
    supportsAutoplay: 'autoplay',
    supportsNoAutoplay: 'no-autoplay',
  };

  /**
   * Public functions
   */
  function init($video) {
    if (!$video.length) {
      return;
    }

    videos[$video.attr('id')] = {
      id: $video.attr('id'),
      videoId: $video.data('id'),
      type: $video.data('type'),
      status: $video.data('type') === 'chrome' ? 'closed' : 'background', // closed, open, background
      videoSelector: $video.attr('id'),
      $parentSlide: $video.closest('.' + classes.slide),
      $parentSlideshowWrapper: $video.closest('.' + classes.slideshowWrapper),
      controls: $video.data('type') === 'background' ? 0 : 1,
      slideshow: $video.data('slideshow'),
    };

    if (!youtubeLoaded) {
      // This code loads the IFrame Player API code asynchronously.
      var tag = document.createElement('script');
      tag.src = 'https://www.youtube.com/iframe_api';
      var firstScriptTag = document.getElementsByTagName('script')[0];
      firstScriptTag.parentNode.insertBefore(tag, firstScriptTag);
    }
  }

  function customPlayVideo(playerId) {
    // Do not autoplay just because the slideshow asked you to.
    // If the slideshow asks to play a video, make sure
    // we have done the playOnClick check first
    if (!playOnClickChecked && !playOnClick) {
      return;
    }

    if (playerId && typeof videoPlayers[playerId].playVideo === 'function') {
      privatePlayVideo(playerId);
    }
  }

  function pauseVideo(playerId) {
    if (
      videoPlayers[playerId] &&
      typeof videoPlayers[playerId].pauseVideo === 'function'
    ) {
      videoPlayers[playerId].pauseVideo();
    }
  }

  function loadVideos() {
    for (var key in videos) {
      if (videos.hasOwnProperty(key)) {
        var args = $.extend({}, videoOptions, videos[key]);
        args.playerVars.controls = args.controls;
        videoPlayers[key] = new YT.Player(key, args);
      }
    }

    initEvents();
    youtubeLoaded = true;
  }

  function loadVideo(key) {
    if (!youtubeLoaded) {
      return;
    }
    var args = $.extend({}, videoOptions, videos[key]);
    args.playerVars.controls = args.controls;
    videoPlayers[key] = new YT.Player(key, args);

    initEvents();
  }

  /**
   * Private functions
   */

  function privatePlayVideo(id, clicked) {
    var videoData = videos[id];
    var player = videoPlayers[id];
    var $slide = videos[id].$parentSlide;

    if (playOnClick) {
      // playOnClick means we are probably on mobile (no autoplay).
      // setAsPlaying will show the iframe, requiring another click
      // to play the video.
      setAsPlaying(videoData);
    } else if (clicked || (autoplayCheckComplete && autoplayAvailable)) {
      // Play if autoplay is available or clicked to play
      $slide.removeClass(classes.loading);
      setAsPlaying(videoData);
      player.playVideo();
      return;
    }

    // Check for autoplay if not already done
    if (!autoplayCheckComplete) {
      autoplayCheckFunction(player, $slide);
    }
  }

  function setAutoplaySupport(supported) {
    var supportClass = supported
      ? classes.supportsAutoplay
      : classes.supportsNoAutoplay;
    $(document.documentElement).addClass(supportClass);

    if (!supported) {
      playOnClick = true;
    }

    autoplayCheckComplete = true;
  }

  function autoplayCheckFunction(player, $slide) {
    // attempt to play video
    player.playVideo();

    autoplayTest(player)
      .then(function () {
        setAutoplaySupport(true);
      })
      .fail(function () {
        // No autoplay available (or took too long to start playing).
        // Show fallback image. Stop video for safety.
        setAutoplaySupport(false);
        player.stopVideo();
      })
      .always(function () {
        autoplayCheckComplete = true;
        $slide.removeClass(classes.loading);
      });
  }

  function autoplayTest(player) {
    var deferred = $.Deferred();
    var wait;
    var timeout;

    wait = setInterval(function () {
      if (player.getCurrentTime() <= 0) {
        return;
      }

      autoplayAvailable = true;
      clearInterval(wait);
      clearTimeout(timeout);
      deferred.resolve();
    }, 500);

    timeout = setTimeout(function () {
      clearInterval(wait);
      deferred.reject();
    }, 4000); // subjective. test up to 8 times over 4 seconds

    return deferred;
  }

  function playOnClickCheck() {
    // Bail early for a few instances:
    // - small screen
    // - device sniff mobile browser

    if (playOnClickChecked) {
      return;
    }

    if ($(window).width() < 750) {
      playOnClick = true;
    } else if (isMobile.any) {
      playOnClick = true;
    }

    if (playOnClick) {
      // No need to also do the autoplay check
      setAutoplaySupport(false);
    }

    playOnClickChecked = true;
  }

  // The API will call this function when each video player is ready
  function onPlayerReady(evt) {
    evt.target.setPlaybackQuality('hd1080');
    var videoData = getVideoOptions(evt);

    playOnClickCheck();

    // Prevent tabbing through YouTube player controls until visible
    $('#' + videoData.id).attr('tabindex', '-1');

    sizeBackgroundVideos();

    // Customize based on options from the video ID
    switch (videoData.type) {
      case 'background-chrome':
      case 'background':
        evt.target.mute();
        // Only play the video if it is in the active slide
        if (videoData.$parentSlide.hasClass(classes.currentSlide)) {
          privatePlayVideo(videoData.id);
        }
        break;
    }

    videoData.$parentSlide.addClass(classes.loaded);
  }

  function onPlayerChange(evt) {
    var videoData = getVideoOptions(evt);

    switch (evt.data) {
      case 0: // ended
        setAsFinished(videoData);
        break;
      case 1: // playing
        setAsPlaying(videoData);
        break;
      case 2: // paused
        setAsPaused(videoData);
        break;
    }
  }

  function setAsFinished(videoData) {
    switch (videoData.type) {
      case 'background':
        videoPlayers[videoData.id].seekTo(0);
        break;
      case 'background-chrome':
        videoPlayers[videoData.id].seekTo(0);
        closeVideo(videoData.id);
        break;
      case 'chrome':
        closeVideo(videoData.id);
        break;
    }
  }

  function setAsPlaying(videoData) {
    var $slideshow = videoData.$parentSlideshowWrapper;
    var $slide = videoData.$parentSlide;

    $slide.removeClass(classes.loading);

    // Do not change element visibility if it is a background video
    if (videoData.status === 'background') {
      return;
    }

    $('#' + videoData.id).attr('tabindex', '0');

    switch (videoData.type) {
      case 'chrome':
      case 'background-chrome':
        $slideshow.removeClass(classes.paused).addClass(classes.playing);
        $slide.removeClass(classes.paused).addClass(classes.playing);
        break;
    }

    // Update focus to the close button so we stay within the slide
    $slide.find('.' + classes.closeVideoBtn).focus();
  }

  function setAsPaused(videoData) {
    var $slideshow = videoData.$parentSlideshowWrapper;
    var $slide = videoData.$parentSlide;

    if (videoData.type === 'background-chrome') {
      closeVideo(videoData.id);
      return;
    }

    // YT's events fire after our click event. This status flag ensures
    // we don't interact with a closed or background video.
    if (videoData.status !== 'closed' && videoData.type !== 'background') {
      $slideshow.addClass(classes.paused);
      $slide.addClass(classes.paused);
    }

    if (videoData.type === 'chrome' && videoData.status === 'closed') {
      $slideshow.removeClass(classes.paused);
      $slide.removeClass(classes.paused);
    }

    $slideshow.removeClass(classes.playing);
    $slide.removeClass(classes.playing);
  }

  function closeVideo(playerId) {
    var videoData = videos[playerId];
    var $slideshow = videoData.$parentSlideshowWrapper;
    var $slide = videoData.$parentSlide;
    var classesToRemove = [classes.pause, classes.playing].join(' ');

    $('#' + videoData.id).attr('tabindex', '-1');

    videoData.status = 'closed';

    switch (videoData.type) {
      case 'background-chrome':
        videoPlayers[playerId].mute();
        setBackgroundVideo(playerId);
        break;
      case 'chrome':
        videoPlayers[playerId].stopVideo();
        setAsPaused(videoData); // in case the video is already paused
        break;
    }

    $slideshow.removeClass(classesToRemove);
    $slide.removeClass(classesToRemove);
  }

  function getVideoOptions(evt) {
    return videos[evt.target.h.id];
  }

  function startVideoOnClick(playerId) {
    var videoData = videos[playerId];
    // add loading class to slide
    videoData.$parentSlide.addClass(classes.loading);

    videoData.status = 'open';

    switch (videoData.type) {
      case 'background-chrome':
        unsetBackgroundVideo(playerId, videoData);
        videoPlayers[playerId].unMute();
        privatePlayVideo(playerId, true);
        break;
      case 'chrome':
        privatePlayVideo(playerId, true);
        break;
    }

    // esc to close video player
    $(document).on('keydown.videoPlayer', function (evt) {
      if (evt.keyCode === 27) {
        closeVideo(playerId);
      }
    });
  }

  function sizeBackgroundVideos() {
    $('.' + classes.videoBackground).each(function (index, el) {
      sizeBackgroundVideo($(el));
    });
  }

  function sizeBackgroundVideo($player) {
    var $slide = $player.closest('.' + classes.slide);
    // Ignore cloned slides
    if ($slide.hasClass(classes.slickClone)) {
      return;
    }
    var slideWidth = $slide.width();
    var playerWidth = $player.width();
    var playerHeight = $player.height();

    // when screen aspect ratio differs from video, video must center and underlay one dimension
    if (slideWidth / videoOptions.ratio < playerHeight) {
      playerWidth = Math.ceil(playerHeight * videoOptions.ratio); // get new player width
      $player
        .width(playerWidth)
        .height(playerHeight)
        .css({
          left: (slideWidth - playerWidth) / 2,
          top: 0,
        }); // player width is greater, offset left; reset top
    } else {
      // new video width < window width (gap to right)
      playerHeight = Math.ceil(slideWidth / videoOptions.ratio); // get new player height
      $player
        .width(slideWidth)
        .height(playerHeight)
        .css({
          left: 0,
          top: (playerHeight - playerHeight) / 2,
        }); // player height is greater, offset top; reset left
    }

    $player.prepareTransition().addClass(classes.loaded);
  }

  function unsetBackgroundVideo(playerId) {
    // Switch the background-chrome to a chrome-only player once played
    $('#' + playerId)
      .removeAttr('style')
      .removeClass(classes.videoBackground)
      .addClass(classes.videoChrome);

    videos[playerId].$parentSlideshowWrapper
      .removeClass(classes.slideBackgroundVideo)
      .addClass(classes.playing);

    videos[playerId].$parentSlide
      .removeClass(classes.slideBackgroundVideo)
      .addClass(classes.playing);

    videos[playerId].status = 'open';
  }

  function setBackgroundVideo(playerId) {
    // Switch back to background-chrome when closed
    var $player = $('#' + playerId)
      .addClass(classes.videoBackground)
      .removeClass(classes.videoChrome);

    videos[playerId].$parentSlide.addClass(classes.slideBackgroundVideo);

    videos[playerId].status = 'background';
    sizeBackgroundVideo($player);
  }

  function initEvents() {
    $(document).on('click.videoPlayer', '.' + classes.playVideoBtn, function (
      evt
    ) {
      var playerId = $(evt.currentTarget).data('controls');
      startVideoOnClick(playerId);
    });

    $(document).on('click.videoPlayer', '.' + classes.closeVideoBtn, function (
      evt
    ) {
      var playerId = $(evt.currentTarget).data('controls');
      closeVideo(playerId);
    });

    // Listen to resize to keep a background-size:cover-like layout
    $(window).on(
      'resize.videoPlayer',
      $.debounce(250, function () {
        if (youtubeLoaded) {
          sizeBackgroundVideos();
        }
      })
    );
  }

  function removeEvents() {
    $(document).off('.videoPlayer');
    $(window).off('.videoPlayer');
  }

  return {
    init: init,
    loadVideos: loadVideos,
    loadVideo: loadVideo,
    playVideo: customPlayVideo,
    pauseVideo: pauseVideo,
    removeEvents: removeEvents,
  };
})();

(function () {
  var selectors = {
    backButton: '.return-link',
  };

  var $backButton = $(selectors.backButton);

  if (!document.referrer || !$backButton.length || !window.history.length) {
    return;
  }

  $backButton.one('click', function (evt) {
    evt.preventDefault();

    var referrerDomain = urlDomain(document.referrer);
    var shopDomain = urlDomain(window.location.href);

    if (shopDomain === referrerDomain) {
      history.back();
    }

    return false;
  });

  function urlDomain(url) {
    var anchor = document.createElement('a');
    anchor.ref = url;

    return anchor.hostname;
  }
})();

/**
 * Module to show Recently Viewed Products
 *
 * Copyright (c) 2014 Caroline Schnapp (11heavens.com)
 * Dual licensed under the MIT and GPL licenses:
 * http://www.opensource.org/licenses/mit-license.php
 * http://www.gnu.org/licenses/gpl.html
 *
 * Adapted to use Tinybind logic
 *
 */

window.theme = window.theme || {};
window.theme.slideshows = window.theme.slideshows || {};

theme.RecentlyViewed = (function () {
  var config = {
    howManyToShow: 4,
    howManyToStoreInMemory: 10,
    onComplete: null,
  };

  var selectors = {
    container: '#recently-viewed-products',
    list: '.recently-viewed-products__list',
  };

  var data = {
    products: [],
  };

  var productHandleQueue = [];
  var wrapper = null;
  var shown = 0;
  var total = 0;

  tinybind.bind($(selectors.container), {
    data: data,
  });

  var cookie = {
    configuration: {
      expires: 90,
      path: '/',
      domain: window.location.hostname,
    },
    name: 'shopify_recently_viewed',
    write: function (recentlyViewed) {
      localStorage.setItem(this.name, recentlyViewed.join(' '));
      
      var total = recentlyViewed.length;
    
      if(recentlyViewed.length > 1 ){
      $('.product__col--related').hide();
        setTimeout(function(){
           }, 4000);
      }else{
      $('.product__col--related').show();
      }
    },
    read: function () {
      var recentlyViewed = [];
      var cookieValue = localStorage.getItem(this.name);
     //console.log(cookieValue);
      if (cookieValue !== null) {
        recentlyViewed = cookieValue.split(' ');
      }
      return recentlyViewed;
    },
    destroy: function () {
      localStorage.removeItem(this.name);
    },
    remove: function (productHandle) {
      var recentlyViewed = this.read();
      var position = $.inArray(productHandle, recentlyViewed);
      if (position !== -1) {
        recentlyViewed.splice(position, 1);
        this.write(recentlyViewed);
      }
    },
  };
  var relatedProductsEl = document.querySelector('.recently-viewed-products__list');
  var moveAlong = function () {
    if (productHandleQueue.length && shown < config.howManyToShow && relatedProductsEl) {
      $.ajax({
        dataType: 'html',
        url: '/products/' + productHandleQueue[0] + '?view=grid-item',
        cache: false,
        success: function (product) {

          // product = JSON.parse(product);
          // product.featured_image = {
          //   src: product.featured_image,
          // };

          // if (product.images) {
          //   for (var i = 0; i < product.images.length; i++) {
          //     product.images[i] = {
          //       src: product.images[i],
          //     };
          //   }
          // }
          if (product){
            var htmlObject = document.createElement('div');
            htmlObject.innerHTML = product;
            let gridItem = htmlObject.querySelector('.product-grid-item');
            data.products.push(gridItem);
            relatedProductsEl.append(gridItem);
          }
          
          productHandleQueue.shift();
          shown++;
          moveAlong();
        },
        error: function () {
          cookie.remove(productHandleQueue[0]);
          productHandleQueue.shift();
          moveAlong();
        },
      });
    } else {
      // var slideshow = $(selectors.container);
      // theme.slideshows[slideshow] = new theme.Slideshow(slideshow);

      if (typeof config.onComplete === 'function') {
        config.onComplete();
      }
    }
  };

  return {
    showRecentlyViewed: function (params) {
      var params = params || {};

      // Update defaults.
      $.extend(config, params);

      // Read cookie.
      productHandleQueue = cookie.read();

      // How many products to show.
      config.howManyToShow = Math.min(
        productHandleQueue.length,
        config.howManyToShow
      );

      // If we have any to show.
      if (config.howManyToShow) {
        // Getting each product with an Ajax call and rendering it on the page.
        moveAlong();
      } else {
        $(selectors.container).hide();
      }
    },

    getConfig: function () {
      return config;
    },

    clearList: function () {
      cookie.destroy();
    },

    recordRecentlyViewed: function (params) {
      var params = params || {};

      // Update defaults.
      $.extend(config, params);

      // Read cookie.
      var recentlyViewed = cookie.read();

      // If we are on a product page.
      if (window.location.pathname.indexOf('/products/') !== -1) {
        // What is the product handle on this page.
        var productHandle = window.location.pathname.match(
          /\/products\/([a-z0-9\-]+)/
        )[1];
        // In what position is that product in memory.
        var position = $.inArray(productHandle, recentlyViewed);
        // If not in memory.
        if (position === -1) {
          // Add product at the start of the list.
          recentlyViewed.unshift(productHandle);
          // Only keep what we need.
          recentlyViewed = recentlyViewed.splice(
            0,
            config.howManyToStoreInMemory
          );
        } else {
          // Remove the product and place it at start of list.
          recentlyViewed.splice(position, 1);
          recentlyViewed.unshift(productHandle);
        }

        // Update cookie.
        cookie.write(recentlyViewed);
      }
    },
  };
})();

(function () {
  var selectors = {
    backButton: '.back-to-top',
  };

  var classes = {
    visible: 'back-to-top--visible',
    fade: 'back-to-top--fade',
  };

  var config = {
    showAfter: 300,
    dimAfter: 1200,
    scrollDuration: 700,
  };

  $backButton = $(selectors.backButton);

  if (!$backButton.length) {
    return;
  }

  // $(window).on('scroll', function(){
  //   ( $(this).scrollTop() > config.showAfter ) ? $backButton.addClass(classes.visible) : $backButton.removeClass(classes.visible + ' ' + classes.fade);
  //   if( $(this).scrollTop() > config.dimAfter ) {
  //     $backButton.addClass(classes.fade);
  //   }
  // });

  $backButton.on('click', function (evt) {
    evt.preventDefault();
    $('body,html').animate({ scrollTop: 0 }, config.scrollDuration);
  });
})();

/*============================================================================
  Favicon cart counter
==============================================================================*/
window.theme = window.theme || {};

theme.Favicon = (function () {
  if (window.Favico === undefined) {
    return;
  }

  var icon = new Favico({
    bgColor: '#00A764',
    textColor: '#fff',
    fontFamily: 'sans-serif', // Arial, Verdana, Times New Roman, serif, sans-serif, ...
    fontStyle: 'bold', // normal, italic, oblique, bold, bolder, lighter, 100, 200, 300, 400, 500, 600, 700, 800, 900
    type: 'circle', // circle, rectangle
    position: 'down', // up, down, left, upleft
    animation: 'none', // slide, fade, pop, popFade, none
    elementId: false, // Image element ID if there is need to attach badge to regular image
    element: false, // DOM element where to change "href" attribute (useful in case of multiple link icon elements)
    dataUrl: false, // Method that will be called for each animation from with data URI parameter
  });

  if (window.shop.cart !== undefined && window.shop.cart.item_count > 0) {
    set(window.shop.cart.item_count);
  }

  function set(value) {
    icon.badge(value);
  }

  function reset() {
    icon.reset();
  }

  return {
    set: set,
    reset: reset,
  };
})();

/*
 * Adapted from Currency tools by Caroline Schnapp
 *
 * Copyright (c) 2015 Caroline Schnapp (mllegeorgesand@gmail.com)
 * Licensed under the MIT license:
 * http://www.opensource.org/licenses/mit-license.php
 *
 */

window.theme = window.theme || {};

theme.CurrencySelectors = (function () {
  function init() {
    Currency.format = shop.currencyFormat;

    var shopCurrency = shop.currency;

    /* Sometimes merchants change their shop currency, let's tell our JavaScript file */
    Currency.moneyFormats[shopCurrency].money_with_currency_format =
      shop.moneyWithCurrencyFormat;
    Currency.moneyFormats[shopCurrency].money_format = shop.moneyFormat;

    /* Default currency */
    var defaultCurrency = shop.defaultCurrency;

    /* Cookie currency */
    var cookieCurrency = Currency.cookie.read();

    /* Fix for customer account pages */
    $('span.money span.money').each(function () {
      $(this).parents('span.money').removeClass('money');
    });

    /* Saving the current price */
    $('span.money').each(function () {
      $(this).attr('data-currency-' + shop.currency, $(this).html());
    });

    // If there's no cookie.
    if (cookieCurrency == null) {
      if (shopCurrency !== defaultCurrency) {
        Currency.convertAll(shopCurrency, defaultCurrency);
      } else {
        Currency.currentCurrency = defaultCurrency;
      }
    }
    // If the cookie value does not correspond to any value in the currency dropdown.
    else if (
      $('[name=currencies]').length &&
      $('[name=currencies] option[value=' + cookieCurrency + ']').length === 0
    ) {
      Currency.currentCurrency = shopCurrency;
      Currency.cookie.write(shopCurrency);
    } else if (cookieCurrency === shopCurrency) {
      Currency.currentCurrency = shopCurrency;
    } else {
      Currency.convertAll(shopCurrency, cookieCurrency);
    }

    $('[name=currencies]')
      .val(Currency.currentCurrency)
      .on('change', function () {
        var newCurrency = $(this).val();
        Currency.convertAll(Currency.currentCurrency, newCurrency);
        $('.selected-currency').text(Currency.currentCurrency);
      });

    var original_selectCallback = window.selectCallback;
    var selectCallback = function (variant, selector) {
      original_selectCallback(variant, selector);
      Currency.convertAll(shopCurrency, $('[name=currencies]').val());
      $('.selected-currency').text(Currency.currentCurrency);
    };

    $(document).on('cart.requestComplete', function (event, cart) {
      Currency.convertAll(shopCurrency, $('[name=currencies]').val());
      $('.selected-currency').text(Currency.currentCurrency);
    });

    $('.selected-currency').text(Currency.currentCurrency);
    $('.currency-picker__wrapper').removeClass('loading');
  }

  return {
    init: init,
  };
})();

theme.CurrencySelectors.init();

window.theme = window.theme || {};

theme.NewsletterPopup = (function () {
  var selectors = {
    el: '#newsletter-popup',
    successMessage: '.form-success',
    barTopParent: '#PageContent',
    barBottomParent: '',
  };

  var defaults = {
    cookieTitle: 'newsletter_popup',
  };

  /**
   * Create a new Newsletter Popup
   *
   * @class      NewsletterPopup
   * @param      {object}  options  The options
   */
  function NewsletterPopup(options) {
    this.el = document.querySelector(selectors.el);

    if (!this.el || this.hasBeenDismised) {
      return;
    }

    this.options = _.defaults(defaults, this.getOptions());

    if (this.options.devMode) {
      this.openPopup();
    } else if (
      this.checkHasBeenDismissed() ||
      window.location.pathname.indexOf('challenge') > -1
    ) {
      return;
    } else if (this.checkHasBeenViewed()) {
      this.openPopup();
    } else {
      this.bindListener();
    }
  }

  NewsletterPopup.prototype = _.extend(NewsletterPopup.prototype, {
    bindListener: function () {
      var self = this;

      $(document).on('scroll.newsletterModal', function () {
        window.setTimeout(function () {
          self.openPopup();
        }, self.options.delay || 0);

        $(document).off('scroll.newsletterModal');
      });
    },

    /**
     * Get the options set as data attributes on the element
     *
     * @return     {Object}  The options set on the element data attribute.
     */
    getOptions: function () {
      var activationDelay,
        cookieExpiry,
        developerMode,
        popupType,
        options = {};

      activationDelay = this.el.dataset.delay;
      cookieExpiry = this.el.dataset.expiry;
      developerMode = this.el.dataset.developerMode;
      popupType = this.el.dataset.popupType;
      popupPosition = this.el.dataset.popupPosition;

      return {
        delay: activationDelay ? parseInt(activationDelay) : null,
        expiry: cookieExpiry ? parseInt(cookieExpiry) : null,
        devMode: developerMode ? developerMode == 'true' : null,
        type: popupType ? popupType : null,
        position: popupPosition ? popupPosition : null,
      };
    },

    /**
     * Check if the popup has been viewed
     *
     * @return     {boolean}  Has the popup been viewed before?
     */
    checkHasBeenViewed: function () {
      return $.cookie(this.options.cookieTitle + '_viewed') == 'true';
    },

    storeViewedState: function () {
      $.cookie(this.options.cookieTitle + '_viewed', 'true', {
        expires: this.options.expiry,
        path: '/',
      });
    },

    checkHasBeenDismissed: function () {
      return $.cookie(this.options.cookieTitle + '_dismissed') == 'true';
    },

    storeDismissedState: function () {
      $.cookie(this.options.cookieTitle + '_dismissed', 'true', {
        expires: this.options.expiry,
        path: '/',
      });
    },

    /**
     * Check the popup type and open the popup
     */
    openPopup: function () {
      var self = this;

      switch (this.options.type) {
        case 'modal':
          this._openAsModal();
          break;
        case 'bar':
          this._openAsBar(this.options.position);
          break;
        default:
      }

      this.storeViewedState();

      $('.newsletter-popup-close').on('click.newsletterModal', function () {
        self.closePopup();
      });

      if (this.el.querySelector('.form-success')) {
        this.storeDismissedState();
      }
    },

    closePopup: function () {
      var self = this;

      switch (this.options.type) {
        case 'modal':
          this._closeModal();
          break;
        case 'bar':
          this._closeBar();
          break;
        default:
      }

      this.storeDismissedState();

      $('.newsletter-popup-close').on('click.newsletterModal', function () {
        self.closePopup();
      });
    },

    _closeBar: function () {
      this.el.remove();
    },

    /**
     * Open the popup as a modal
     */
    _openAsModal: function () {
      var self = this;

      new theme.Modal(this.el, {
        positionX: 'bottom',
        positionY: 'left',
        featherlightOptions: {
          variant: 'newsletter-modal',
          beforeClose: function () {
            self.storeDismissedState();
          },
        },
      });
    },

    /**
     * Open the popup as a bar at the desired position
     *
     * @param      {string}  position  Currently supports 'top'
     */
    _openAsBar: function (position) {
      var target;

      if (position == 'top') {
        target = document.querySelector(selectors.barTopParent);
        target.insertBefore(this.el, target.firstChild);

        $(this.el).stickybits({
          useFixed: true,
          useStickyClasses: true,
        });

        this.el.classList.add('reveal');
      }
    },
  });

  return new NewsletterPopup();
})();

window.theme = window.theme || {};

theme.StickyAddToCart = (function () {
  var selectors = {
    productDetails: '.product__col--details',
  };

  var stickybitsDefaults = {
    useFixed: true,
  };

  var defaults = {
    selectors: selectors,
    useStickybits: false,
    stickybits: stickybitsDefaults,
    parent: '#MainContent',
    templateName: 'product-sticky-add-to-cart',
    revealClass: 'show',
    showOnLoad: false,
  };

  function StickyAddToCart(options) {
    this.options = _.defaultsDeep(options, defaults);
    this.product = this.options.product;

    if (!this.product) {
      console.error('No product defined');
      return;
    }

    var self = this;

    this._build();
    this._bindReveal();

    this.isHidden = true;
    if (this.options.showOnLoad) {
      this.show();
    }
  }

  StickyAddToCart.prototype = $.extend({}, StickyAddToCart.prototype, {
    _build: function () {
      var self = this;

      var template = theme.utils.getTemplate(this.options.templateName);
      self.$el = $(template);
      $(self.options.parent).prepend(self.$el);

      // Bind StickyBits
      if (self.options.useStickybits) {
        self.$el.stickybits(self.options.stickybits);
      }

      // Bind TinyBind view
      // You can either bind here or in product.js
      // self.view = tinybind.bind(self.$el, { data: self });

      return;
    },

    _bindReveal: function () {
      var self = this;

      var waypointElement = $(selectors.productDetails)[0];

      self.waypoint = new Waypoint({
        element: waypointElement,
        handler: function (direction) {
          if (direction == 'down') {
            self.show();
          } else {
            self.hide();
          }
        },
        offset: function () {
          return -this.element.clientHeight + 150;
        },
      });
    },

    show: function () {
      var self = this;
      if (self.isHidden) {
        self.isHidden = false;
        self.$el.addClass(self.options.revealClass);
      }
    },

    hide: function () {
      var self = this;
      if (!self.isHidden) {
        self.isHidden = true;
        self.$el.removeClass(self.options.revealClass);
      }
    },

    destroy: function () {
      var self = this;
      self.$el.remove();
    },
  });

  return StickyAddToCart;
})();
window.theme = window.theme || {};

theme.ResponsiveNavList = (function () {
  var selectors = {};

  var defaults = {
    breakPoint: 900,
    overflowItemHtml: '<a href="#">More</a>',
  };

  function ResponsiveNavList(el, options) {
    var settings, lastDocWidth;

    settings = _.defaults(options, defaults);

    lastDocWidth = $(document).width();

    var $list = $(el);
    var container = $list.parent();
    var overflowItem = $(
      '<li class="dropdown hide" style="order:999">' +
        settings.overflowItemHtml +
        '<ul class="dropdown-menu"></ul></li>'
    ).appendTo($list);
    var overflowList = $(overflowItem).find('ul.dropdown-menu');

    var thisWidth = $list[0].scrollWidth;
    var maxWidth = $(container).width();

    $(overflowItem)
      .not(overflowList)
      .on('mouseenter', function () {
        $(this).addClass('active');
      });

    $(overflowItem)
      .not(overflowList)
      .on('mouseleave', function () {
        $(this).removeClass('active');
      });

    function reset() {
      var child = $(overflowList).children();

      //////////

      var count = child.length;
      if (count > 0) {
        for (var i = 0; i < count; i++) {
          $(child[i]).insertBefore($list.children(':last-child'));
        }
      }
      $(overflowItem).addClass('hide');
    }

    function grow() {
      var overflowWidth = $(overflowItem).width();
      var child = $(overflowList).children();

      //////////

      var count = child.length;

      if (count > 0) {
        for (var i = 0; i < count; i++) {
          // move the first dropdown item to end of list
          $(child[i]).removeClass('in-dropdown-menu');
          $(child[i]).insertBefore($list.children(':last-child'));
          thisWidth = $list[0].scrollWidth;
          if (
            (i == count - 1 && thisWidth - overflowWidth > maxWidth) ||
            (i != count - 1 && thisWidth > maxWidth)
          ) {
            $(child[i]).prependTo(overflowList);
            break;
          }
        }
      }

      // Hide the overflow item if it has no children
      if ($(overflowList).children().length == 0) {
        $(overflowItem).addClass('hide');
      }

      return;
    }

    function shrink() {
      var child = $list.children(':not(:last-child)');

      // Do not hide featured items
      child = $(child).filter(function () {
        return $(this).hasClass('featured') ? false : true;
      });

      var count = child.length;
      if (count < 1) return;

      // show the overflow link in case it's been hidden
      $(overflowItem).removeClass('hide');

      $($(container).parent().parent()).css('overflow', 'hidden');
      maxWidth = $(container).width();

      for (var i = count - 1; i >= 0; i--) {
        // move the last item to dropdown
        $(child[i]).prependTo(overflowList);
        $(child[i]).addClass('in-dropdown-menu');

        // recalc width
        thisWidth = $list.width();
        if (thisWidth < maxWidth) break;
      }

      $($(container).parent().parent()).css('overflow', 'visible');
    }

    function refresh() {
      thisWidth = $list.width();
      maxWidth =
        $(container).width() -
        ($(container).find('.navbar-header').width() || 0);
      var docWidth = $(document).width();

      if ($(window).width() < settings.breakPoint) {
        reset();
      } else if (thisWidth > maxWidth) {
        shrink();
      } else if (0 < docWidth - lastDocWidth) {
        grow();
      }
      lastDocWidth = docWidth;
    }

    $(window).resize(_.throttle(refresh, 250)).trigger('resize');
  }

  return ResponsiveNavList;
})();

window.theme = window.theme || {};

var originalOnYouTubePlayerAPIReady = _.noop;

if (typeof onYouTubePlayerAPIReady == 'function') {
  originalOnYouTubePlayerAPIReady = onYouTubePlayerAPIReady;
}

window.onYouTubePlayerAPIReady = function () {
  var youTubeService = _.find(theme.videoServiceAPIs, { name: 'youtube' });
  youTubeService.runOnReadyQueue();
  originalOnYouTubePlayerAPIReady();
};

theme.videoServiceAPIs = (function () {
  function PlayerServiceAPI(data) {
    _.extend(this, data);
    this._isloaded = false;
    this._isloading = false;
    this._onReadyQueue = [];
  }

  PlayerServiceAPI.prototype = _.extend(PlayerServiceAPI.prototype, {
    load: function (callback) {
      var self = this;

      if (this._isloaded || this._checkIsLoaded()) {
        callback();
        return;
      }

      this._onReadyQueue.push(callback);

      if (this._isloading) {
        return;
      }

      loadJS(this.url, function () {
        if (self.name == 'vimeo') {
          self.runOnReadyQueue();
        }
      });
    },

    runOnReadyQueue: function () {
      this._isloaded = true;

      while (this._onReadyQueue.length) {
        this._onReadyQueue.shift().call();
      }
    },
  });

  return [
    new PlayerServiceAPI({
      name: 'youtube',
      url: 'https://www.youtube.com/iframe_api',
      newPlayer: function (data) {
        return new YT.Player(data.node.id, {
          videoId: data.videoID,
          playerVars: {
            modestbranding: 1,
            rel: 0,
            iv_load_policy: 3,
            showinfo: 0,
            wmode: 'opaque',
            branding: 0,
            autohide: 0,
          },
          events: {
            onReady: data.onPlayerReady || _.noop,
            onStateChange: data.onPlayerStateChange || _.noop,
          },
        });
      },
      _checkIsLoaded: function () {
        return typeof YT != 'undefined' && YT && YT.loaded;
      },
      isPlaying: function (event) {
        return event.data == YT.PlayerState.PLAYING;
      },
      play: function (player) {
        player.playVideo();
      },
      pause: function (player) {
        player.pauseVideo();
      },
    }),

    // TODO
    // new PlayerServiceAPI({
    //   name: 'vimeo',
    //   url: 'https://player.vimeo.com/api/player.js',
    //   newPlayer: function(data) {
    //     var player = new Vimeo.Player(data.node, {
    //       // TODO
    //     });
    //     player.on('play', function() {
    //       if (data.onPlayerStateChange) {
    //         data.onPlayerStateChange();
    //       }
    //     });
    //     if (data.onPlayerReady) {
    //       data.onPlayerReady();
    //     }
    //   },
    //   _checkIsLoaded: function() {
    //     var scriptElement;
    //     scriptElement = document.querySelectorAll('script[src="' + this.url + '"]');
    //     if (scriptElement.length > 0) {
    //       return true;
    //     }
    //     return false;
    //   },
    //   play: function(player) {
    //     player.playVideo();
    //   },
    //   pause: function(player) {
    //     player.pauseVideo();
    //   }
    // }),
  ];
})();

theme.Video = (function () {
  var SELECTORS = {
    placeholder: '.video__placeholder',
  };

  function Video(container) {
    this.container = container;
    this.videoID = container.dataset.videoId;
    this.autoPlay = container.dataset.videoAutoplay == 'true';
    this.placeholder = this.container.querySelector(SELECTORS.placeholder);

    if (this.container.dataset.placeholderOverlay) {
      this.additionalOverlay = document.querySelector(
        this.container.dataset.placeholderOverlay
      );
      // this.additionalOverlay.classList.add('video-is-paused');
    }

    var playerServiceName = container.dataset.videoType;

    this._loadPlayerServiceAPI(playerServiceName);
  }

  Video.prototype = _.extend(Video.prototype, {
    _loadPlayerServiceAPI: function (playerServiceName) {
      var self = this;

      var type, source;

      this.playerService = _.find(theme.videoServiceAPIs, {
        name: playerServiceName,
      });

      if (!this.playerService) {
        console.error(new Error('No service found'));
        return;
      }

      this.playerService.load(this._onServiceLoad.bind(this));
    },

    _onServiceLoad: function () {
      if (this.autoPlay) {
        this._bindWaypoint();
      } else {
        if (this.placeholder) {
          this._bindPlaceholder();
        } else {
          this._createPlayer();
        }
      }
    },

    _bindWaypoint: function () {
      var self = this;

      new Waypoint({
        element: this.container,
        offset: '100%',
        handler: function () {
          self._createPlayer(self.play.bind(self));
          this.destroy();
        },
      });
    },

    _bindPlaceholder: function () {
      var self = this;

      this.placeholder.addEventListener('click', function () {
        self._addPlaceholderLoadingState();
        self._createPlayer(self.play.bind(self));
      });
    },

    revealVideo: function () {
      this.container.dataset.videoVisible = true;
      this._removePlaceholderLoadingState();
    },

    _createPlayer: function (onPlayerReady) {
      var videoNode = document.getElementById('video-' + this.videoID);

      this.player = this.playerService.newPlayer({
        node: videoNode,
        videoID: this.videoID,
        onPlayerReady: onPlayerReady || _.noop,
        onPlayerStateChange: this._onStateChange.bind(this),
      });
    },

    _onStateChange: function (event) {
      if (this.playerService.isPlaying(event)) {
        this.revealVideo();

        if (this.additionalOverlay) {
          this.additionalOverlay.classList.add('video-is-playing');
          this.additionalOverlay.classList.remove('video-is-paused');
        }
      } else {
        if (this.additionalOverlay) {
          this.additionalOverlay.classList.add('video-is-paused');
          this.additionalOverlay.classList.remove('video-is-playing');
        }
      }
    },

    _addPlaceholderLoadingState: function () {
      this.container.classList.add('loading');
    },

    _removePlaceholderLoadingState: function () {
      this.container.classList.remove('loading');
    },

    play: function () {
      try {
        this.playerService.play(this.player);
      } catch (e) {
        console.error(e);
      }
    },
  });

  return Video;
})();

var videoContainers = document.getElementsByClassName('video');

theme.videos = [];

_.each(videoContainers, function (videoContainer) {
  var video = new theme.Video(videoContainer);
  theme.videos.push(video);
});
window.theme = window.theme || {};

theme.SearchSuggestion = (function () {
  function SearchSuggestions() {
    this.template = theme.utils.getTemplate('search-suggestions');

    if (!this.template) {
      return;
    }

    this.el = theme.utils.createElementFromHTML(this.template);

    tinybind.bind(this.el, {
      search: theme.current.search,
      shop: shop,
      Currency: Currency,
    });
  }

  SearchSuggestions.prototype = _.extend(SearchSuggestions.prototype, {
    getSuggestions: function () {
      this.el.style.display = '';
      return this.el;
    },
  });

  return new SearchSuggestions();
})();

/*================ Sections ================*/
window.theme = window.theme || {};

theme.Cart = (function () {
  var selectors = {
    edit: '.js-edit-toggle',
  };
  var config = {
    showClass: 'cart__update--show',
    showEditClass: 'cart__edit--active',
    cartNoCookies: 'cart--no-cookies',
  };

  function Cart(container) {
    this.$container = $(container);
    this.$edit = $(selectors.edit, this.$container);

    if (!this.cookiesEnabled()) {
      this.$container.addClass(config.cartNoCookies);
    }

    this.$edit.on('click', this._onEditClick.bind(this));
  }

  Cart.prototype = _.assignIn({}, Cart.prototype, {
    onUnload: function () {
      this.$edit.off('click', this._onEditClick);
    },

    _onEditClick: function (evt) {
      var $evtTarget = $(evt.target);
      var $updateLine = $('.' + $evtTarget.data('target'));

      $evtTarget.toggleClass(config.showEditClass);
      $updateLine.toggleClass(config.showClass);
    },

    cookiesEnabled: function () {
      var cookieEnabled = navigator.cookieEnabled;

      if (!cookieEnabled) {
        document.cookie = 'testcookie';
        cookieEnabled = document.cookie.indexOf('testcookie') !== -1;
      }
      return cookieEnabled;
    },
  });

  return Cart;
})();

window.theme = window.theme || {};

theme.Filters = (function () {
  var constants = {
    SORT_BY: 'sort_by',
  };
  var selectors = {
    filterSelection: '.collection-filters__dropdown--filter',
    sortSelection: '.collection-filters__dropdown--sort',
    defaultSort: '.collection-filters__default-sort',
    filterPlaceholderDesktop: '.collection-filters-placeholder--desktop',
    filterPlaceholderMobile: '.collection-filters-placeholder--mobile',
    filterContentDesktop: '.collection-filters-content--desktop',
    filterContentMobile: '.collection-filters-content--mobile',
    filterSection: '[data-section-type="collection-filters"]',
    filterSectionWrapper: '#shopify-section-collection-filters',
    collectionSlideshows: '.sub-collection__slideshow',
    collectionSubHeader: '.collection__sub-header',
  };

  function Filters(container) {
    var $container = (this.$container = $(container));

    var self = this;

    this.initFilters();

    this.$filterSelects = $(selectors.filterSelection, $container);
    this.$sortSelect = $(selectors.sortSelection, $container);
    this.$selects = $(selectors.filterSelection, $container).add(
      $(selectors.sortSelection, $container)
    );

    var currentUrl = window.location.pathname;
    if (currentUrl.indexOf('collections/all') > -1 || currentUrl.indexOf('collections/bundles') > -1){
      this.manageCollectionsAll()
    }


    this.defaultSort = this._getDefaultSortValue();
    this._resizeSelect(this.$selects);
    this.$selects.removeClass('hidden');

    this.$filterSelects.on('change', this._onFilterChange.bind(this));
    this.$sortSelect.on('change', this._onSortChange.bind(this));

    this.$collectionSlideshows = $(selectors.collectionSlideshows);
    this.$collectionSlideshows.each(function () {
      var $slideshow = $(this);

      $slideshow.on('init', function (evt, slick) {
        self.appendSlickScrollbar(slick);
      });

      $slideshow.on('beforeChange', function (
        evt,
        slick,
        currentSlide,
        nextSlide
      ) {
        var activeSlidesCount = slick.$slides.filter('.slick-active').length;
        var currentMarkerOffset = (nextSlide * 100) / activeSlidesCount;
        $('.slick-scrollbar-mark', slick.$slider.next()).css(
          'transform',
          'translateX(' + currentMarkerOffset + '%)'
        );
      });

      new theme.Slideshow($slideshow);
    });

    this.collectionSubHeader = container.querySelector(selectors.collectionSubHeader);
    if (this.collectionSubHeader) {
      new StickyState(this.collectionSubHeader, {
        scrollClass: {
          down: 'sticky--down',
          up: 'sticky--up',
          none: 'sticky--none',
          persist: true,
        },
      });
    }
    

    $('#sub-collections-select').on('change', function () {
      var target = this.options[this.selectedIndex].value;
      if (target) {
        theme.scrollTo.target(target);
      }
    });
  }

  Filters.prototype = _.assignIn({}, Filters.prototype, {

    manageCollectionsAll: function(){
      const self = this;
      let boostFilterContainer = document.querySelector('.boost-pfs-filter-products');
      let subCollectionsSliders = document.querySelector('.subcollection-wrapper');
      let subCollectionsToolbar = document.querySelector('[data-all-collection]');
      checkDisplayRules();

      window.addEventListener('boost-products-updated',function(){
        checkDisplayRules();
      });

      window.addEventListener('boost-filter-updated',function(){
        let boostClearButton = document.querySelector('.boost-pfs-filter-clear-all');
        boostClearButton.addEventListener('click', function(){
          hideBoost();
        });
      });

      function checkDisplayRules(){
        currentQueryParams = theme.utils.getQueryParams();

        if (currentQueryParams && Object.keys(currentQueryParams).join(',').indexOf('pf') > -1){
          hideSubCollections();
        }
        else {
          hideBoost();
          
        }
      }
      function hideBoost(){
        boostFilterContainer.classList.add('hidden');
        subCollectionsSliders.classList.remove('hidden');
        subCollectionsToolbar.classList.remove('hidden');
      }

      function hideSubCollections(){
        subCollectionsSliders.classList.add('hidden');
        subCollectionsToolbar.classList.add('hidden');
        boostFilterContainer.classList.remove('hidden');
      }
      
    },

    appendSlickScrollbar: function (slick) {
      var existingScrollBar = slick.$slider.next('.slick-scrollbar');
      if (existingScrollBar) {
        $(existingScrollBar).remove();
      }

      var activeSlidesCount = slick.$slides.filter('.slick-active').length;

      if (activeSlidesCount != slick.$slides.length) {
        var currentMarkerOffset = slick.currentSlide * 100;
        var scrollbarMarkerWidth =
          (1 / slick.slideCount) * 100 * activeSlidesCount;
        slick.$slider.after(
          '<div class="slick-scrollbar"><div class="slick-scrollbar-mark" style="width: ' +
            scrollbarMarkerWidth +
            '%"></div></div>'
        );
        $('.slick-scrollbar-mark', slick.$slider).css(
          'transform',
          'translateX(' + currentMarkerOffset + '%)'
        );
      }
    },

    /**
     * Initialises filters
     */
    initFilters: function () {
      var self = this;
      var $filterSectionWrapper = $(selectors.filterSectionWrapper);

      var $filterContentMobile = $(
        selectors.filterContentMobile,
        $filterSectionWrapper
      ).html();
      var $filterContentDesktop = $(
        selectors.filterContentDesktop,
        $filterSectionWrapper
      ).html();

      $(selectors.filterPlaceholderMobile, this.$container).replaceWith(
        $filterContentMobile
      );
      $(selectors.filterPlaceholderDesktop, this.$container).replaceWith(
        $filterContentDesktop
      );
    },

    _onSortChange: function (evt) {
      var sort = this._sortValue();
      if (sort.length) {
        window.location.search = sort;
      } else {
        // clean up our url if the sort value is blank for default
        window.location.href = window.location.href.replace(
          window.location.search,
          ''
        );
      }
      this._resizeSelect($(evt.target));
    },

    _onFilterChange: function (evt) {
      // window.location.href = $(evt.target).val() + window.location.search;
      var newLocation = $(evt.target).val();
      if (window.location.search != '') {
        var currentQueryParams = theme.utils.getQueryParams();
        for (var k in currentQueryParams) {
          if (currentQueryParams.hasOwnProperty(k)) {
            newLocation = theme.utils.updateQueryStringParameter(
              k,
              currentQueryParams[k],
              newLocation
            );
          }
        }
        var newQueryParams = theme.utils.getQueryParams(newLocation);
        for (var k in newQueryParams) {
          if (newQueryParams.hasOwnProperty(k)) {
            newLocation = theme.utils.updateQueryStringParameter(
              k,
              newQueryParams[k],
              newLocation
            );
          }
        }
        window.location.href = newLocation;
      }
      this._resizeSelect($(evt.target));
    },

    _getSortValue: function () {
      return this.$sortSelect.val() || this.defaultSort;
    },

    _getDefaultSortValue: function () {
      return $(selectors.defaultSort, this.$container).val();
    },

    _sortValue: function () {
      var sort = this._getSortValue();
      var query = '';

      if (sort !== this.defaultSort) {
        query = constants.SORT_BY + '=' + sort;
      }

      return query;
    },

    _resizeSelect: function ($selection) {
      $selection.each(function () {
        var $this = $(this);
        var arrowWidth = 20;
        // create test element
        var text = $this.find('option:selected').text();
        var $test = $('<span>').html(text);

        // add to body, get width, and get out
        $test.appendTo('body');
        var width = $test.width();
        $test.remove();

        // set select width
        $this.width(width + 5 + arrowWidth);
        $this.parent().addClass('ready');
      });
    },

    onUnload: function () {
      this.$filterSelects.off('change', this._onFilterChange);
      this.$sortSelect.off('change', this._onSortChange);
    },
  });

  return Filters;
})();

theme.HeaderSection = (function () {
  var settings = {
    stickyHeader: false,
  };

  function Header(container) {
    var $container, stickyHeaderEl;

    theme.header = new theme.Header(container);
    theme.Search.init();

    console.info('Making header sticky');

    $container = $(container);

    if (settings.stickyHeader) {
      stickyHeaderEl = $container.parent().get(0);
      stickyHeaderEl.classList.add('sticky');
      theme.stickyHeader = new StickyState(stickyHeaderEl, {
        scrollClass: {
          down: 'sticky--down',
          up: 'sticky--up',
          none: 'sticky--none',
          persist: true,
        },
      });

      theme.stickyHeader.on('sticky:on', function (e) {
        document.body.classList.add('sticky-header-active');
      });

      theme.stickyHeader.on('sticky:off', function (e) {
        document.body.classList.remove('sticky-header-active');
      });
    }
  }

  Header.prototype = _.assignIn({}, Header.prototype, {
    onUnload: function () {
      theme.Header.unload();
    },
  });

  return Header;
})();

theme.Maps = (function () {
  var config = {
    zoom: 14,
  };
  var apiStatus = null;
  var mapsToLoad = [];
  var key = theme.mapKey ? theme.mapKey : '';

  function Map(container) {
    this.$container = $(container);

    if (apiStatus === 'loaded') {
      this.createMap();
    } else {
      mapsToLoad.push(this);

      if (apiStatus !== 'loading') {
        apiStatus = 'loading';
        if (typeof window.google === 'undefined') {
          $.getScript(
            'https://maps.googleapis.com/maps/api/js?key=' + key
          ).then(function () {
            apiStatus = 'loaded';
            initAllMaps();
          });
        }
      }
    }
  }

  function initAllMaps() {
    // API has loaded, load all Map instances in queue
    $.each(mapsToLoad, function (index, instance) {
      instance.createMap();
    });
  }

  function geolocate($map) {
    var deferred = $.Deferred();
    var geocoder = new google.maps.Geocoder();
    var address = $map.data('address-setting');

    geocoder.geocode({ address: address }, function (results, status) {
      if (status !== google.maps.GeocoderStatus.OK) {
        deferred.reject(status);
      }

      deferred.resolve(results);
    });

    return deferred;
  }

  Map.prototype = _.assignIn({}, Map.prototype, {
    createMap: function () {
      var $map = this.$container.find('.map-section__container');

      return geolocate($map)
        .then(
          function (results) {
            var mapOptions = {
              zoom: config.zoom,
              center: results[0].geometry.location,
              disableDefaultUI: true,
            };

            var map = (this.map = new google.maps.Map($map[0], mapOptions));
            var center = (this.center = map.getCenter());

            //eslint-disable-next-line no-unused-vars
            var marker = new google.maps.Marker({
              map: map,
              position: map.getCenter(),
            });

            google.maps.event.addDomListener(
              window,
              'resize',
              $.debounce(250, function () {
                google.maps.event.trigger(map, 'resize');
                map.setCenter(center);
              })
            );
          }.bind(this)
        )
        .fail(function () {
          var errorMessage;

          switch (status) {
            case 'ZERO_RESULTS':
              errorMessage = theme.strings.addressNoResults;
              break;
            case 'OVER_QUERY_LIMIT':
              errorMessage = theme.strings.addressQueryLimit;
              break;
            default:
              errorMessage = theme.strings.addressError;
              break;
          }

          $map
            .parent()
            .addClass('page-width map-section--load-error')
            .html('<div class="errors text-center">' + errorMessage + '</div>');
        });
    },

    onUnload: function () {
      google.maps.event.clearListeners(this.map, 'resize');
    },
  });

  return Map;
})();

// Global function called by Google on auth errors.
// Show an auto error message on all map instances.
// eslint-disable-next-line camelcase, no-unused-vars
function gm_authFailure() {
  $('.map-section').addClass('map-section--load-error');
  $('.map-section__container').remove();
  $('.map-section__link').remove();
  $('.map-section__overlay').after(
    '<div class="errors text-center">' + theme.strings.authError + '</div>'
  );
}

/**
 * Product Template Script
 * ------------------------------------------------------------------------------
 * A file that contains scripts highly couple code to the Product template.
 *
 * @namespace product
 */

theme.Product = (function () {
  var selectors = {
    addToCart: '[data-add-to-cart]',
    addToCartText: '[data-add-to-cart-text]',
    comparePrice: '[data-compare-price]',
    comparePriceText: '[data-compare-text]',
    originalSelectorId: '.product__details [data-product-select]',
    priceWrapper: '[data-price-wrapper]',
    productFeaturedImage: '[data-product-featured-image]',
    productJson: '[data-product-json-main]',
    productSku: '[data-product-variant-sku]',
    productPrice: '[data-product-price]',
    productPriceWithDiscount: '[data-product-price-discount]',
    productImageWrap: '[data-product-images-wrap]',
    productImageContainer: '[data-product-images]',
    productImages: '[data-product-image]',
    productActiveImage: '[data-product-active-image]',
    productThumbContainer: '[data-product-thumbnails]',
    productThumbs: '[data-product-thumbnail]',
    singleOptionSelector: '.product__details [data-single-option-selector]',
    singleOptionValue: '[data-single-option-value]',
    productQtyWrapper: '.product-form__item--quantity',
    optionSelector: '[data-option-selector]',
    productForm: 'form.product-form',
    relatedProducts: '.product__related-products',
    relatedArticles: '.product__related-articles',
    quantitySelector: '#Quantity',
    stickyAddToCartSibling: '.site-header-lower',
    productFormSummary: '.product-form__summary',
    productDetails: '.product-single__details',
    subscriptionSelector: 'input[name="purchase_type"]',
  };

  /**
   * Product section constructor. Runs on page load as well as Theme Editor
   * `section:load` events.
   * @param {string} container - selector for the section container DOM element
   */
  function Product(container) {
    this.container = container;
    this.$container = $(container);
    var sectionId = this.$container.attr('data-section-id');

    this.settings = {
      // Breakpoints from src/styles/settings/variables.scss.liquid // $grid-breakpoints
      mediaQuerySmall: theme.settings.mediaQuery.small,
      mediaQueryMediumUp: theme.settings.mediaQuery.mediumUp,
      enableHistoryState: this.$container.data('enable-history-state') || false,
      sectionId: sectionId,
      sliderActive: false,
      bpSmall: false,
      zoomEnabled: false,
    };
    this.namespace = '.product';

    // Stop parsing if we don't have the product json script tag when loading
    // section in the Theme Editor
    if (
      !$(selectors.productJson, this.$container).html() &&
      !theme.current.product
    ) {
      return;
    }

    this.$featuredImage = $(selectors.productFeaturedImage, this.$container);
    this.product = JSON.parse($(selectors.productJson, this.$container).html());
    this.settings.imageSize = this.$featuredImage.length
      ? slate.Image.imageSize(this.$featuredImage.attr('src'))
      : 0;
    this.settings.zoomEnabled = $(selectors.productFeaturedImage).hasClass(
      'js-zoom-enabled'
    );

    if (window.theme.subscription && window.theme.subscription.config) {
      this.initSubscriptionProducts();
    }

    this.related = {};

    // this.initBreakpoints();

    this.initImageSlider();
    this.initGallery();
    this.initVariants();
    // this.initStickyAddToCart();
    // this.initQuantitySelectors();
    this.getRelatedProducts();
    this.initRelatedArticles();
    this.filterImageSlides();

    new theme.TabsGroup($('#tabs--product'), {
      breakpoint: 0,
      activeTab: 0,
    });

    var readMoreLink =
      '<button aria-hidden="true" focusable="false" role="presentation" class="read-more">Read more <svg class="icon icon-fa-caret-down" viewBox="0 0 1792 1792" xmlns="http://www.w3.org/2000/svg"><path d="M1408 704q0 26-19 45l-448 448q-19 19-45 19t-45-19L403 749q-19-19-19-45t19-45 45-19h896q26 0 45 19t19 45z"/></svg></button>';
    var productDescriptionReadMoreHeight = 200;

    // Only enable readmore if there's a decent amount of text to hide
    if (
      $('.product__description').innerHeight() >=
      productDescriptionReadMoreHeight * 1.175
    ) {
      $('.product__description').readmore({
        speed: 75,
        collapsedHeight: productDescriptionReadMoreHeight,
        heightMargin: 20,
        moreLink: readMoreLink,
        lessLink: false,
        beforeToggle: function (trigger, element, expanded) {
          $(element).toggleClass('readmore-expanded');
        },
      });
    }
  }

  Product.prototype = $.extend({}, Product.prototype, {
    get: function () {
      return this.product;
    },

    onRelatedProductsReceived: function () {
      this.initRelatedProducts();
      // this.initUpsellModal();
    },

    initSubscriptionProducts: function () {
      // variant ids to exclude from subscription option
      this.excludedVariantIds =
        window.theme.subscription &&
        window.theme.subscription.config &&
        window.theme.subscription.config.excludedVariantIds
          ? window.theme.subscription.config.excludedVariantIds
          : [];

      // default purchase type
      this.subscriptionPurchaseType = 'onetime';
    },

    initUpsellModal: function () {
      var addToCartButtons,
        addToCartButton,
        modalTriggerClass,
        self = this;

      modalTriggerClass = 'open-product-recomendations-modal';
      addToCartButtons = this.container.querySelectorAll(selectors.addToCart);

      var i = addToCartButtons.length;

      while (i--) {
        addToCartButton = addToCartButtons[i];

        delete addToCartButton.dataset.opensCartDrawer;

        addToCartButton.addEventListener('click', function () {
          document.body.classList.add(modalTriggerClass);
        });
      }

      function onRequestComplete(event, cart) {
        if (!document.body.classList.contains(modalTriggerClass)) {
          return;
        }

        document.body.classList.remove(modalTriggerClass);

        if (cart.errors.length) {
          return;
        }

        self.openUpsellModal();
      }

      $(document).on('cart.requestComplete', onRequestComplete);
    },

    openUpsellModal: function () {
      var template,
        self = this;

      template = theme.utils.getTemplate('product-upsell-modal');

      function modalAfterOpen() {
        // bind tinybind

        tinybind.bind(this.$content, {
          product: self.product,
          related: {
            products: self.related.products.slice(0, 2),
          },
        });
      }

      new theme.Modal(template, {
        featherlightOptions: {
          afterOpen: modalAfterOpen,
        },
      });
    },

    getRelatedProducts: function (callback) {
      this.related.products = [];

      var url,
        limit,
        self = this;

      limit = 8;
      url =
        '/recommendations/products.json?product_id=' +
        this.product.id +
        '&limit=' +
        limit;

      function onComplete(data) {
        self.related.products = data.products;

        var i = self.related.products.length;

        while (i--) {
          if (
            self.related.products[i].images.length &&
            !self.related.products[i].image
          ) {
            self.related.products[i].image = self.related.products[i].images[0];
          }
        }

        self.onRelatedProductsReceived();
      }

      $.getJSON(url, onComplete);
    },

    initRelatedProducts: function () {
      const self = this;
      //todo: inject related products
      var relatedProductsEl = document.querySelector('.recently-viewed-products__list');

      setTimeout(function(){
        //     var $st = $('.pagination');
        var $slickEl = $('.recently-viewed-products__list');

        $slickEl.on('init reInit afterChange', function (event, slick, currentSlide, nextSlide) {
          var i = (currentSlide ? currentSlide : 0) + 1;
          //   $st.text(i + ' of ' + slick.slideCount);
        });

        $slickEl.slick({
          centerMode: false,
          centerPadding: '200px',
          slidesToShow: self.related.products.length < 3 ? self.related.products.length : 3,
          focusOnSelect: false,
          dots: false,
          infinite: false,
          responsive: [
            {
              breakpoint: 768,
              settings: {
                arrows: false,
                centerMode: false,
                centerPadding: '40px',
                slidesToShow: self.related.products.length < 3 ? self.related.products.length : 3
              }
            },
            {
              breakpoint: 480,
              settings: {
                arrows: false,
                centerMode: false,
                centerPadding: '40px',
                slidesToShow: 2
              }
            }
          ]
        });
      },4000)
      

    },

    initRelatedArticles: function () {
      var relatedArticlesEl = document.querySelector(selectors.relatedArticles);
      new theme.RelatedItems(relatedArticlesEl, {
        type: 'articles',
      });
    },

    initStickyAddToCart: function () {
      var stickyAddToCartTemplate = theme.utils.getTemplate(
        'product-sticky-add-to-cart'
      );

      if (!stickyAddToCartTemplate) {
        return;
      }

      this.stickyAddToCartEl = theme.utils.createElementFromHTML(
        stickyAddToCartTemplate
      );

      var sibling = document.querySelector(selectors.stickyAddToCartSibling);

      // Append element after sibling
      sibling.parentNode.insertBefore(
        this.stickyAddToCartEl,
        sibling.nextSibling
      );

      var self = this;

      new Waypoint({
        element: document.querySelector(selectors.productDetails),
        handler: function (direction) {
          if (direction == 'down') {
            self.stickyAddToCartEl.children[0].classList.remove('retract');
            document.body.classList.add('show-product-sticky');
          } else {
            self.stickyAddToCartEl.children[0].classList.add('retract');
            document.body.classList.remove('show-product-sticky');
          }
        },
        offset: function () {
          return -this.element.clientHeight + 100;
        },
      });

      document
        .querySelector('header')
        .classList.add('header--sticky-add-to-cart');
    },

    /**
     * Uses enquire.js to handle breakpoint related actions
     */
    // initBreakpoints: function() {
    // var self = this;

    // enquire.register(this.settings.mediaQuerySmall, {
    //   match: function() {
    //     self.settings.bpSmall = true;
    //   },
    //   unmatch: function() {
    //       self.settings.bpSmall = false;
    //   }
    // });

    // enquire.register(this.settings.mediaQueryMediumUp, {
    //   match: function() {

    //   }
    // });
    // },

    initQuantitySelectors: function () {
      var elem = document.querySelector(selectors.quantitySelector);

      if (!elem) {
        return;
      }

      var quantitySelector = new theme.QuantitySelector(elem);
    },

    /**
     * Creates linked sliders for product main and thumb images
     */
    initImageSlider: function () {
      var thumbOptions = {
        slidesToShow: 5,
        swipeToSlide: true,
        infinite: true,
        asNavFor: selectors.productImageContainer,
        focusOnSelect: true,
        rows: 0,
        responsive: [
          {
            breakpoint: 992,
            settings: {
              slidesToShow: 5,
            },
          },
          {
            breakpoint: 768,
            settings: {
              slidesToShow: 5,
            },
          },
          {
            breakpoint: 600,
            settings: {
              slidesToShow: 4,
            },
          },
          {
            breakpoint: 480,
            settings: {
              slidesToShow: 3,
            },
          },
        ],
      };

      var mainOptions = {
        slidesToShow: 1,
        slidesToScroll: 1,
        swipe: true,
        arrows: true,
        infinite: true,
        focusOnSelect: false,
        fade: false,
        adaptiveHeight: false,
        lazyLoad: 'progressive',
        rows: 0,
        dots: true,
        prevArrow:
          selectors.productImageContainer + ' ~ .product-images__prev-btn',
        nextArrow:
          selectors.productImageContainer + ' ~ .product-images__next-btn',
        responsive: [
          {
            breakpoint: 768,
            settings: {
              arrows: true,
              fade: false,
              dots: true,
            },
          },
        ],
      };

      $activeProductImage = $(selectors.productActiveImage).first();
      if ($activeProductImage.length > 0) {
        var firstSlide = $activeProductImage.index() || 0;
        mainOptions.initialSlide = firstSlide;
      }

      if (
        $(selectors.productImageWrap, this.$container).is('[data-vertical]')
      ) {
        thumbOptions = $.extend({}, thumbOptions, {
          vertical: true,
          verticalSwiping: true,
        });
      }

      if (this.product.images.length > 1) {
        $(selectors.productThumbContainer).slick(thumbOptions);
      }

      $(selectors.productImageContainer).slick(mainOptions);

      this.settings.sliderActive = true;
    },

    /**
     * Sets up product image lightbox with Photoswipe.js
     */
    initGallery: function () {
      var self = this;

      if (self.settings.zoomEnabled) {
        var pswpElement = document.querySelectorAll('.pswp')[0];
        var items = $('[data-pswp-items]').data('pswp-items');

        $(selectors.productImageWrap, this.$container).on(
          'click',
          '.zoom-js',
          function (e) {
            e.preventDefault();
            e.stopImmediatePropagation();

            var thumbnail = $(this).find('img')[0];
            options = {
              index: $(this).data('index'),
              barsSize: { top: 0, bottom: 0 },
              captionEl: false,
              fullscreenEl: false,
              shareEl: false,
              bgOpacity: 0.96,
              tapToClose: true,
              tapToToggleControls: false,
              history: false,

              allowPanToNext: false,
              arrowKeys: false,
              arrowEl: false,

              getThumbBoundsFn: function (index) {
                var pageYScroll =
                    window.pageYOffset || document.documentElement.scrollTop,
                  rect = thumbnail.getBoundingClientRect(),
                  thumbInfo = theme.utils.getImgSizeInfo(thumbnail);
                return {
                  x: rect.left + thumbInfo.left,
                  y: rect.top + pageYScroll,
                  w: thumbInfo.width,
                };
              },
            };

            var gallery = new PhotoSwipe(
              pswpElement,
              PhotoSwipeUI_Default,
              items,
              options
            );

            var realViewportWidth,
              useLargeImages = false,
              firstResize = true,
              imageSrcWillChange;

            // gettingData event fires each time PhotoSwipe retrieves image source & size
            gallery.listen('gettingData', function (index, item) {
              realViewportWidth =
                gallery.viewportSize.x * window.devicePixelRatio;

              // Set image source & size based on real viewport width
              if (useLargeImages) {
                item.src = item.originalImage.src;
                item.w = item.originalImage.w;
                item.h = item.originalImage.h;
                item.msrc = item.originalImage.msrc;
              } else {
                if (realViewportWidth > 1024) {
                  item.w = 1600;
                } else if (realViewportWidth > 768) {
                  item.w = 1024;
                } else if (realViewportWidth > 640) {
                  item.w = 768;
                } else if (realViewportWidth > 480) {
                  item.w = 640;
                } else {
                  item.w = 480;
                }
                item.w = Math.min(item.w, item[index].originalWidth);
                item.h = Math.round(item.w / item[index].ratio);

                var itemSrcTemplate = decodeURI(item[index].src);
                item.src = itemSrcTemplate.replace('{width}', item.w);
                // item.msrc = itemSrcTemplate.replace('{width}', 180);

                var $imageElem = $(
                  selectors.productImageContainer +
                    ' [data-slick-index="' +
                    index +
                    '"]:not(.slick-cloned) img'
                );
                item.msrc =
                  $imageElem.prop('currentSrc') ||
                  $imageElem.attr('src') ||
                  item[index].msrc;
              }

              // It doesn't really matter what will you do here,
              // as long as item.src, item.w and item.h have valid values.
              //
              // Just avoid http requests in this listener, as it fires quite often
            });

            // gallery.listen('close', function() {
            //   if (self.settings.sliderActive) {
            //     $(selectors.productImageContainer).slick('slickGoTo', this.getCurrentIndex());
            //   }
            // });

            gallery.init();
          }
        );
      }
    },

    /**
     * Handles change events from the variant inputs
     */
    initVariants: function () {
      var options = {
        $container: this.$container,
        enableHistoryState:
          this.$container.data('enable-history-state') || false,
        singleOptionSelector: selectors.singleOptionSelector,
        originalSelectorId: selectors.originalSelectorId,
        product: this.product,
        subscriptionSelector: selectors.subscriptionSelector,
      };

      this.variants = new slate.Variants(options);

      this.$container.on(
        'subscriptionPurchaseTypeChange' + this.namespace,
        this.updateProductOptions.bind(this)
      );
      this.$container.on(
        'subscriptionPurchaseTypeChange' + this.namespace,
        this.updateDynamicCheckoutButtons.bind(this)
      );
      this.$container.on(
        'variantChange' + this.namespace,
        this.updateAddToCartState.bind(this)
      );
      this.$container.on(
        'variantChange' + this.namespace,
        this.filterImageSlides.bind(this)
      );
      this.$container.on(
        'variantImageChange' + this.namespace,
        this.updateProductImage.bind(this)
      );
      this.$container.on(
        'variantChange' + this.namespace,
        this.updateProductImage.bind(this)
      );
      this.$container.on(
        'variantPriceChange' + this.namespace,
        this.updateProductPrices.bind(this)
      );
      this.$container.on(
        'variantOptionChange' + this.namespace,
        this.updateProductOptions.bind(this)
      );
      this.$container.on(
        'variantSKUChange' + this.namespace,
        this.updateSKU.bind(this)
      );
    },

    /**
     * Filters product images based on variant selected
     *
     * @param {event} Takes a triggered event including variant selected. Variant defaults to currentVariant
     */
    filterImageSlides: function (evt) {
      // Only filter if there's images to filter
      if (this.product.images.length > 1) {
        var variant =
          evt && evt.variant ? evt.variant : this.variants.currentVariant;

        var currentVariantIndex =
          _.findIndex(this.product.variants, { id: variant.id }) + 1;
        var filterSelector = '';
        filterSelector += '[data-image-for=""]:not([data-variant-index]),';
        filterSelector +=
          '[data-variant-index^="' + currentVariantIndex + ',"],';
        filterSelector +=
          '[data-variant-index*="' + currentVariantIndex + ',"],';
        filterSelector +=
          '[data-variant-index*="' + currentVariantIndex + ']"],';
        filterSelector += '[data-image-for="' + variant.id + '"]';

        var $imageSlider = $(selectors.productImageContainer);
        var $thumbSlider = $(selectors.productThumbContainer);

        $imageSlider.slick('slickSetOption', 'speed', 0);
        $thumbSlider.slick('slickSetOption', 'speed', 0);

        $imageSlider.slick('slickUnfilter');
        $thumbSlider.slick('slickUnfilter');

        $imageSlider.slick('slickFilter', filterSelector);
        $thumbSlider.slick('slickFilter', filterSelector);

        $imageSlider[0].slick.slickGoTo(0);
        if ($thumbSlider.length) {
          $thumbSlider[0].slick.slickGoTo(0);
        }
        // var firstSlideIndex = 0;
        // $imageSlider.slick('slickGoTo', firstSlideIndex, true);
        // $thumbSlider.slick('slickGoTo', firstSlideIndex, true);

        // $imageSlider.slick('slickSetOption', 'infinite', false);
        // $thumbSlider.slick('slickSetOption', 'infinite', false);

        // var firstSlideIndex = $('.slick-slide:not(.slick-cloned)', $imageSlider).first().index();

        // $('[data-image-for="' + variant.id + '"]:not(.slick-cloned)', $imageSlider).first().index() || 0;
        // var slickIndex = $('.slick-slide:not(.slick-cloned)', $imageSlider).eq(firstSlideIndex).data();

        // $('.slick-slide:not(.slick-cloned)', $imageSlider).each(function(index){
        //   if ($(this).is('[data-image-for="' + variant.id + '"]')) {
        //     firstSlideIndex = index;
        //     return false;
        //   }
        // });

        // $imageSlider.slick('slickSetOption', 'infinite', true);
        // $thumbSlider.slick('slickSetOption', 'infinite', true);

        $imageSlider.slick('slickSetOption', 'speed', 300);
        $thumbSlider.slick('slickSetOption', 'speed', 300);
      }
    },

    /**
     * Updates the DOM state of the add to cart button
     *
     * @param {boolean} enabled - Decides whether cart is enabled or disabled
     * @param {string} text - Updates the text notification content of the cart
     */
    updateAddToCartState: function (evt) {
      var variant = evt.variant;

      if (variant) {
        $(selectors.priceWrapper, this.$container).removeClass('hide');
      } else {
        $(selectors.addToCart, this.$container).prop('disabled', true);
        $(selectors.addToCartText, this.$container).html(
          theme.strings.unavailable
        );
        $(selectors.priceWrapper, this.$container).addClass('hide');
        return;
      }

      if (variant.available) {
        var quantityAvailable = Math.max(variant.inventory_quantity, 0);
        quantityAvailable = quantityAvailable > 0 ? quantityAvailable : 999;
        var maxQuantityToDisplay = Math.min(quantityAvailable, 6);

        $('[data-product-quantity]').find('option').remove();

        var selectedString = '';

        for (var i = maxQuantityToDisplay - 1; i >= 0; i--) {
          if (i == 0) {
            selectedString = 'selected="selected"';
          }

          $('[data-product-quantity]').prepend(
            '<option ' +
              selectedString +
              'value="' +
              (i + 1) +
              '">' +
              (i + 1) +
              '</option>'
          );

          selectedString = '';
        }

        // $(selectors.productQtyWrapper + ' input', this.$container).prop('max', quantityAvailable);
        // $(selectors.productQtyWrapper + ' input', this.$container).prop('min', 1);
        $(selectors.addToCart, this.$container).prop('disabled', false);
        $(selectors.addToCart, this.$container).removeClass('disabled');
        $(selectors.addToCartText, this.$container).children().first().html(
          theme.strings.addToCart
        );
      } else {
        $(selectors.productQtyWrapper + ' input', this.$container).prop(
          'max',
          0
        );
        $(selectors.productQtyWrapper + ' input', this.$container).prop(
          'min',
          0
        );
        $(selectors.addToCart, this.$container).prop('disabled', true);
        $(selectors.addToCart, this.$container).addClass('disabled');
        $(selectors.addToCartText, this.$container).children().first().html(theme.strings.soldOut);
      }
    },

    /**
     * Updates the dynamic checkout buttons
     *
     */
    updateDynamicCheckoutButtons: function (evt) {
      this.subscriptionPurchaseType =
        evt.purchaseType || this.subscriptionPurchaseType;

      if (
        this.subscriptionPurchaseType == 'autodeliver' ||
        subscriptionProductInCart(CartJS.cart)
      ) {
        $('.additional-checkout-buttons').hide();
      } else {
        $('.additional-checkout-buttons').show();
      }

      function subscriptionProductInCart(cart) {
        if (!cart.items) {
          return false;
        }

        for (var i = 0; i < cart.items.length; i++) {
          var isSubscriptionProduct =
            cart.items[i].properties.shipping_interval_frequency != null;
          if (isSubscriptionProduct) {
            return true;
          } else {
            return false;
          }
        }
      }
    },

    /**
     * Updates the DOM with specified prices
     *
     * @param {string} productPrice - The current price of the product
     * @param {string} comparePrice - The original price of the product
     */
    updateProductPrices: function (evt) {
      var variant = evt.variant;
      var $comparePrice = $(selectors.comparePrice, this.$container);
      var $compareEls = $comparePrice.add(
        selectors.comparePriceText,
        this.$container
      );
      var comparePrefixString = $comparePrice.data('prefix-string') || '';
      var compareSuffixString = $comparePrice.data('suffix-string') || '';

      $(selectors.productPrice, this.$container).html(
        slate.Currency.formatMoney(variant.price, shop.moneyFormat)
      );

      var productPriceWithDiscount = $(
        selectors.productPriceWithDiscount,
        this.$container
      );

      for (var i = 0; i < productPriceWithDiscount.length; i++) {
        var field = productPriceWithDiscount[i];
        var discountAmount = $(field).data('product-price-discount');
        var discountPrice = variant.price * discountAmount;

        $(field).html(
          slate.Currency.formatMoney(discountPrice, shop.moneyFormat)
        );
      }

      if (variant.compare_at_price > variant.price) {
        $comparePrice.html(
          comparePrefixString +
            slate.Currency.formatMoney(
              variant.compare_at_price,
              shop.moneyFormat
            ) +
            compareSuffixString
        );
        $compareEls.removeClass('hide');
      } else {
        $comparePrice.html('');
        $compareEls.addClass('hide');
      }

      var $afterpayInstallments = $('#afterpay_instalments', this.$container);
      if ($afterpayInstallments.length) {
        $afterpayInstallments.html(
          slate.Currency.formatMoney(variant.price / 4, shop.moneyFormat)
        );
      }
    },

    /**
     * Updates the DOM with specified options
     */
    updateProductOptions: function (evt) {
      var self = this;
      var enabledOptions = [];
      var selectedVariant = evt.variant;

      var selectedVariantDisabled = false;
      var element_type = evt.element_type;
      var selectionAction = 'selected';
      var dropdownOptions =
        selectors.singleOptionSelector + ':not([data-index="option1"]) option';
      //check is subscription product
      this.subscriptionPurchaseType =
        evt.purchaseType || this.subscriptionPurchaseType || 'onetime';
      //check if id is in excluded list dont enable

      //check type of option input
      if (this.element_type === 'radio' || this.element_type === 'checkbox') {
        selectionAction = 'checked';
      }

      //check if single option product
      if (selectedVariant.option2 == null) {
        dropdownOptions = selectors.singleOptionSelector + ' option';
      }

      for (var i = 0; i < this.product.variants.length; i++) {
        var variant = this.product.variants[i];

        if (
          this.excludedVariantIds.length &&
          this.subscriptionPurchaseType == 'autodeliver' &&
          this.excludedVariantIds.indexOf(variant.id) > -1
        ) {
          $(dropdownOptions + '[value="' + variant.option1 + '"]').attr(
            'disabled',
            'disabled'
          );
          if (selectedVariant.id == variant.id) {
            selectedVariantDisabled = true;
          }
        } else if (variant.available) {
          $(
            selectors.singleOptionSelector +
              ' option[value="' +
              variant.option1 +
              '"]'
          ).removeAttr('disabled');
        }

        if (variant.option1 == selectedVariant.option1 && variant.available) {
          enabledOptions = _.union(enabledOptions, [
            variant.option2,
            variant.option3,
          ]);
        }
      }

      if (selectedVariant.option2 != null) {
        $(dropdownOptions).attr('disabled', 'disabled');
        for (var i = 0; i < enabledOptions.length; i++) {
          $(dropdownOptions + '[value="' + enabledOptions[i] + '"]').removeAttr(
            'disabled'
          );
        }
      }

      if (!selectedVariant.available || selectedVariantDisabled) {
        var $selectedDisabledOptions = $(
          dropdownOptions + ':disabled:' + selectionAction
        );
        if ($selectedDisabledOptions.length) {
          $selectedDisabledOptions.each(function () {
            if (selectedVariant.option2 == null) {
              var $newOption = $(this)
                .siblings('option:not(:disabled):not(:' + selectionAction + ')')
                .eq(0);
            } else {
              var $newOption = $(this)
                .siblings(
                  dropdownOptions +
                    ':not(:disabled):not(:' +
                    selectionAction +
                    ')'
                )
                .eq(0);
            }

            $(this).removeAttr(selectionAction);
            $newOption.attr(selectionAction, selectionAction);

            $(selectors.singleOptionSelector, self.$container).val(
              $newOption.val()
            );

            $(selectors.singleOptionSelector, self.$container).trigger(
              'change'
            );
          });
        }
      } else {
        $(selectors.singleOptionValue).each(function () {
          var $this = $(this);
          $this.text(
            selectedVariant.options[$this.data('single-option-value')]
          );
        });
      }
    },

    /**
     * Updates the DOM with the specified image URL
     *
     * @param {string} src - Image src URL
     */
    updateProductImage: function (evt) {
      var self = this;
      var variant = evt.variant;

      if (self.settings.sliderActive) {
        var imageIndex = $(
          '[data-image-id="' +
            variant.featured_image.id +
            '"]:not(.slick-cloned)'
        )
          .closest('.slick-slide')
          .data('slick-index');
        $(selectors.productImageContainer).slick('slickGoTo', imageIndex);
      } else {
        if (this.$featuredImage.length) {
          var sizedImgUrl = slate.Image.getSizedImageUrl(
            variant.featured_image.src,
            this.settings.imageSize
          );
          this.$featuredImage.attr('src', sizedImgUrl);
        }
      }
    },

    /**
     * Updates the DOM with specified Variant SKU
     */
    updateSKU: function (evt) {
      var variant = evt.variant;

      // Update the sku
      $(selectors.productSku, this.$container).html(variant.sku);
    },

    /**
     * Event callback for Theme Editor `section:unload` event
     */
    onUnload: function () {
      this.$container.off(this.namespace);

      if (this.stickyAddToCartEl) {
        this.stickyAddToCartEl.remove();
      }
    },
  });

  return Product;
})();

theme.Quotes = (function () {
  var selectors = {
    slideshow: '[data-slideshow]',
  };

  function Quotes(container) {
    this.$container = $(container);
    this.$slideshows = $(selectors.slideshow, this.$container);

    $.each(this.$slideshows, function (index, slideshow) {
      theme.slideshows[slideshow] = new theme.Slideshow(slideshow);
    });
  }

  return Quotes;
})();

theme.slideshows = theme.slideshows || {};

theme.SlideshowSection = (function () {
  function SlideshowSection(container) {
    var $container = (this.$container = $(container));
    var sectionId = $container.attr('data-section-id');
    var slideshow = (this.slideshow = '#Slideshow-' + sectionId);

    $('.slideshow__video', slideshow).each(function () {
      var $el = $(this);
      theme.SlideshowVideo.init($el);
      theme.SlideshowVideo.loadVideo($el.attr('id'));
    });

    theme.slideshows[slideshow] = new theme.Slideshow(slideshow);
  }

  return SlideshowSection;
})();

theme.SlideshowSection.prototype = _.assignIn(
  {},
  theme.SlideshowSection.prototype,
  {
    onUnload: function () {
      delete theme.slideshows[this.slideshow];
    },

    onBlockSelect: function (evt) {
      var $slideshow = $(this.slideshow);

      // Ignore the cloned version
      var $slide = $(
        '.slideshow__slide--' + evt.detail.blockId + ':not(.slick-cloned)'
      );
      var slideIndex = $slide.data('slick-index');

      // Go to selected slide, pause autoplay
      $slideshow.slick('slickGoTo', slideIndex).slick('slickPause');
    },

    onBlockDeselect: function () {
      // Resume autoplay
      $(this.slideshow).slick('slickPlay');
    },
  }
);

window.theme = window.theme || {};

theme.BrandValueSliders = (function () {
  var config = {
    mediaQuerySmall: theme.settings.mediaQuery.small,
    mediaQueryMediumUp: theme.settings.mediaQuery.mediumUp,
    slideCount: 0,
    anchorPosition: 'above', // above, below
    anchorElement: false, // '.site-header-lower'
    anchorViewport: 'small', // large, small
  };

  var cache = {
    anchorMarginBottom: 0,
    anchorMarginTop: 0,
    anchorOffset: 0,
  };

  var defaults = {
    arrows: false,
    dots: false,
    autoplay: false,
    touchThreshold: 20,
    slidesToShow: 3,
    swipeToSlide: true,
    slidesToScroll: 1,
    rows: 0,
  };

  function brandValueSliders(container) {
    var $container = (this.$container = $(container));
    var sectionId = $container.attr('data-section-id');
    var wrapper = (this.wrapper = '.brand-values-wrap');
    var slider = (this.slider = '#brand-values-' + sectionId);
    var $slider = $(slider, wrapper);
    var $contentContainer = $('#PageContent');
    var $anchorElement = $(config.anchorElement);

    var mobileOptions = $.extend({}, defaults, {
      arrows: true,
      slidesToShow: 1,
      slidesToScroll: 1,
      adaptiveHeight: true,
      autoplay: $slider.data('autoplay-mobile'),
      autoplaySpeed: $slider.data('speed'),
    });

    var sliderActive = false;
    var desktopOptions = $.extend({}, defaults, {
      autoplay: $slider.data('autoplay'),
      autoplaySpeed: $slider.data('speed'),
      slidesToShow: $slider.data('slides-show-desktop'),
    });

    config.slideCount = $slider.data('count');

    // Override slidesToShow/Scroll if there are not enough blocks
    if (config.slideCount < defaults.slidesToShow) {
      defaults.slidesToShow = config.slideCount;
      defaults.slidesToScroll = config.slideCount;
    }

    $slider.on('init', this.a11y.bind(this));

    if ($anchorElement.length) {
      cache.anchorMarginTop = parseInt(
        $anchorElement.css('marginTop').replace('px', '')
      );
      cache.anchorMarginBottom = parseInt(
        $anchorElement.css('marginBottom').replace('px', '')
      );
    }

    enquire.register(config.mediaQuerySmall, {
      deferSetup: true,
      match: function () {
        initSlider($slider, mobileOptions);

        if ($anchorElement.length) {
          $anchorElement.css({
            'margin-top': cache.anchorMarginTop + 'px',
            'margin-bottom': cache.anchorMarginBottom + 'px',
          });

          if (
            config.anchorViewport == 'small' ||
            config.anchorViewport == 'all'
          ) {
            $container.css('position', 'fixed');
            switch (config.anchorPosition) {
              case 'above':
                cache.anchorOffset = $anchorElement.offset().top;
                var anchorAdjustment = {
                  'margin-top':
                    cache.anchorMarginTop + $container.outerHeight() + 'px',
                };
                var sliderAdjustment = {
                  top: cache.anchorOffset + 'px',
                };
                break;
              default:
                cache.anchorOffset =
                  $anchorElement.offset().top + $anchorElement.innerHeight();
                var anchorAdjustment = {
                  'margin-bottom':
                    cache.anchorMarginBottom + $container.outerHeight() + 'px',
                };
                var sliderAdjustment = {
                  top: cache.anchorOffset + 'px',
                };
                break;
            }
          } else {
            var anchorAdjustment = {
              'margin-bottom': cache.anchorMarginBottom + 'px',
            };
            var sliderAdjustment = {
              position: 'static',
              top: '0px',
            };
          }

          $anchorElement.css(anchorAdjustment);
          $container.not('.brand-values--cloned').css(sliderAdjustment);
        }
      },
    });

    enquire.register(config.mediaQueryMediumUp, {
      deferSetup: true,
      match: function () {
        initSlider($slider, desktopOptions);
        if ($anchorElement.length) {
          $anchorElement.css({
            'margin-top': cache.anchorMarginTop + 'px',
            'margin-bottom': cache.anchorMarginBottom + 'px',
          });

          if (
            config.anchorViewport == 'large' ||
            config.anchorViewport == 'all'
          ) {
            $container.css('position', 'fixed');
            switch (config.anchorPosition) {
              case 'above':
                cache.anchorOffset = $anchorElement.offset().top;
                var anchorAdjustment = {
                  'margin-top':
                    cache.anchorMarginTop + $container.outerHeight() + 'px',
                };
                var sliderAdjustment = {
                  position: 'fixed',
                  top: cache.anchorOffset + 'px',
                };
                break;
              default:
                cache.anchorOffset =
                  $anchorElement.offset().top + $anchorElement.innerHeight();
                var anchorAdjustment = {
                  'margin-bottom':
                    cache.anchorMarginBottom + $container.outerHeight() + 'px',
                };
                var sliderAdjustment = {
                  position: 'fixed',
                  top: cache.anchorOffset + 'px',
                };
                break;
            }
          } else {
            var anchorAdjustment = {
              'margin-bottom': cache.anchorMarginBottom + 'px',
            };
            var sliderAdjustment = {
              position: 'static',
              top: '0px',
            };
          }

          $anchorElement.css(anchorAdjustment);
          $container.not('.brand-values--cloned').css(sliderAdjustment);
        }
      },
    });

    function initSlider(sliderObj, args) {
      if (sliderActive) {
        sliderObj.slick('unslick');
        sliderActive = false;
        $('.brand-values-clone').empty();
      }

      // Clone brand values content to other site areas
      // #TODO: Attach this to the main slider init so it functions as a slider
      sliderObj
        .clone()
        .addClass('brand-values--cloned')
        .removeAttr('id')
        .removeAttr('style')
        .appendTo('.brand-values-clone');

      sliderObj.slick(args);

      // sliderObj.on('wheel', (function(e) {
      //   e.preventDefault();
      //   if (e.originalEvent.deltaY < 0) {
      //     $(this).slick('slickNext');
      //   } else {
      //     $(this).slick('slickPrev');
      //   }
      // }));

      sliderActive = true;

      if ($anchorElement.length) {
        if ($(window).width() < 750) {
          switch (config.anchorPosition) {
            case 'above':
              $anchorElement.css('margin-top', sliderObj.outerHeight() + 'px');
              break;
            default:
              $anchorElement.css(
                'margin-bottom',
                sliderObj.outerHeight() + 'px'
              );
              break;
          }
        }
      }
    }
  }

  brandValueSliders.prototype = _.assignIn({}, brandValueSliders.prototype, {
    onUnload: function () {
      enquire.unregister(config.mediaQuerySmall);
      enquire.unregister(config.mediaQueryMediumUp);

      $(this.slider, this.wrapper).slick('unslick');
    },

    onBlockSelect: function (evt) {
      // Ignore the cloned version
      var $slide = $(
        '.brand-values__slide--' + evt.detail.blockId + ':not(.slick-cloned)'
      );
      var slideIndex = $slide.data('slick-index');

      // Go to selected slide, pause autoplay
      $(this.slider, this.wrapper).slick('slickGoTo', slideIndex);
    },

    a11y: function (event, obj) {
      var $list = obj.$list;
      var $wrapper = $(this.wrapper, this.$container);

      // Remove default Slick aria-live attr until slider is focused
      $list.removeAttr('aria-live');

      // When an element in the slider is focused set aria-live
      $wrapper.on('focusin', function (evt) {
        if ($wrapper.has(evt.target).length) {
          $list.attr('aria-live', 'polite');
        }
      });

      // Remove aria-live
      $wrapper.on('focusout', function (evt) {
        if ($wrapper.has(evt.target).length) {
          $list.removeAttr('aria-live');
        }
      });
    },
  });

  return brandValueSliders;
})();

window.theme = window.theme || {};

theme.FeaturedCollection = (function () {
  var config = {
    mediaQuerySmall: theme.settings.mediaQuery.small,
    mediaQueryMediumUp: theme.settings.mediaQuery.mediumUp,
    slideCount: 0,
  };

  var sliderOptions = {
    arrows: true,
    dots: false,
    slidesToShow: 3,
    slidesToScroll: 3,
    infinite: true,
  };

  function featuredCollection(container) {
    var $container = (this.$container = $(container));
    var sectionId = $container.attr('data-section-id');
    var wrapper = (this.wrapper = '.featured-collection-wrap');
    var slider = (this.slider = '#featured-collection-' + sectionId);
    var $slider = (this.$slider = $(slider, wrapper));
    var sliderActive = (this.sliderActive = false);

    var options = $.extend({}, sliderOptions, {
      prevArrow: slider + ' ~ .featured-collection__prev',
      nextArrow: slider + ' ~ .featured-collection__next',
      autoplay: $slider.data('autoplay'),
      autoplaySpeed: $slider.data('speed'),
      swipeToSlide: true,
      slidesToShow: 3,
      slidesToScroll: 1,
      responsive: [
        {
          breakpoint: 1080,
          settings: {
            slidesToShow: 4,
            slidesToScroll: 1,
          },
        },
        {
          breakpoint: 992,
          settings: {
            slidesToShow: 2,
            slidesToScroll: 1,
          },
        },
        {
          breakpoint: 768,
          settings: {
            slidesToShow: 2,
            slidesToScroll: 1,
            // dots: true,
            autoplay: $slider.data('autoplay-mobile'),
          },
        },
        {
          breakpoint: 512,
          settings: {
            slidesToShow: 3,
            slidesToScroll: 1,
            // vertical: true,
            // dots: true
          },
        },
      ],
    });

    var self = this;

    enquire.register(config.mediaQuerySmall, {
      match: function () {
        destroySlider(self.$slider);
      },
    });

    enquire.register(config.mediaQueryMediumUp, {
      match: function () {
        initSlider(self.$slider, options);
      },
    });

    function appendSlickScrollbar(slick) {
      if (
        slick.$slides.filter('.slick-active').length != slick.$slides.length
      ) {
        var currentMarkerOffset = slick.currentSlide * 100;
        var scrollbarMarkerWidth = (1 / slick.slideCount) * 100;
        slick.$slider.append(
          '<div class="slick-scrollbar"><div class="slick-scrollbar-mark" style="width: ' +
            scrollbarMarkerWidth +
            '%"></div></div>'
        );
        $('.slick-scrollbar-mark', slick.$slider).css(
          'transform',
          'translateX(' + currentMarkerOffset + '%)'
        );
      }
    }

    $slider.on('init', function (evt, slick) {
      self.a11y.bind(this);

      // appendSlickScrollbar(slick);
    });

    $slider.on('reInit', function (evt, slick) {
      // appendSlickScrollbar(slick);
    });

    $slider.on('beforeChange', function (evt, slick, currentSlide, nextSlide) {
      var currentMarkerOffset = nextSlide * 100;
      $('.slick-scrollbar-mark', slick.$slider).css(
        'transform',
        'translateX(' + currentMarkerOffset + '%)'
      );
    });

    initSlider($slider, options);

    function initSlider(sliderObj, args) {
      if (self.sliderActive) {
        sliderObj.slick('unslick');
        self.sliderActive = false;
      }

      // var markerRatio = $('.featured-collection .slick-list').width() / $('.featured-collection .slick-track').width();

      var gridItems;
      gridItems = sliderObj[0].querySelectorAll('[rv-product-grid-item]');

      // $('input[type="number"]', sliderObj).not('.js-qty-select input[type="number"]').each( function(){
      //   var $el = $(this);
      //   theme.QuantitySelector.init($el);
      // });

      for (var i = 0; i < gridItems.length; i++) {
        var el = gridItems[i],
          gridIndex = el.dataset.index,
          animateIn =
            typeof el.dataset.animateIn != 'undefined'
              ? el.dataset.animateIn
              : true,
          options = {
            animateIn: animateIn == 'true' ? true : false,
          };
        new theme.ProductGridItem(el, null, gridIndex, options);
      }

      if ($(window).width() > 599) {
        sliderObj.slick(args);
        // sliderObj.on('wheel', (function(e) {
        //   e.preventDefault();
        //   if (e.originalEvent.deltaY < 0) {
        //     $(this).slick('slickNext');
        //   } else {
        //     $(this).slick('slickPrev');
        //   }
        // }));
        self.sliderActive = true;
      }
    }

    function destroySlider(sliderObj) {
      if (self.sliderActive) {
        sliderObj.slick('unslick');
        self.sliderActive = false;
      }
    }
  }

  featuredCollection.prototype = _.assignIn({}, featuredCollection.prototype, {
    onUnload: function () {
      $(this.slider, this.wrapper).slick('unslick');
    },

    a11y: function (event, obj) {
      var $list = obj.$list;
      var $wrapper = $(this.wrapper, this.$container);

      // Remove default Slick aria-live attr until slider is focused
      $list.removeAttr('aria-live');

      // When an element in the slider is focused set aria-live
      $wrapper.on('focusin', function (evt) {
        if ($wrapper.has(evt.target).length) {
          $list.attr('aria-live', 'polite');
        }
      });

      // Remove aria-live
      $wrapper.on('focusout', function (evt) {
        if ($wrapper.has(evt.target).length) {
          $list.removeAttr('aria-live');
        }
      });
    },
  });

  return featuredCollection;
})();

window.theme = window.theme || {};
theme.slideshows = theme.slideshows || {};

theme.FeaturedCollections = (function () {
  var selectors = {
    collectionLink: '.featured_colections__header-item',
  };

  function FeaturedCollections(container) {
    var $container = (this.$container = $(container));
    var sectionId = $container.attr('data-section-id');
    var slideshow = (this.slideshow = '#Slideshow-' + sectionId);
    var activeCollectionHandle = $('[data-block-id]', $container)
      .first()
      .data('related-collection');

    theme.slideshows[slideshow] = new theme.Slideshow(slideshow);

    $(
      selectors.collectionLink +
        '[data-related-collection=' +
        activeCollectionHandle +
        ']',
      $container
    ).addClass('active');

    $(slideshow).on('beforeChange', function (
      event,
      slick,
      currentSlide,
      nextSlide
    ) {
      var nextCollectionHandle = $(
        '[data-slick-index="' +
          nextSlide +
          '"]:not(.slick-cloned) [data-related-collection]',
        $container
      ).data('related-collection');
      if (nextCollectionHandle != activeCollectionHandle) {
        activeCollectionHandle = nextCollectionHandle;

        $(selectors.collectionLink, $container).removeClass('active');
        $(
          selectors.collectionLink +
            '[data-related-collection="' +
            activeCollectionHandle +
            '"]',
          $container
        ).addClass('active');
      }
    });

    $(selectors.collectionLink, $container).on('click', function (evt) {
      evt.preventDefault();
      var $this = $(this);

      var relatedCollectionHandle = $this.data('related-collection');
      var $slide = $(
        '.slick-slide[data-slick-index="' +
          $this.data('first-product') +
          '"]:not(.slick-cloned)',
        $container
      ).first();
      var slideIndex = $slide.data('slick-index');
      $(slideshow).slick('slickGoTo', slideIndex);
    });
  }

  return FeaturedCollections;
})();

theme.FeaturedCollections.prototype = _.assignIn(
  {},
  theme.FeaturedCollections.prototype,
  {
    onUnload: function () {
      delete theme.slideshows[this.slideshow];
    },

    onBlockSelect: function (evt) {
      var $slideshow = $(this.slideshow);

      // Ignore the cloned version
      var $slide = $(
        '[data-block-id="' + evt.detail.blockId + '"]:not(.slick-cloned)'
      );
      var slideIndex = $slide.data('slick-index');

      // Go to selected slide, pause autoplay
      $slideshow.slick('slickGoTo', slideIndex).slick('slickPause');
    },

    onBlockDeselect: function () {
      // Resume autoplay
      $(this.slideshow).slick('slickPlay');
    },
  }
);

window.theme = window.theme || {};

theme.FeaturedProduct = (function () {
  var selectors = {
    quantitySelector: 'input[type="number"]',
  };

  function FeaturedProduct(container) {
    var qtySelectorElem = container.querySelector(selectors.quantitySelector);

    if (!qtySelectorElem) {
      return;
    }

    var quantitySelector = new theme.QuantitySelector(qtySelectorElem);
  }

  return FeaturedProduct;
})();

window.theme = window.theme || {};

theme.slideshows = theme.slideshows || {};

theme.FeaturedProducts = (function () {
  function FeaturedProducts(container) {
    var $container = (this.$container = $(container));
    var sectionId = $container.attr('data-section-id');
    var slideshowMasthead = (this.slideshow =
      '#featured-products-masthead-' + sectionId);
    var slideshow = (this.slideshow = '#featured-products-' + sectionId);

    theme.slideshows[slideshowMasthead] = new theme.Slideshow(
      slideshowMasthead
    );
    theme.slideshows[slideshow] = new theme.Slideshow(slideshow);

    $('.featured-products__slide', slideshow).on('mouseenter', function () {
      $(slideshowMasthead).slick(
        'slickGoTo',
        $(this).parents('.slick-slide').data('slick-index')
      );
    });

    $('.featured-products__slide', slideshow).on('mouseleave', function () {
      $(slideshowMasthead).slick(
        'slickGoTo',
        $(slideshow).slick('slickCurrentSlide')
      );
    });
  }

  return FeaturedProducts;
})();

theme.FeaturedProducts.prototype = _.assignIn(
  {},
  theme.FeaturedProducts.prototype,
  {
    onUnload: function () {
      delete theme.slideshows[this.slideshow];
    },

    onBlockSelect: function (evt) {
      var $slideshow = $(this.slideshow);

      // Ignore the cloned version
      var $slide = $(
        '[data-block-id="' + evt.detail.blockId + '"]:not(.slick-cloned)'
      );
      var slideIndex = $slide.data('slick-index');

      // Go to selected slide, pause autoplay
      $slideshow.slick('slickGoTo', slideIndex).slick('slickPause');
    },

    onBlockDeselect: function () {
      // Resume autoplay
      $(this.slideshow).slick('slickPlay');
    },
  }
);

window.theme = window.theme || {};
theme.slideshows = theme.slideshows || {};

theme.ImageRows = (function () {
  function ImageRows(container) {
    var $container = (this.$container = $(container));
    var sectionId = $container.attr('data-section-id');
    var slideshow = (this.slideshow = '#Slideshow-' + sectionId);

    theme.slideshows[slideshow] = new theme.Slideshow(slideshow);
  }

  return ImageRows;
})();

theme.ImageRows.prototype = _.assignIn({}, theme.ImageRows.prototype, {
  onUnload: function () {
    delete theme.slideshows[this.slideshow];
  },

  onBlockSelect: function (evt) {
    var $slideshow = $(this.slideshow);

    // Ignore the cloned version
    var $slide = $(
      '[data-block-id="' + evt.detail.blockId + '"]:not(.slick-cloned)'
    );
    var slideIndex = $slide.data('slick-index');

    // Go to selected slide, pause autoplay
    $slideshow.slick('slickGoTo', slideIndex).slick('slickPause');
  },

  onBlockDeselect: function () {
    // Resume autoplay
    $(this.slideshow).slick('slickPlay');
  },
});

window.theme = window.theme || {};

theme.ContentSliders = (function () {
  var config = {
    mediaQuerySmall: theme.settings.mediaQuery.small,
    mediaQueryMedium: theme.settings.mediaQuery.medium,
    mediaQueryLargeUp: theme.settings.mediaQuery.largeUp,
  };

  function contentSliders(container) {
    var $container = (this.$container = $(container));
    var sectionId = $container.attr('data-section-id');
    var wrapper = (this.wrapper = '.content-slider-wrap');
    var slider = (this.slider = '#content-slider-' + sectionId);
    var $slider = $(slider, wrapper);
    var sliderActive = false;

    var options = {
      infinite: $slider.data('infinite'),
      prevArrow: slider + ' ~ .content-slider__prev',
      nextArrow: slider + ' ~ .content-slider__next',
      arrows: $slider.data('arrows'),
      dots: $slider.data('dots'),
      autoplay: $slider.data('autoplay'),
      autoplaySpeed: $slider.data('speed'),
      slidesToShow: $slider.data('slides-show-desktop'),
      slidesToScroll: $slider.data('slides-scroll-desktop'),
      rows: $slider.data('rows-desktop'),
      slidesPerRow: $slider.data('per-row-desktop'),
    };

    var tabletOptions = $.extend({}, options, {
      slidesToShow: $slider.data('slides-show-tablet'),
      slidesToScroll: $slider.data('slides-scroll-tablet'),
      rows: $slider.data('rows-tablet'),
      slidesPerRow: $slider.data('per-row-tablet'),
    });

    var mobileOptions = $.extend({}, options, {
      arrows: $slider.data('arrows-mobile'),
      dots: $slider.data('dots-mobile'),
      autoplay: $slider.data('autoplay-mobile'),
      slidesToShow: $slider.data('slides-show-mobile'),
      slidesToScroll: $slider.data('slides-scroll-mobile'),
      rows: $slider.data('rows-mobile'),
      slidesPerRow: $slider.data('per-row-mobile'),
    });

    $slider.on('init', this.a11y.bind(this));

    enquire.register(config.mediaQuerySmall, {
      match: function () {
        initSlider($slider, mobileOptions);
      },
    });

    enquire.register(config.mediaQueryMedium, {
      match: function () {
        initSlider($slider, tabletOptions);
      },
    });

    enquire.register(config.mediaQueryLargeUp, {
      match: function () {
        initSlider($slider, options);
      },
    });

    function initSlider(sliderObj, args) {
      if (sliderActive) {
        sliderObj.slick('unslick');
        sliderActive = false;
      }

      sliderObj.slick(args);
      // sliderObj.on('wheel', (function(e) {
      //   e.preventDefault();
      //   if (e.originalEvent.deltaY < 0) {
      //     $(this).slick('slickNext');
      //   } else {
      //     $(this).slick('slickPrev');
      //   }
      // }));
      sliderActive = true;
    }

    $('.slideshow__video', wrapper).each(function () {
      var $el = $(this);
      theme.SlideshowVideo.init($el);
      theme.SlideshowVideo.loadVideo($el.attr('id'));
    });
  }

  contentSliders.prototype = _.assignIn({}, contentSliders.prototype, {
    onUnload: function () {
      $(this.slider, this.wrapper).slick('unslick');
    },

    a11y: function (event, obj) {
      var $list = obj.$list;
      var $wrapper = $(this.wrapper, this.$container);

      // Remove default Slick aria-live attr until slider is focused
      $list.removeAttr('aria-live');

      // When an element in the slider is focused set aria-live
      $wrapper.on('focusin', function (evt) {
        if ($wrapper.has(evt.target).length) {
          $list.attr('aria-live', 'polite');
        }
      });

      // Remove aria-live
      $wrapper.on('focusout', function (evt) {
        if ($wrapper.has(evt.target).length) {
          $list.removeAttr('aria-live');
        }
      });
    },
  });

  return contentSliders;
})();

window.theme = window.theme || {};
theme.slideshows = theme.slideshows || {};

theme.LatestBlogPosts = (function () {
  function LatestBlogPosts(container) {
    var $container = (this.$container = $(container));
    var sectionId = $container.attr('data-section-id');
    var slideshow = (this.slideshow = '#Slideshow-' + sectionId);

    theme.slideshows[slideshow] = new theme.Slideshow(slideshow);
  }

  return LatestBlogPosts;
})();

theme.LatestBlogPosts.prototype = _.assignIn(
  {},
  theme.LatestBlogPosts.prototype,
  {
    onUnload: function () {
      delete theme.slideshows[this.slideshow];
    },

    onBlockSelect: function (evt) {
      var $slideshow = $(this.slideshow);

      // Ignore the cloned version
      var $slide = $(
        '.slideshow__slide--' + evt.detail.blockId + ':not(.slick-cloned)'
      );
      var slideIndex = $slide.data('slick-index');

      // Go to selected slide, pause autoplay
      $slideshow.slick('slickGoTo', slideIndex).slick('slickPause');
    },

    onBlockDeselect: function () {
      // Resume autoplay
      $(this.slideshow).slick('slickPlay');
    },
  }
);

window.theme = window.theme || {};
theme.slideshows = theme.slideshows || {};

theme.ImageGallerySliders = (function () {
  function ImageGallerySliders(container) {
    var $container = (this.$container = $(container));
    var sectionId = $container.attr('data-section-id');
    var slideshow = (this.slideshow = '#Slideshow-' + sectionId);

    theme.slideshows[slideshow] = new theme.Slideshow(slideshow);

    var pswpElement = document.querySelectorAll('.pswp')[0];
    var galleryItems = [];

    $(
      '.image-gallery-item__anchor:not(.slick-cloned .image-gallery-item__anchor)',
      slideshow
    ).map(function () {
      var $this = $(this);
      var width = $this.data('width');

      galleryItems.push({
        src: $this.attr('href'),
        w: width,
        h: width / $this.data('aspect-ratio'),
      });
    });

    $('.image-gallery-item__anchor').on('click', function (evt) {
      evt.preventDefault();

      var thumbnail = $(this).find('img')[0];

      var options = {
        index: $(this).data('index'),
        barsSize: { top: 0, bottom: 0 },
        captionEl: false,
        fullscreenEl: false,
        shareEl: false,
        bgOpacity: 0.96,
        tapToClose: true,
        tapToToggleControls: false,
        history: false,
        getThumbBoundsFn: function (index) {
          var pageYScroll =
              window.pageYOffset || document.documentElement.scrollTop,
            rect = thumbnail.getBoundingClientRect(),
            thumbInfo = theme.utils.getImgSizeInfo(thumbnail);
          return {
            x: rect.left + thumbInfo.left,
            y: rect.top + pageYScroll,
            w: thumbInfo.width,
          };
        },
      };

      var gallery = new PhotoSwipe(
        pswpElement,
        PhotoSwipeUI_Default,
        galleryItems,
        options
      );
      gallery.init();
    });
  }

  return ImageGallerySliders;
})();

theme.ImageGallerySliders.prototype = _.assignIn(
  {},
  theme.ImageGallerySliders.prototype,
  {
    onUnload: function () {
      delete theme.slideshows[this.slideshow];
    },

    onBlockSelect: function (evt) {
      var $slideshow = $(this.slideshow);

      // Ignore the cloned version
      var $slide = $(
        '.slideshow__slide--' + evt.detail.blockId + ':not(.slick-cloned)'
      );
      var slideIndex = $slide.data('slick-index');

      // Go to selected slide, pause autoplay
      $slideshow.slick('slickGoTo', slideIndex).slick('slickPause');
    },

    onBlockDeselect: function () {
      // Resume autoplay
      $(this.slideshow).slick('slickPlay');
    },
  }
);

window.theme = window.theme || {};

theme.DashboardDynamicWelcome = (function () {
  var selectors = {
    title: '[data-dynamic-welcome-title]',
    message: '[data-dynamic-welcome]',
    data: '#dynamic-welcome-data',
  };

  function DashboardDynamicWelcome(container) {
    this.$container = $(container);
    this.$title = $(selectors.title);
    this.$message = $(selectors.message);
    this.data = JSON.parse($(selectors.data).html());

    if (!this.$message.length) {
      return;
    }

    var currentDate = new Date();
    var currentHour = currentDate.getHours();

    var message = 'Hello there';
    var timePeriod;
    var icon;

    if (currentHour < 4) {
      timePeriod = 'early_morning';
    } else if (currentHour >= 4 && currentHour < 12) {
      timePeriod = 'morning';
    } else if (currentHour >= 12 && currentHour < 17) {
      timePeriod = 'afternoon';
    } else if (currentHour >= 17 && currentHour < 18) {
      timePeriod = 'evening';
    } else {
      timePeriod = 'night';
    }

    message = this.data[timePeriod];
    icon = theme.utils.getTemplate('dynamic-welcome-icon-' + timePeriod);

    $(selectors.message).html(message);
    $(selectors.title).append(icon);

    this.$title.addClass('fade-in');
  }

  return DashboardDynamicWelcome;
})();
window.theme = window.theme || {};

theme.DashboardPlaceOrder = (function () {
  var selectors = {
    tabsGroup: '.tabs-group',
    tabContent: '[data-tab]',
    accountViewRight: '.account__view-right',
  };

  function DashboardPlaceOrder(container) {
    this.$container = $(container);

    this.$accountViewRight = $(selectors.accountViewRight);
    this.$accountViewRight.addClass('hidden');

    if (!this.$container.length) {
      return;
    }

    this.$tabsGroup = $(selectors.tabsGroup, this.$container);
    this.$tabs = $(selectors.tabContent, this.$container);

    var self = this;

    var activeTab = this.$tabs.length;

    if (window.location.href.indexOf('search') > -1) {
      activeTab = 1;
    }

    if (window.location.href.indexOf('cart') > -1) {
      activeTab = this.$tabs.length;
      this.$accountViewRight.removeClass('hidden');
    }

    if (window.location.href.indexOf('account') > -1) {
      activeTab = 1;
    }

    $.each(this.$tabsGroup, function (index, tabsGroup) {
      window.theme.tabsGroups[tabsGroup] = new theme.TabsGroup(tabsGroup, {
        breakpoint: 0,
        activeTab: activeTab,
      });

      window.theme.tabsGroups[tabsGroup].$tabsGroup.on('tabChange', function (
        evt
      ) {
        var title = $(self.$tabs[evt.tabIndex - 1]).data('tabTitle');
        if (title.toLowerCase() == 'my cart') {
          self.$accountViewRight.removeClass('hidden');
        } else {
          self.$accountViewRight.addClass('hidden');
        }
      });

      window.theme.tabsGroups[tabsGroup].$navContainer
        .addClass('swipeable')
        .css('overflow-x', 'auto');

      var $cartTab = window.theme.tabsGroups[tabsGroup].$navContainer
        .children()
        .filter(function () {
          return $(this).data('targetTitle') == 'My Cart';
        });

      var cartCountHtml =
        '<span rv-class-cart-count--even="cart.item_count | modulo 2 | eq 0" rv-class-cart-count--odd="cart.item_count | modulo 2 | eq 1" class="cart-count" rv-html="cart.item_count">{{ cart.item_count }}</span>';

      $cartTab.append(cartCountHtml);
      tinybind.bind($cartTab, { cart: CartJS.cart });
    });
  }

  return DashboardPlaceOrder;
})();
window.theme = window.theme || {};

theme.DashboardReports = (function () {
  var selectors = {
    dropdownButton: '[data-dropdown-button]',
    dropdownOptions: '[data-dropdown-options]',
  };

  function DashboardReports(container) {
    this.$container = $(container);
    this.data = {};

    this.ui = {
      active: {},
    };

    this._bindView();
    this._getReportsData();
  }

  DashboardReports.prototype = $.extend({}, DashboardReports.prototype, {
    _getReportsData: function () {
      var self = this;

      // TODO: Check SessionStorage

      $.ajax({
        url: '/account?view=dashboard-reports-json',
      }).done(function (data) {
        var dataJson = JSON.parse(data.replace(/<!--[\s\S]*?-->/g, ''));
        self.data.reports = dataJson;
        self.ui.loadComplete = true;

        if (!dataJson.reports.length) {
          return;
        }

        self.ui.active = {
          days: dataJson.reports[0].days,
          title: dataJson.reports[0].title,
        };

        self._bindDropdown();
      });
    },

    _bindView: function () {
      var self = this;

      var $el = self.$container;
      tinybind.bind($el, {
        ui: self.ui,
        data: self.data,
        actions: {
          toggleDropdown: self._toggleDropdown.bind(self),
          openDropdown: self._openDropdown.bind(self),
          closeDropdown: self._closeDropdown.bind(self),
          changeActiveReport: self._changeActiveReport.bind(self),
        },
      });
    },

    _toggleDropdown: function () {
      var self = this;
      self.ui.showDropdown = !self.ui.showDropdown;
    },

    _openDropdown: function () {
      var self = this;
      self.ui.showDropdown = true;
    },

    _closeDropdown: function () {
      var self = this;
      self.ui.showDropdown = false;
    },

    _changeActiveReport: function () {
      var self = this;

      var $target = $(event.target);
      var reportDays = $target.attr('data-report-days');
      var reportTitle = $target.attr('data-report-title');

      self.ui.active = {
        days: parseInt(reportDays),
        title: reportTitle,
      };

      self._closeDropdown();
    },

    _bindDropdown: function () {
      var self = this;

      var $button = $(selectors.dropdownButton, self.$container);
      var $options = $(selectors.dropdownOptions, self.$container);

      self.dropdown = new Popper($button[0], $options[0], {
        placement: 'bottom-end',
      });
    },
  });

  return DashboardReports;
})();
window.theme = window.theme || {};
window.theme.slideshows = window.theme.slideshows || {};

theme.ProductRelatedProducts = (function () {
  var selectors = {
    slideshow: '[data-slideshow]',
  };

  function ProductRelatedProducts(container) {
    this.$container = $(container);
    this.$slideshows = $(selectors.slideshow, this.$container);

    $.each(this.$slideshows, function (index, slideshow) {
      theme.slideshows[slideshow] = new theme.Slideshow(slideshow);
    });
  }

  return ProductRelatedProducts;
})();
window.theme = window.theme || {};

theme.ConstantCart = (function () {
  var selectors = {
    cart: '.cart-drawer__inner',
    constantContainer: '.constant-cart',
    drawerContainer: '#CartDrawer',
    accountViewRight: '.account__view-right',
  };

  var options = {
    // breakpoint: 1200
    breakpoint: 1330,
  };

  var breakpoints = {
    desktop: 'screen and (min-width: ' + options.breakpoint + 'px)',
    mobile: 'screen and (max-width: ' + (options.breakpoint - 1) + 'px)',
  };

  function ConstantCart(container) {
    this.$container = $(container);
    this.$constantContainer = $(selectors.constantContainer, this.$container);
    this.$drawerContainer = $(selectors.drawerContainer);
    this.$cart = $(selectors.cart);
    this.$accountViewRight = this.$container.closest(
      selectors.accountViewRight
    );
    this.$stickyElement = this.$accountViewRight.children().first();

    var self = this;

    this.$stickyElement.stickybits({ stickyBitStickyOffset: 40 });

    enquire.register(breakpoints.mobile, {
      match: function () {
        self._makeDrawer();
      },
    });

    enquire.register(breakpoints.desktop, {
      match: function () {
        self._makeConstant();
      },
    });
  }

  ConstantCart.prototype = $.extend({}, ConstantCart.prototype, {
    _makeConstant: function () {
      this.$cart.detach();
      this.$constantContainer.append(this.$cart);

      $('body').addClass('cart-is-constant');
      this.$accountViewRight.css('display', '');
    },

    _makeDrawer: function () {
      this.$cart.detach();
      this.$drawerContainer.append(this.$cart);

      $('body').removeClass('cart-is-constant');
      this.$accountViewRight.css('display', 'none');
    },
  });

  return ConstantCart;
})();
window.theme = window.theme || {};

theme.StickySubNav = (function () {
  var selectors = {
    subNav: '.sticky-sub-nav',
  };

  var options = {
    stickybits: {},
  };

  function StickySubNav(container) {
    this.$container = $(container);

    this.$subNav = $(selectors.subNav).insertBefore(this.$container.parent());
    this.$subNav.stickybits(options.stickybits);
  }

  return StickySubNav;
})();

window.theme = window.theme || {};

theme.StoreLocator = (function () {
  var selectors = {
    storesDataContainer: 'script#store-locations',
    filtersDataContainer: 'script#store-location-filters',
    mapContainer: '#Map-',
  };

  var defaults = {
    map: {
      zoom: 6,
      center: {
        lat: -40.895021,
        lng: 170.5285246,
      },
      zoomControl: true,
      mapTypeControl: false,
      scaleControl: true,
      streetViewControl: false,
      rotateControl: false,
      fullscreenControl: true,
    },
    rawDataType: 'json',
    googlePlacesFields: ['url'],
    enableSearch: true,
  };

  function StoreLocator(container) {
    this.container = container;
    this.sectionId = container.dataset.sectionId;
    this.mapContainer = document.querySelector(
      selectors.mapContainer + this.sectionId
    );

    if (!this.container) {
      return;
    }

    this.data = {
      parsedData: {},
      stores: [],
      groups: [],
      filters: [],
      tags: [],
      activeFilters: [],
      activeStore: null,
      activeGroup: null,
      storesInFilter: [],
      storesInView: [],
    };

    this.methods = {
      focusStore: this._focusStore.bind(this),
      zoomToFitMarkers: this._zoomToFitMarkers.bind(this),
      selectGroup: this._focusGroup.bind(this),
      selectFilter: this._focusFilter.bind(this),
      clearFilter: this._clearFilters.bind(this),
      findUser: this._findUser.bind(this),
    };

    this._prepareData();
    this._bindView();
    this._buildMap();

    if ('geolocation' in navigator) {
      this.data.geolocationEnabled = true;
    }

    this.data.is_ready = true;
  }

  StoreLocator.prototype = _.extend({}, StoreLocator.prototype, {
    _onMapLoadComplete: function () {
      this._setActiveStoreFromQueryParam();
    },

    _setActiveStoreFromQueryParam: function () {
      var queryparams, handle, store;

      queryparams = theme.utils.getQueryParams();

      if (queryparams && queryparams.store) {
        handle = queryparams.store;
        store = _.find(this.data.stores, { handle: handle });
      }

      if (store) {
        this._setActiveStore(store);
      }
    },

    _focusFilter: function () {
      var id, filter;

      id = event.currentTarget.dataset.filterId;
      filter = _.find(this.data.filters, { id: id });

      if (!filter) {
        console.error(new Error('No filter found!'));
        return;
      }

      if (filter.active) {
        this._setActiveFilter(filter, 'remove');
      } else {
        this._setActiveFilter(filter, 'add');
      }
    },

    _setActiveFilter: function (filter, action, updateMap) {
      var self = this;

      // action = 'add', 'remove', 'replace', 'reset'

      if (!action) {
        console.error('An action must be defined');
        console.error('action = add, remove, replace, reset');
        return;
      }

      this._setActiveStore(false, false);

      switch (action) {
        case 'replace':
          _.each(this.data.activeFilters, function (filter) {
            filter.active = false;
          });

          this.data.activeFilters = [];

          filter.active = true;
          this.data.activeFilters.push(filter);
          break;

        case 'remove':
          filter.active = false;
          _.remove(this.data.activeFilters, { id: filter.id });
          break;

        case 'add':
          filter.active = true;
          this.data.activeFilters.push(filter);
          break;

        case 'reset':
          _.each(this.data.activeFilters, function (filter) {
            filter.active = false;
          });

          this.data.activeFilters = [];
          break;
      }

      _.each(this.data.stores, function (store, i) {
        var storeInFilter = true;

        _.each(self.data.activeFilters, function (filter) {
          if (!store.tags || store.tags.indexOf(filter.tag) == -1) {
            storeInFilter = false;
          }
        });

        if (storeInFilter) {
          self._addStoreToFilter(store);
        } else {
          self._removeStoreFromFilter(store);
        }
      });

      if (self.data.activeFilters.length == 0) {
        this.data.storesAreFiltered = false;
      } else {
        this.data.storesAreFiltered = true;
      }

      this._getMarkersInView();

      this._toggleFiltersNoResultsMessage();
    },

    _toggleFiltersNoResultsMessage: function () {
      if (this.data.storesAreFiltered && this.data.storesInFilter.length == 0) {
        this.data.filterNoResults = true;
      } else {
        this.data.filterNoResults = false;
      }
    },

    _clearFilters: function () {
      this._setActiveFilter(false, 'reset');
    },

    _addStoreToFilter: function (store) {
      if (store.in_filter == true) {
        return;
      }

      store.in_filter = true;
      store.marker.setMap(this.map);
      store.markerCluster.addMarker(store.marker);
      store.markerCluster.redraw();

      this.data.storesInFilter.push(store);
    },

    _removeStoreFromFilter: function (store) {
      if (store.in_filter == false) {
        return;
      }

      store.in_filter = false;
      store.markerCluster.removeMarker(store.marker);
      store.marker.setMap(null);
      store.markerCluster.redraw();

      _.pull(this.data.storesInFilter, store);
    },

    _focusStore: function () {
      var id, store;

      id = event.currentTarget.dataset.storeId;
      store = _.find(this.data.stores, { id: id });

      if (!store) {
        console.error(new Error('No store found!'));
        return;
      }

      // If a link is cliked, only follow the link if the store is active
      if (event.target && event.target.nodeName == 'A') {
        if (store.active) {
          return;
        } else {
          event.preventDefault();
        }
      }

      this._setActiveStore(store);
    },

    _setActiveStore: function (store, updateMap) {
      var self = this;

      var marker,
        markerPosition,
        activeStore,
        currentMapBounds,
        currentMapZoom,
        boundsContainsMarker;

      activeStore = this.data.activeStore;

      if (activeStore) {
        activeStore.active = false;

        if (activeStore.infoWindow) {
          activeStore.infoWindow.close();
        }
      }

      if (store == false) {
        this.data.activeStore = null;
        return;
      }

      if (updateMap != false) {
        marker = store.marker;

        markerPosition = marker.getPosition();
        currentMapBounds = this.map.getBounds();
        boundsContainsMarker = currentMapBounds
          ? currentMapBounds.contains(markerPosition)
          : false;
        currentMapZoom = this.map.getZoom();

        if (!boundsContainsMarker || currentMapZoom < 12) {
          this.map.panTo(markerPosition);
          this.map.setZoom(14);
        }
      }

      if (store.group) {
        this._setActiveGroup(store.group, false);
      }

      this.data.activeStore = store;
      store.active = true;

      if (store.place_id && !store.place && !store.is_loading) {
        this._fetchStoreDetails(store, function () {
          self._openStoreInfoWindow(store);
        });
      } else {
        self._openStoreInfoWindow(store);
      }
    },

    _fetchStoreDetails: function (store, callback) {
      var request;

      store.is_loading = true;

      request = {
        placeId: store.place_id,
        fields: defaults.googlePlacesFields,
      };

      function formatOpeningHours(periods) {
        // Formats opening hours provided by Google Places API

        var days,
          dayNames,
          dayIndex,
          dayTitle,
          daysString,
          openAmPm,
          openHours,
          openMinutes,
          openTime,
          closeAmPm,
          closeHours,
          closeMinutes,
          closeTime,
          timesString;

        days = [];
        dayNames = ['mon', 'tues', 'wed', 'thurs', 'fri', 'sat', 'sun'];

        _.each(periods, function (period) {
          dayIndex = period.open.day;
          dayTitle = dayNames[dayIndex];

          openAmPm = period.open.hours < 12 ? 'am' : 'pm';
          openHours =
            period.open.hours < 12 ? period.open.hours : period.open.hours - 12;
          openMinutes = period.open.minutes ? ':' + period.open.minutes : '';
          openTime = openHours + openMinutes + openAmPm;

          closeAmPm = period.close.hours < 12 ? 'am' : 'pm';
          closeHours =
            period.close.hours < 12
              ? period.close.hours
              : period.close.hours - 12;
          closeMinutes = period.close.minutes ? ':' + period.close.minutes : '';
          closeTime = closeHours + closeMinutes + closeAmPm;

          timesString = openTime + ' - ' + closeTime;

          daysString = dayTitle;

          function TimePeriod(options) {
            _.extend(this, options);
          }

          days.push(
            new TimePeriod({
              startDay: dayTitle,
              endDay: dayTitle,
              daysString: daysString,
              timesString: timesString,
              open: openTime,
              close: closeTime,
            })
          );
        });

        _.each(days, function (day, i) {
          var nextDay;

          nextDay = days[i + 1];

          if (nextDay && day.timesString == nextDay.timesString) {
            nextDay.startDay = day.startDay;
            nextDay.daysString = nextDay.startDay + ' - ' + nextDay.endDay;
            day.toDelete = true;
          }
        });

        _.remove(days, { toDelete: true });

        return days;
      }

      this.placesService.getDetails(request, function (place, status) {
        if (status === google.maps.places.PlacesServiceStatus.OK) {
          store.place = place;

          // store.open_now = place.opening_hours.open_now;
          // store.opening_hours = (place.opening_hours.periods ? formatOpeningHours(place.opening_hours.periods) : []);
          // store.int_phone = place.international_phone_number;
          // store.phone = (place.formatted_phone_number ? place.formatted_phone_number.replace(/\-/g, ' ') : false);
          // store.permanently_closed = place.permanently_closed;
          store.google_url = place.url;

          store.is_loading = false;

          if (callback && typeof callback == 'function') {
            callback();
          }
        } else {
          console.error(new Error('Error receiving data from Places service'));

          if (callback && typeof callback == 'function') {
            callback();
          }
        }
      });
    },

    _openStoreInfoWindow: function (store) {
      var self = this;

      var marker;

      marker = store.marker;

      if (!store.infoWindow) {
        store.infoWindowContent = document.createElement('div');
        store.infoWindowContent.innerHTML = theme.utils.getTemplate(
          'store-location-info-popup'
        );

        tinybind.bind(store.infoWindowContent, {
          store: store,
        });

        store.infoWindow = new google.maps.InfoWindow({
          content: store.infoWindowContent,
        });
      }

      store.infoWindow.open(self.map, store.marker);
    },

    _focusGroup: function () {
      var id, group;

      id = event.currentTarget.value;

      if (id == '' || id == 'none') {
        this._setActiveGroup(false);
        return;
      }

      group = _.find(this.data.groups, { id: id });

      if (!group) {
        console.error(new Error('No group found!'));
        return;
      }

      this._setActiveGroup(group);
    },

    _setActiveGroup: function (group, updateMap) {
      var self = this;

      var center, address, markerPosition, activeGroup;

      activeGroup = this.data.activeGroup;
      if (activeGroup) {
        activeGroup.active = false;
      }

      if (group == false) {
        this.data.activeGroup = null;
        this._zoomToFitMarkers();
        this._setActiveStore(false, false);
        return;
      }

      this.data.activeGroup = group;
      group.active = true;

      if (updateMap == false) {
        return;
      }

      this._setActiveStore(false, false);

      if (group.markers.length > 1) {
        bounds = new google.maps.LatLngBounds();

        _.each(group.markers, function (marker, i) {
          bounds.extend(marker.getPosition());
        });

        self.map.fitBounds(bounds);
      } else {
        markerPosition = group.markers[0].getPosition();

        this.map.panTo(markerPosition);
        this.map.setZoom(14);
      }

      //  IF LOOKUP UP A REGION FROM MAPS API

      // if (region.geo) {
      //   console.info(this.data);
      //   this.map.fitBounds(region.geo.bounds);
      //   return;
      // }

      // this.geocoder.geocode({
      //   'address': region.title,
      //   'bounds': bounds
      // }, function(results, status) {

      //   if (status == 'OK') {
      //     center = results[0].geometry;
      //     region.geo = center;

      //     self.map.fitBounds(region.geo.bounds);
      //   } else {
      //     console.error(new Error('Geocode error: ' + status));
      //   }

      // });
    },

    _prepareData: function () {
      var self = this;

      this._getData(processData);

      function processData() {
        self._prepareStoresData();
        self._prepareStoresTagsData();
        self._prepareGroupsData();
        self._prepareFiltersData();
      }
    },

    _getData: function (callback) {
      var dataContainer, rawData, parsedData, parseOptions, rawDataType;

      dataContainer = document.querySelector(selectors.storesDataContainer);

      rawDataType = defaults.rawDataType;

      if (!dataContainer) {
        console.error(new Error('Missing data container'));
        return;
      }

      rawData = dataContainer.innerHTML;

      switch (rawDataType) {
        case 'json':
          this.data.parsedData.data = JSON.parse(rawData);
          callback();
          return;

        case 'csv':
          parseOptions = {
            header: true,
            dynamicTyping: true,
          };

          this.data.parsedData = Papa.parse(rawData, parseOptions);
          callback();
          return;

        default:
          this.data.parsedData.data = rawData;
          callback();
          return;
      }
    },

    _prepareStoresData: function () {
      var self = this;

      var locationMarkerSVG, googleMapsSearchURLPrefix;

      locationMarkerSVG = theme.utils.getTemplate('store-location-marker-icon');
      googleMapsSearchURLPrefix = 'https://www.google.com/maps/search/';

      function Store(data) {
        _.extend(this, data);

        this.id = theme.utils.handleize(this.title);
        this.icon = locationMarkerSVG;
        this.google_url =
          googleMapsSearchURLPrefix +
          theme.utils.handleize(this.title).replace(/\-/g, '+') +
          '+' +
          theme.utils.handleize(this.street).replace(/\-/g, '+');
        this.opening_hours = _.map(this.opening_hours.split(/,/), function (
          period
        ) {
          return _.map(period.replace(/:/, '#').split(/#/), _.trim);
        });
      }

      if (
        self.data.parsedData.errors &&
        self.data.parsedData.errors.length > 0
      ) {
        console.error(new Error('There was an error parsing data'));
        console.error(data.parsedData.errors);
        return;
      }

      _.each(self.data.parsedData.data, function (value) {
        var store, locationData, existingArea;

        // Build store data
        store = new Store(value);
        self.data.stores.push(store);
      });

      // Sort stores by title
      self.data.stores = _.orderBy(
        self.data.stores,
        ['title'],
        ['city'],
        ['street']
      );
    },

    _prepareStoresTagsData: function () {
      var self = this;

      function Tag(data) {
        _.extend(this, data);
        this.id = theme.utils.handleize(this.title);
      }

      _.each(this.data.stores, function (store, i) {
        var existingTag, tagString, tags;

        if (store.tags && typeof store.tags == 'string') {
          tags = store.tags.split(',');

          store.tags = [];

          _.each(tags, function (tagString) {
            tagString = theme.utils.handleize(tagString);

            existingTag = _.find(self.data.tags, { title: tagString });

            if (!existingTag) {
              tag = new Tag({ title: tagString });
              self.data.tags.push(tag);
            } else {
              tag = existingTag;
            }

            store.tags.push(tag);
          });
        }
      });
    },

    _prepareGroupsData: function () {
      var self = this;

      function Group(data) {
        _.extend(this, data);
        this.id = theme.utils.handleize(this.title);
      }

      _.each(this.data.stores, function (store, i) {
        var locationData, existingGroup;

        if (store.group && typeof store.group == 'string') {
          existingGroup = _.find(self.data.groups, { title: store.group });

          if (!existingGroup) {
            locationData = {
              title: store.group,
            };

            group = new Group(locationData);
            self.data.groups.push(group);
            group.stores = [];
          } else {
            group = existingGroup;
          }

          store.group = group;

          group.stores.push(store);
        }
      });
    },

    _prepareFiltersData: function () {
      var self = this;

      var dataContainer, rawData, jsonData;

      dataContainer = document.querySelector(selectors.filtersDataContainer);

      if (!dataContainer) {
        console.error(new Error('Missing data container'));
        return;
      }

      rawData = dataContainer.innerHTML;
      jsonData = JSON.parse(rawData);

      function Filter(data) {
        _.extend(this, data);
        this.id = theme.utils.handleize(this.title);
      }

      _.each(jsonData, function (value) {
        var filter, tag;

        value.tag = _.find(self.data.tags, { title: value.tag });

        if (value.tag) {
          value.tag.icon = value.icon;
        }

        filter = new Filter(value);
        self.data.filters.push(filter);
      });
    },

    _bindView: function () {
      tinybind.bind(this.container, {
        data: this.data,
        methods: this.methods,
      });
    },

    _buildMap: function () {
      var self = this;

      var googleMapsAPIURL, googleMapsAPIKEY, googleMapsAdditionalLibraries;

      googleMapsAPIURL = 'https://maps.googleapis.com/maps/api/js?key=';
      googleMapsAPIKEY = shop.keys.googleMaps;
      googleMapsAdditionalLibraries = '&libraries=places';

      if (!googleMapsAPIKEY) {
        return console.error(
          new Error(
            'Google Maps API key is required. You can set this up as as Store metafield: '
          )
        );
      }

      var options = defaults.map;

      function initMap() {
        self.geocoder = new google.maps.Geocoder();
        self.map = new google.maps.Map(self.mapContainer, options);
        self.placesService = new google.maps.places.PlacesService(self.map);
        self._addMapMarkers();

        google.maps.event.addListenerOnce(self.map, 'idle', function () {
          self._onMapLoadComplete();
        });

        if (defaults.enableSearch) {
          self._prepareSearch();
        }
      }

      loadJS(
        googleMapsAPIURL + googleMapsAPIKEY + googleMapsAdditionalLibraries,
        initMap
      );
    },

    _addMapMarkers: function () {
      var self = this;

      _.each(this.data.stores, function (store, i) {
        var position, icon;

        position = {
          lat: store.lat,
          lng: store.long,
        };

        icon = store.icon;

        store.marker = new google.maps.Marker({
          position: position,
          map: self.map,
          icon: {
            url: 'data:image/svg+xml;charset=UTF-8,' + encodeURIComponent(icon),
            size: new google.maps.Size(28, 40),
            origin: new google.maps.Point(0, 0),
            anchor: new google.maps.Point(14, 40),
            scaledSize: new google.maps.Size(28, 40),
          },
          optimized: false,
        });

        if (store.group) {
          store.group.markers = store.group.markers || [];
          store.group.markers.push(store.marker);
        }

        store.marker.addListener('click', function () {
          self._setActiveStore(store);
        });
      });

      this._clusterMarkers();
      this._zoomToFitMarkers();
      this._bindMapListners();
    },

    _clusterMarkers: function () {
      var self = this;

      var clusterMarkerSVG = theme.utils.getTemplate(
        'store-location-marker-icon'
      );

      _.each(this.data.groups, function (group, i) {
        var clusterStyles = [
          {
            width: 28,
            height: 40,
            url:
              'data:image/svg+xml;charset=UTF-8,' +
              encodeURIComponent(clusterMarkerSVG),
            textColor: 'transparent',
            textSize: 0,
            iconAnchor: [50, 100],
          },
        ];

        group.markerCluster = new MarkerClusterer(self.map, group.markers, {
          gridSize: 30,
          styles: clusterStyles,
          zoomOnClick: true,
        });

        _.each(group.stores, function (store) {
          store.markerCluster = group.markerCluster;
        });
      });
    },

    _zoomToFitMarkers: function () {
      var bounds = new google.maps.LatLngBounds();

      _.each(this.data.stores, function (store, i) {
        bounds.extend(store.marker.getPosition());
      });

      this.map.fitBounds(bounds);
    },

    _bindMapListners: function () {
      var self = this;

      this.map.addListener(
        'bounds_changed',
        _.debounce(this._getMarkersInView.bind(self), 50)
      );
    },

    _unbindMapListners: function () {
      var self = this;

      google.maps.event.clearListeners(this.map, 'bounds_changed');
    },

    _getMarkersInView: function () {
      var self = this;

      this.data.storesInView = [];
      this.data.storesInActiveGroup = [];

      // this.data.activeGroupTitle = 'none';

      var bounds = this.map.getBounds();

      _.each(this.data.stores, function (store, i) {
        var markerPosition, boundsContainsMarker;

        markerPosition = store.marker.getPosition();
        boundsContainsMarker = bounds.contains(markerPosition);

        if (
          boundsContainsMarker &&
          (!self.data.storesAreFiltered ||
            (self.data.storesAreFiltered && store.in_filter))
        ) {
          store.in_view = true;
          self.data.storesInView.push(store);
        } else {
          store.in_view = false;
        }

        if (store.group == self.data.activeGroup) {
          store.in_active_group = true;
          self.data.storesInActiveGroup.push(store);
        } else {
          store.in_active_group = false;
        }
      });

      if (this.data.storesInView && this.data.storesInView.length == 1) {
        var store = this.data.storesInView[0];

        if (store != self.data.activeStore) {
          this._setActiveStore(store, false);
        }
      }
    },

    _findUser: function () {
      var self = this;

      this.data.geolocationLoading = true;

      function success(position) {
        var pos;

        pos = {
          lat: position.coords.latitude,
          long: position.coords.longitude,
        };

        userLocation = new google.maps.LatLng(pos.lat, pos.long);

        self._updateUserMarker(userLocation);

        self._findClosestStore(userLocation);
        self.data.geolocationLoading = false;
      }

      function error() {
        self.data.geolocationLoading = false;
        self.data.geolocationEnabled = false;

        iziToast.error({
          title: "We couldn't find your location",
          position: 'bottomCenter',
          theme: 'light',
        });
      }

      navigator.geolocation.getCurrentPosition(success, error);
    },

    _findClosestStore: function (latLng) {
      var self = this;

      var closestStore, bounds, userLocation;

      bounds = new google.maps.LatLngBounds();

      closestStore = getClosestStore(latLng);

      self._setActiveStore(closestStore, false);

      bounds.extend(closestStore.marker.getPosition());
      bounds.extend(latLng);

      self.map.fitBounds(bounds);

      function getClosestStore(latLng) {
        // https://stackoverflow.com/questions/4057665/google-maps-api-v3-find-nearest-markers
        var lat = latLng.lat();
        var long = latLng.lng();
        var R = 6371; // radius of earth in km
        var distances = [];
        var closest = -1;

        var closestStore = null;

        function rad(x) {
          return (x * Math.PI) / 180;
        }

        _.each(self.data.stores, function (store, i) {
          var mlat = store.lat;
          var mlng = store.long;

          var dLat = rad(mlat - lat);
          var dLong = rad(mlng - long);
          var a =
            Math.sin(dLat / 2) * Math.sin(dLat / 2) +
            Math.cos(rad(lat)) *
              Math.cos(rad(lat)) *
              Math.sin(dLong / 2) *
              Math.sin(dLong / 2);
          var c = 2 * Math.atan2(Math.sqrt(a), Math.sqrt(1 - a));
          var d = R * c;
          distances[i] = d;

          if (closest == -1 || d < distances[closest]) {
            closest = i;
            closestStore = store;
          }
        });

        return closestStore;
      }
    },

    _updateUserMarker: function (latLng) {
      var self = this;

      var pos, icon, user, locationMarkerSVG;

      if (!latLng) {
        console.error(new Error('latLng must be defined'));
        return;
      }

      function User(data) {
        _.extend(this, data);
      }

      if (!this.data.user) {
        locationMarkerSVG = theme.utils.getTemplate(
          'user-location-marker-icon'
        );
        this.data.user = new User({
          icon: locationMarkerSVG,
        });
      }

      user = this.data.user;

      user.latLng = latLng;

      if (!user.marker) {
        icon = user.icon;

        user.marker = new google.maps.Marker({
          position: user.latLng,
          map: self.map,

          icon: {
            url: 'data:image/svg+xml;charset=UTF-8,' + encodeURIComponent(icon),
            size: new google.maps.Size(24, 24),
            origin: new google.maps.Point(0, 0),
            anchor: new google.maps.Point(12, 12),
            scaledSize: new google.maps.Size(24, 24),
          },

          optimized: false,
        });
      } else {
        user.marker.setPosition(user.latLng);
      }
    },

    _prepareSearch: function () {
      this.data.searchEnabled = true;

      var self = this;

      var searchField;

      // If the search box breaks it is because we are
      // using TinyBind but searching for the input field
      // with an ID. Perhaps use a tinybind binder to
      // reference the input field.
      searchField = document.getElementById('store-locator-search');

      this.autocomplete = new google.maps.places.Autocomplete(searchField);

      // #todo: Autocomplete.setFields()

      this.autocomplete.addListener('place_changed', function () {
        var place;

        place = self.autocomplete.getPlace();

        if (!place.geometry) {
          iziToast.error({
            title: "We couldn't find this location",
            position: 'bottomCenter',
            theme: 'light',
          });

          return;
        }

        self._findClosestStore(place.geometry.location);
        self._updateSearchMarker(place.geometry.location);
      });
    },

    _updateSearchMarker: function (latLng) {
      var self = this;

      var pos, icon, locationMarkerSVG;

      if (!latLng) {
        console.error(new Error('latLng must be defined'));
        return;
      }

      function Search(data) {
        _.extend(this, data);
      }

      if (!this.data.search) {
        locationMarkerSVG = theme.utils.getTemplate(
          'search-location-marker-icon'
        );
        this.data.search = new Search({
          icon: locationMarkerSVG,
        });
      }

      search = this.data.search;
      search.latLng = latLng;

      if (!search.marker) {
        icon = search.icon;

        search.marker = new google.maps.Marker({
          position: search.latLng,
          map: self.map,

          icon: {
            url: 'data:image/svg+xml;charset=UTF-8,' + encodeURIComponent(icon),
            size: new google.maps.Size(24, 24),
            origin: new google.maps.Point(0, 0),
            anchor: new google.maps.Point(12, 12),
            scaledSize: new google.maps.Size(24, 24),
          },

          optimized: false,
        });
      } else {
        search.marker.setPosition(search.latLng);
      }
    },
  });

  return StoreLocator;
})();

window.theme = window.theme || {};
window.theme.slideshows = window.theme.slideshows || {};

theme.RelatedItems = (function () {
  var selectors = {
    slideshow: '[data-slideshow]',
  };

  function RelatedItems(container, options) {
    if (!container || !options) {
      return;
    }

    this.related = options.related || {};

    tinybind.bind(container, {
      related: {
        type: options.type || 'products',
        products: this.related.products,
        articles: this.related.articles,
      },
    });

    this.slideshowEl = container.querySelectorAll('[data-slideshow]');

    var self = this;

    if (this.slideshowEl) {
      var $slideshow = $(this.slideshowEl);

      $slideshow.on('init', function (evt, slick) {
        self.appendSlickScrollbar(slick);
      });

      $slideshow.on('beforeChange', function (
        evt,
        slick,
        currentSlide,
        nextSlide
      ) {
        var activeSlidesCount = slick.$slides.filter('.slick-active').length;
        var currentMarkerOffset = (nextSlide * 100) / activeSlidesCount;
        $('.slick-scrollbar-mark', slick.$slider.next()).css(
          'transform',
          'translateX(' + currentMarkerOffset + '%)'
        );
      });

      this.slideshow = new theme.Slideshow($slideshow);
      theme.slideshows[this.slideshowEl] = this.slideshow;
    }
  }

  RelatedItems.prototype = _.assignIn({}, RelatedItems.prototype, {
    appendSlickScrollbar: function (slick) {
      var existingScrollBar = slick.$slider.next('.slick-scrollbar');
      if (existingScrollBar) {
        $(existingScrollBar).remove();
      }

      var activeSlidesCount = slick.$slides.filter('.slick-active').length;

      if (activeSlidesCount != slick.$slides.length) {
        var currentMarkerOffset = slick.currentSlide * 100;
        var scrollbarMarkerWidth =
          (1 / slick.slideCount) * 100 * activeSlidesCount;
        slick.$slider.after(
          '<div class="slick-scrollbar"><div class="slick-scrollbar-mark" style="width: ' +
            scrollbarMarkerWidth +
            '%"></div></div>'
        );
        $('.slick-scrollbar-mark', slick.$slider).css(
          'transform',
          'translateX(' + currentMarkerOffset + '%)'
        );
      }
    },
  });

  return RelatedItems;
})();

// =require sections/wishlist-page.js
window.theme = window.theme || {};
window.theme.slideshows = window.theme.slideshows || {};

theme.Ingredients = (function () {
  var selectors = {
    slideshow: '[data-slideshow]',
  };

  var slideshowTemplate = theme.utils.getTemplate(
    'active-ingredient-slideshow'
  );

  function Ingredients(container) {
    this.container = container;

    this.data = {
      ready: false,
      ingredients: [],
      filters: [],
    };

    this.methods = {
      setActiveFilterByIndex: this.setActiveFilterByIndex.bind(this),
      setActiveIngredientByIndex: this.setActiveIngredientByIndex.bind(this),
      removeActiveIngredient: this.removeActiveIngredient.bind(this),
      reverseIngredients: this.reverseIngredients.bind(this),
    };

    this._bind();
    this._prepareIngredients();
    this._addTaggedProducts();
    this._googleTagListener();

    this.data.ready = true;

    console.info(this.data);
  }

  Ingredients.prototype = _.assignIn({}, Ingredients.prototype, {
    _bind: function () {
      tinybind.bind(this.container, {
        data: this.data,
        methods: this.methods,
      });
    },

    _prepareIngredients: function () {
      var i, j, ingredient, ingredients, tags, tag;

      function Ingredient(data) {
        _.extend(this, data);
      }

      ingredients = window.ingredients;
      i = ingredients.length;

      while (i--) {
        ingredient = new Ingredient(ingredients[i]);
        this.data.ingredients.push(ingredient);

        j = ingredient.tags.length;

        while (j--) {
          tag = ingredient.tags[j];
          if (this.data.filters.indexOf(tag) == -1) {
            this.data.filters.push(tag);
          }
        }
      }

      this.data.ingredients = _.sortBy(this.data.ingredients, ['id'], function (
        num
      ) {
        return num;
      });

      this.data.filters = _.sortBy(this.data.filters);
    },

    _googleTagListener: function() {
      $('.ingredient').on("click", function() {
        const ingredientName = $(this).data("name");
        ga('send', 'event', 'Ingredient', 'click', ingredientName);
        console.log("clicked on " + ingredientName);
      });
    },

    _addTaggedProducts: function (){
      for (let i = 0; i < this.data.ingredients.length; i++) {
        let tag = this.data.ingredients[i].relatedProductsTag;
        if (tag) {
          this.getTaggedProducts(tag).then((data) => {
            this.data.ingredients[i].relatedTaggedProducts = data;
          })
        }
      }
    },

    getTaggedProducts: function (tag) {
      return new Promise((resolve, reject) => {
        $.ajax('/collections/all/' + tag + '?view=data',
        {
          success: function (data, status, xhr) {
            data = JSON.parse(data);
            let products = [];
            $.each(data, function(index, item) {
              let product = {
                id: item.id,
                title: item.title,
                url: item.url,
              }
              products.push(product);
            });
            resolve(products);
          }
        });
      });
    },

    setActiveFilterByIndex: function () {
      var index = event.currentTarget.dataset.index;
      var targetFilter = this.data.filters[index];

      this.removeActiveIngredient();

      if (this.data.activeFilter == targetFilter) {
        this.data.activeFilter = null;
      } else {
        this.data.activeFilter = targetFilter;
      }
    },

    reverseIngredients: function () {
      var cache = [];

      while (this.data.ingredients.length) {
        cache.push(this.data.ingredients.pop());
      }

      while (cache.length) {
        this.data.ingredients.push(cache.shift());
      }
    },

    setActiveIngredientByIndex: function () {
      var index = event.currentTarget.dataset.index;
      var targetIngredient = this.data.ingredients[index];
      var targetIngredientId = targetIngredient.id;
      var self = this;

      if (
        this.data.showPreviewPanel &&
        this.data.activeIngredient &&
        this.data.activeIngredient.id == targetIngredientId
      ) {
        this.removeActiveIngredient();
        return;
      } else {
        this.removeActiveIngredient();
        this.data.activeIngredient = targetIngredient;
        this.data.activeIngredient.isActive = true;
        this.data.showPreviewPanel = true;
        this._setRelatedProducts(this.data.activeIngredient);
        this._getRelatedProducts(this.data.activeIngredient, function () {
          if (targetIngredientId == self.data.activeIngredient.id) {
            self._initSlideshow.apply(self);
          }
        });
      }
    },

    _initSlideshow: function () {
      if (
        !this.data.activeIngredient.products ||
        !this.data.activeIngredient.products.length
      ) {
        return;
      }

      var self = this;
      var slideshowContainerEl = this.container.querySelector(
        '.active-ingredient__products'
      );

      var slideshowEl = theme.utils.createElementFromHTML(slideshowTemplate);
      slideshowContainerEl.appendChild(slideshowEl);

      tinybind.bind(slideshowEl, {
        data: this.data,
      });

      this.$slideshow = $(slideshowEl).children('[data-slideshow]');

      this.$slideshow.on('init', function (evt, slick) {
        self._appendSlickScrollbar(slick);
      });

      this.$slideshow.on('beforeChange', function (
        evt,
        slick,
        currentSlide,
        nextSlide
      ) {
        if (slick.$slides) {
          var activeSlidesCount = slick.$slides.filter('.slick-active').length;
          var currentMarkerOffset = (nextSlide * 100) / activeSlidesCount;
          $('.slick-scrollbar-mark', slick.$slider.next()).css(
            'transform',
            'translateX(' + currentMarkerOffset + '%)'
          );
        }
      });

      new theme.Slideshow(this.$slideshow);
    },

    _appendSlickScrollbar: function (slick) {
      var existingScrollBar = slick.$slider.next('.slick-scrollbar');
      if (existingScrollBar) {
        $(existingScrollBar).remove();
      }

      var activeSlidesCount = slick.$slides.filter('.slick-active').length;

      if (activeSlidesCount != slick.$slides.length) {
        var currentMarkerOffset = slick.currentSlide * 100;
        var scrollbarMarkerWidth =
          (1 / slick.slideCount) * 100 * activeSlidesCount;
        slick.$slider.after(
          '<div class="slick-scrollbar"><div class="slick-scrollbar-mark" style="width: ' +
            scrollbarMarkerWidth +
            '%"></div></div>'
        );
        $('.slick-scrollbar-mark', slick.$slider).css(
          'transform',
          'translateX(' + currentMarkerOffset + '%)'
        );
      }
    },

    // _transition: function() {
    //   var self = this;

    //   this.data.isTransitioning = true;

    //   setTimeout(function() {
    //     self.data.isTransitioning = false;
    //   }, 500);
    // },

    removeActiveIngredient: function () {
      if (this.$slideshow) {
        this.$slideshow.slick('unslick');
        var slideshowContainerEl = this.container.querySelector(
          '.active-ingredient__products'
        );
        slideshowContainerEl.innerHTML = '';
      }

      if (this.data.activeIngredient) {
        this.data.activeIngredient.isActive = false;
        this.data.showPreviewPanel = false;
        this.data.activeIngredient = {};
      }
    },

    _setRelatedProducts: function (activeIngredient) {
      $("#related-products-container").empty();
      const relatedProducts = activeIngredient.relatedTaggedProducts;
      const template = `
        <div class="related-product-wrapper">
          <a href="%url%">
            <div>%title%</div>
          </a>
        </div>
      `;
      const templateTitle = `
        <div class="related-products-title">This ingredient is found in products like:</div>
      `;
      if (relatedProducts.length > 0) {
        $("#related-products-container").append(templateTitle);
      }
      for (let i=0; i < relatedProducts.length; i++) {
        let productTemplate = template;
        productTemplate = productTemplate.replace(/%url%/g, relatedProducts[i].url);
        productTemplate = productTemplate.replace(/%title%/g, relatedProducts[i].title);
        $("#related-products-container").append(productTemplate);
      }
    },

    _getRelatedProducts: function (ingredient, callback) {
      callback = callback || _.noop;

      var url =
        '/collections/_all-products/' +
        theme.utils.handleize(ingredient.title) +
        '?view=data';

      if (ingredient.products) {
        callback(ingredient.products);
        return;
      }

      $.get(url, function (data) {
        ingredient.products = JSON.parse(data);
        callback(ingredient.products);
      });
    },
  });

  return Ingredients;
})();

window.theme = window.theme || {};

theme.Instagram = (function () {
  var config = {
    apiUrl:
      'https://api.instagram.com/v1/users/self/media/recent/?access_token=',
  };

  var selectors = {
    mediaContainer: '.instagram-feature-media',
  };

  function Instagram(container) {
    this.$container = $(container);

    this.loadContent({
      $container: this.$container,
      accessToken: this.$container.data('access-token'),
      limit: this.$container.data('limit'),
    });

    // $('esf').on('galleryPostsLoaded.ElfsightShoppableFeed', function(){
    //   if ($(window).width() < 768) {
    //     $(this).removeClass('elfsight-sf');
    //     $('.elfsight-sf-feed', this).slick({
    //       arrows: false,
    //       centerMode: true,
    //     });
    //   }
    // });
  }

  Instagram.prototype = _.assignIn({}, Instagram.prototype, {
    loadContent: function (settings) {
      if (settings.accessToken) {
        var url = config.apiUrl + settings.accessToken;

        $.ajax({
          type: 'GET',
          url: url,
          dataType: 'jsonp',
          success: function (data) {
            if (data.meta.code === 200 && data.data.length) {
              data = data.data;
              var count = 0;
              var $mediaContainer = $(
                selectors.mediaContainer,
                settings.$container
              );
              $mediaContainer.empty();

              for (var i = 0; i < data.length && count < settings.limit; i++) {
                var media = data[i],
                  item;

                if (!media.images.low_resolution.url.includes('null')) {
                  item =
                    '<img class="instagram-feed__img" src="' +
                    media.images.low_resolution.url +
                    '" data-filter="' +
                    media.filter +
                    '" />';
                  item =
                    '<a href="' +
                    media.link +
                    '" target="_blank">' +
                    item +
                    '</a>';
                }

                /*if(media.videos) {
                  var src;

                  if(media.videos.standard_resolution) {
                    src = media.videos.standard_resolution.url;
                  } else if(media.videos.low_resolution) {
                    src = media.videos.low_resolution.url;
                  } else if(media.videos.low_bandwidth) {
                    src = media.videos.low_bandwidth.url;
                  }

                  item = '<video poster="' + media.images.low_resolution.url + '" controls>';
                  item += '<source src="' + src + '" type="video/mp4;"></source>';
                  item += '</video>';
                }*/
                if (item) {
                  item = '<div class="instagram-feed__item">' + item + '</div>';
                }
                if (item !== '') {
                  $mediaContainer.append(item);
                  count++;
                }
                if (count == settings.limit) {
                  break;
                }
              }
            } else {
              settings.$container.hide();
              console.error(
                'Instagram responded with ' +
                  data.meta.code +
                  ' [' +
                  data.meta.error_type +
                  ']: ' +
                  data.meta.error_message
              );
            }
          },
          error: function () {},
        });
      }
    },
  });

  return Instagram;
})();

window.theme = window.theme || {};

theme.Faq = (function (container) {
  var selectors = {
    container: '.faq-search-input-wrapper',
    searchInput: '.faq-search',
    answersContainer: '.faq-container',
    searchContainer: '.faq-search-wrapper',
    searchButton: '.search-button',
    searchClose: '.search-button.close',
    tabHandles: '.tabs-menu a',
    tabContainer: '.tabs-menu',
    stickyNavigation: '.js-faq-sticky__element',
  };

  function Faq() {
    if ($(selectors.stickyNavigation).length) {
      initStickyNav();
    }

    if ($(selectors.container).length) {
      initSearch();
    }

    if ($(selectors.tabContainer).length) {
      initTabs();
    }

    function initTabs() {
      //show all groups if all tabs is active
      if ($('.all-tabs').length) {
        showAllFaq($('.all-tabs'));
      }

      $('.tabs-menu a').click(function (e) {
        e.preventDefault();
      });

      //this is in tabs already
      function showAllFaq(_this) {
        _this.parent().addClass('current');
        _this.parent().siblings().removeClass('current');
        $('.tab-content').addClass('js-d-flex');
      }
    }

    function initStickyNav() {
      $($(selectors.stickyNavigation)).each(function () {
        var elementOptions = $(this).data() ? $(this).data() : 0;

        $(this).stickybits({
          stickyBitStickyOffset: elementOptions.offsetDesktop,
          useStickyClasses: true,
        });
      });
    }

    function initSearch() {
      var list = window.faq;
      var options = {
        shouldSort: true,
        threshold: 0.6,
        location: 0,
        distance: 100,
        maxPatternLength: 32,
        minMatchCharLength: 1,
        keys: ['category', 'question', 'answer'],
      };
      var fuse = new Fuse(list, options);

      $(selectors.searchInput).on('keyup', function () {
        var search_value = $(this).val();

        if (search_value != '') {
          search(search_value);
        } else {
          closeSearch();
        }
      });

      $(selectors.container).on('click', selectors.searchClose, function () {
        closeSearch();
      });

      function closeSearch() {
        $(selectors.searchContainer).removeClass('active');
        $(selectors.answersContainer).removeClass('hidden');
        $(selectors.searchButton).removeClass('close');
        $(selectors.searchInput).val('');
      }

      function openSearch() {
        $(selectors.searchContainer).addClass('active');
        $(selectors.answersContainer).addClass('hidden');
        $(selectors.searchButton).addClass('close');
      }

      function search(search_value) {
        var result = fuse.search(search_value);
        if (result.length >= 1) {
          openSearch();
        } else {
          $(selectors.searchContainer).html('<p>No results found</p>');
        }
        var searchResults = '';
        $(selectors.searchContainer).html('');
        for (var i = 0; i < result.length; i++) {
          var answerTemplate = theme.utils.getTemplate('faq-item');

          answerTemplate = answerTemplate.replace(
            '{question}',
            result[i].question
          );
          answerTemplate = answerTemplate.replace('{answer}', result[i].answer);

          var answerElement = theme.utils.createElementFromHTML(answerTemplate);
          //searchResults = searchResults + answerTemplate;
          $(selectors.searchContainer).append(answerElement);

          new theme.SimpleAccordion(answerElement);
        }
      }
    }
  }

  return Faq;
})();

(function () {
  var selectors = {
    tabHandles: '.tabs-menu a',
  };

  var classes = {
    qtySelector: 'js-qty-select',
  };

  var $tabHandles = $(selectors.tabHandles);

  if (!$tabHandles.length) {
    return;
  }

  $(selectors.tabHandles).click(function (e) {
    e.preventDefault();
    var $this = $(this);
    var tab = $this.attr('href');
    if ($this.hasClass('all-tabs')) {
      $this.addClass('active');
      $this.siblings().removeClass('active');
      $('.tab-content').addClass('js-d-flex');
    } else {
      $this.addClass('active');
      $this.siblings().removeClass('active');
      $('.tab-content').not(tab).removeClass('js-d-flex');
      $(tab).addClass('js-d-flex');
    }
  });
})();

window.theme = window.theme || {};

theme.Customer = (function () {
  var selectors = {
    AccountNavDrawer: '.account-nav-drawer',
    drawerOpenTrigger: '.account-nav--open',
  };

  function Customer() {
    $(selectors.drawerTrigger).on('click', function () {
      var position = parseInt($(this).attr('data-position'));
      $(this)
        .closest('.account-drawer-wrapper')
        .attr('data-drawer-inner-position', position.toString());
    });

    $('[data-position]', '.login-page-form').on('click', function () {
      var position = parseInt($(this).attr('data-position'));

      $(this)
        .closest('.login-form-wrapper')
        .attr('data-page-inner-position', position.toString());
    });

    if (window.location.href.indexOf('#recover') > -1) {
      var position = 3;
      $('.login-form-wrapper').attr(
        'data-page-inner-position',
        position.toString()
      );
    }
  }

  return Customer;
})();

/*================ Templates ================*/
/**
 * Customer Addresses Script
 * ------------------------------------------------------------------------------
 * A file that contains scripts highly couple code to the Customer Addresses
 * template.
 *
 * @namespace customerAddresses
 */

theme.customerAddresses = (function () {
  var $newAddressForm = $('#AddressNewForm');

  if ($newAddressForm.length) {
    // Initialize observers on address selectors, defined in shopify_common.js
    if (Shopify) {
      new Shopify.CountryProvinceSelector(
        'AddressCountryNew',
        'AddressProvinceNew',
        {
          hideElement: 'AddressProvinceContainerNew',
        }
      );
    }
  }

  // Initialize each edit form's country/province selector
  $('.address-country-option').each(function () {
    var formId = $(this).data('form-id');
    var countrySelector = 'AddressCountry_' + formId;
    var provinceSelector = 'AddressProvince_' + formId;
    var containerSelector = 'AddressProvinceContainer_' + formId;

    new Shopify.CountryProvinceSelector(countrySelector, provinceSelector, {
      hideElement: containerSelector,
    });
  });

  $('.address-delete').on('click', function () {
    var $el = $(this);
    var formId = $el.data('form-id');
    var confirmMessage = $el.data('confirm-message');
    if (
      confirm(confirmMessage || 'Are you sure you wish to delete this address?')
    ) {
      Shopify.postLink('/account/addresses/' + formId, {
        parameters: { _method: 'delete' },
      });
    }
  });
})();

/**
 * Password Template Script
 * ------------------------------------------------------------------------------
 * A file that contains scripts highly couple code to the Password template.
 *
 * @namespace password
 */

theme.customerLogin = (function () {
  var config = {
    recoverPasswordForm: '#RecoverPassword',
    newCustomerForm: '#NewCustomer',
    hideRecoverPasswordLink: '#HideRecoverPasswordLink',
    HideNewCustomerLink: '#HideNewCustomerLink',
  };

  if (!$(config.recoverPasswordForm).length) {
    return;
  }

  checkUrlHash();
  resetPasswordSuccess();
  newCustomerSuccess();

  $(config.recoverPasswordForm).on('click', onShowHidePasswordForm);
  $(config.hideRecoverPasswordLink).on('click', onShowHidePasswordForm);

  $(config.newCustomerForm).on('click', onShowHideNewCustomerForm);
  $(config.HideNewCustomerLink).on('click', onShowHideNewCustomerForm);

  function onShowHidePasswordForm(evt) {
    evt.preventDefault();

    if (!$('#RecoverEmail').val()) {
      var enteredEmail = $('#CustomerEmail').val();
      $('#RecoverEmail').val(enteredEmail);
    }

    toggleRecoverPasswordForm();
  }

  function onShowHideNewCustomerForm(evt) {
    evt.preventDefault();

    if (!$('#CreateEmail').val()) {
      var enteredEmail = $('#CustomerEmail').val();
      $('#CreateEmail').val(enteredEmail);
    }

    toggleNewCustomerForm();
  }

  function checkUrlHash() {
    var hash = window.location.hash;

    // Allow deep linking to recover password form
    if (hash === '#recover') {
      toggleRecoverPasswordForm();
    }

    // if (hash === '#create') {
    //   toggleNewCustomerForm();
    // }
  }

  /**
   *  Show/Hide recover password form
   */
  function toggleRecoverPasswordForm() {
    $('#RecoverPasswordForm').toggleClass('hide');
    $('#CustomerLoginForm').toggleClass('hide');
  }

  function toggleNewCustomerForm() {
    $('#NewCustomerForm').toggleClass('hide');
    $('#CustomerLoginForm').toggleClass('hide');
  }

  /**
   *  Show reset password success message
   */
  function resetPasswordSuccess() {
    var $formState = $('.reset-password-success');

    // check if reset password form was successfully submited.
    if (!$formState.length) {
      return;
    }

    // show success message
    // $('#ResetSuccess').removeClass('hide');
    // $('#CustomerLoginForm').toggleClass('hide');

    iziToast.success({
      message: theme.strings.recoverPasswordEmailSent,
      position: 'bottomCenter',
      theme: 'light',
      closeOnClick: true,
      timeout: false,
    });
  }

  function newCustomerSuccess() {
    var $formState = $('.new-customer-success');

    // check if reset password form was successfully submited.
    if (!$formState.length) {
      return;
    }

    // show success message
    $('#NewCustomerSuccess').removeClass('hide');
  }
})();

window.theme = window.theme || {};

theme.RegisterPage = (function () {
  var selectors = {
    registerPage: '.register-page',
  };

  if (!$(selectors.registerPage).length) {
    return;
  }

  var validateABN = function (abn) {
    var isValid = true;
    abn = abn.replace(/[^0-9]/g, '');
    isValid &= abn && /^\d{11}$/.test(abn);

    if (isValid) {
      var weightedSum = 0;
      var weight = [10, 1, 3, 5, 7, 9, 11, 13, 15, 17, 19];
      for (var i = 0; i < weight.length; i++) {
        weightedSum += (parseInt(abn[i]) - (i === 0 ? 1 : 0)) * weight[i];
      }
      isValid &= weightedSum % 89 === 0;
    }

    return isValid;
  };

  var abnField = document.getElementById('CustomerFormABN');
  if (abnField !== undefined && abnField !== null) {
    abnField.addEventListener('input', function (event) {
      if (
        abnField.validity.typeMismatch ||
        validateABN(abnField.value) != true
      ) {
        abnField.setCustomValidity('Please enter a valid ABN.');
      } else {
        abnField.setCustomValidity('');
      }
    });
  }

  if ($('#CustomerFormCustomerType').length) {
    updateRegisterFormFields($('#CustomerFormCustomerType').val());

    $('#CustomerFormCustomerType').on('change', function () {
      updateRegisterFormFields($(this).val());
    });
  }

  $('.form-element--product-interest label:last-child input').on(
    'change',
    function () {
      $('.form-element--product-interest label input')
        .not(this)
        .prop('checked', this.checked);
    }
  );

  $('.form-element--product-interest label:not(:last-child) input').on(
    'change',
    function () {
      $('.form-element--product-interest label:last-child input').prop(
        'checked',
        false
      );
    }
  );

  function updateRegisterFormFields(selector) {
    var activeGroup = theme.utils.handleize(selector);
    var activeSelector = '.form-element--' + activeGroup;

    $('.form-element--toggles').not(activeSelector).hide();
    $('.form-element--toggles')
      .not(activeSelector)
      .removeClass('form-element--visible');
    $('.form-element--toggles').not(activeSelector).prop('disabled', true);

    $(activeSelector).show();
    $(activeSelector).addClass('form-element--visible');
    $(activeSelector).prop('disabled', false);

    $('input[name="tags"]').val(activeGroup);
  }
})();

/**
 * Free Gift Product
 * ------------------------------------------------------------------------------
 */

theme.CartGifts = (function () {
  var selectors = {
    dataJsonContainer: '[data-cart-gifts-json]',
  };
  var cache = {};

  function CartGifts(container) {
    this.container = container;
    this.namespace = '.cartGifts';

    if (!this.container) {
      return;
    }

    this.cartGifts = this._getCartGifts();
    this.progressBar = {};

    this._bindCartEventListener();
  }

  CartGifts.prototype = $.extend({}, CartGifts.prototype, {
    _formatProgressGifts: function () {
      var i = this.cartGifts.length,
        cartGift;

      while (i--) {
        cartGift = this.cartGifts[i];

        if (cartGift.cart_gift_type == 'cart-price-min') {
          cartGift.position_percent = Math.max(
            Math.min(
              ((cartGift.minimum_cart_price - this.progressBar.lowerLimit) /
                (this.progressBar.upperLimit - this.progressBar.lowerLimit)) *
                100,
              100
            ),
            0
          );
          if (
            window.shop.cartGifts.progressBar.giftMarkers.indexOf(cartGift) ==
            -1
          ) {
            window.shop.cartGifts.progressBar.giftMarkers.push(cartGift);
          }
        }
      }
    },

    _bindCartEventListener: function () {
      $(document).on(
        'cart.requestComplete' +
          this.namespace +
          ' cart.ready' +
          this.namespace,
        this._run.bind(this)
      );

      // Force CartJS reload
      CartJS.getCart({ success: function () {} });
    },

    _run: function (event, cart) {
      cache.cart = cart;

      // Reset options
      window.shop.cartGifts.giftOptions = [];

      this._addEligibleCartGiftsToCart();
      this._findNextEligibleCartGift();
      this._updateProgressBar();
      this._formatProgressGifts();
      this._buildSuccessMessage();
      // this._addGiftsFromProperties();
    },

    _getVariantsToAdd: function () {
      var variantsToAdd = [];
      var i = cache.cart.items.length;
      while (i--) {
        lineItem = cache.cart.items[i];
        for (var propertyKey in lineItem.properties) {
          if (propertyKey.indexOf('_add-to-cart') > -1) {
            var variantToAdd = lineItem.properties[propertyKey].split(':');
            variantsToAdd.push({
              variantId: variantToAdd[0],
              quantity: variantToAdd[1],
            });
          }
        }
      }
      return variantsToAdd;
    },

    _addGiftsFromProperties: function () {
      var variantsToAdd = this._getVariantsToAdd();

      var variantsAdded = [],
        i = variantsToAdd.length,
        variantToAdd;

      while (i--) {
        variantToAdd = variantsToAdd[i];
        if (variantsAdded.indexOf(variantToAdd.variantId) > -1) {
          continue;
        }
        variantsAdded.push(variantToAdd.variantId);
        CartJS.addItem(variantToAdd.variantId, variantToAdd.quantity, {
          _is_free_gift: 'true',
        });
      }
    },

    _buildSuccessMessage: function () {
      var i = this.cartGifts.length,
        cartGift,
        successMessage;

      while (i--) {
        cartGift = this.cartGifts[i];
        if (cartGift.is_in_cart && cartGift.success_title) {
          successMessage = successMessage
            ? successMessage +
              ' and <strong>' +
              cartGift.success_title +
              '</strong>'
            : '<strong>' + cartGift.success_title + '</strong>';
        }
      }

      if (successMessage) {
        successMessage = 'You get ' + successMessage;
      }

      window.shop.cartGifts.successMessage = successMessage;
    },

    _updateProgressBar: function () {
      var i = this.cartGifts.length,
        cartGift,
        lowerLimitCartGiftPrice,
        upperLimitCartGiftPrice,
        limitPadding,
        totalPrice;

      while (i--) {
        cartGift = this.cartGifts[i];

        if (cartGift.cart_gift_type == 'cart-price-min') {
          if (
            !upperLimitCartGiftPrice ||
            (upperLimitCartGiftPrice &&
              upperLimitCartGiftPrice < cartGift.minimum_cart_price)
          ) {
            upperLimitCartGiftPrice = parseInt(cartGift.minimum_cart_price);
          }
          if (
            !lowerLimitCartGiftPrice ||
            (lowerLimitCartGiftPrice &&
              lowerLimitCartGiftPrice > cartGift.minimum_cart_price)
          ) {
            lowerLimitCartGiftPrice = parseInt(cartGift.minimum_cart_price);
          }
        }
      }

      limitPadding = upperLimitCartGiftPrice / 8;
      totalPrice = cache.cart.total_price;

      this.progressBar.upperLimit = upperLimitCartGiftPrice + limitPadding;
      this.progressBar.lowerLimit = Math.min(
        lowerLimitCartGiftPrice - limitPadding,
        Math.max(totalPrice - limitPadding, 0)
      );
      this.progressBar.progressPercent =
        ((totalPrice - this.progressBar.lowerLimit) /
          (this.progressBar.upperLimit - this.progressBar.lowerLimit)) *
        100;

      window.shop.cartGifts.progressBar.progressPercent = this.progressBar.progressPercent;
    },

    _findNextEligibleCartGift: function () {
      var i = this.cartGifts.length,
        cartGift,
        nextCartGift;

      while (i--) {
        cartGift = this.cartGifts[i];

        if (
          cartGift.cart_gift_type == 'cart-price-min' &&
          cartGift.minimum_cart_price > cache.cart.total_price
        ) {
          if (
            !nextCartGift ||
            (nextCartGift &&
              nextCartGift.minimum_cart_price > cartGift.minimum_cart_price)
          ) {
            nextCartGift = cartGift;
          }
        }
      }

      this._setNextCartGift(nextCartGift);
    },

    _setNextCartGift: function (cartGift) {
      if (cartGift) {
        var nextPriceCartTotalDifferenceCents =
          cartGift.minimum_cart_price - cache.cart.total_price;
        cartGift.cart_cta_message_formatted = cartGift.cart_cta_message.replace(
          '[price]',
          Shopify.formatMoney(nextPriceCartTotalDifferenceCents)
        );
      }

      window.shop.cartGifts.next = cartGift;
    },

    _addEligibleCartGiftsToCart: function () {
      var i = this.cartGifts.length,
        cartGift,
        lineItemInCart,
        isEligible;

      while (i--) {
        cartGift = this.cartGifts[i];

        isInCart = cartGift.isIncart(cache.cart);
        isEligible = cartGift.isEligible(cache.cart);

        if (isEligible && !isInCart) {
          if (cartGift.type == 'cart-gift-options') {
            this._displayGiftOffer(cartGift, cache.cart);
          } else {
            cartGift.addToCart(cache.cart);
          }
        }

        if (!isEligible && isInCart) {
          if (cartGift.type == 'subscription-gift') {
            for (var i = 0; i < cache.cart.items.length; i++) {
              if (
                cache.cart.items[i].properties &&
                cache.cart.items[i].properties._item_id == cartGift.item_id
              ) {
                cartGift.removeFromCart(cache.cart.items[i]);
                break;
              }
            }
          }
        }

        if (isEligible) {
          cartGift.is_in_cart = true;
        } else {
          cartGift.is_in_cart = false;
        }
      }
    },

    _displayGiftOffer: function (cartGift, cart) {
      if (window.shop.cartGifts.giftOptions.length) {
        return;
      }

      cartGift.loadProducts();

      window.shop.cartGifts.giftOptions = cartGift.options;
    },

    _getCartGifts: function () {
      var dataJsonContainer = this.container.querySelector(
        selectors.dataJsonContainer
      );
      if (!dataJsonContainer) {
        return;
      }

      return _.map(JSON.parse(dataJsonContainer.innerHTML), function (
        cartGift
      ) {
        return new CartGift(cartGift);
      });
    },

    /**
     * Event callback for Theme Editor `section:unload` event
     */
    onUnload: function () {
      $(document).off(this.namespace);
    },
  });

  function CartGift(data) {
    _.extend(this, data);
    this.tooltip = {
      content: data.tooltip_message,
      theme: 'light',
    };

    if (data.type == 'cart-gift-options') {
      function Option(option) {
        _.extend(this, option);
      }
      this.options.map(function (option) {
        option.cart_gift_type = data.cart_gift_type;
        return new Option(option);
      });
    }
  }

  CartGift.prototype = $.extend({}, CartGift.prototype, {
    loadProducts: function () {
      this.options.forEach(function (option) {
        if (option.product || option.loading) {
          return;
        }

        option.loading = true;

        $.get('/products/' + option.product_handle + '?view=data', function (
          data
        ) {
          option.product = new theme.Product(JSON.parse(data, 'shopify'));
          option.variant = _.find(option.product.variants, {
            id: parseInt(option.product_variant_id),
          });
          option.loading = false;
        });
      });
    },

    getLineItemFromCart: function (cart, itemId) {
      var i = cart.items.length,
        item;
      while (i--) {
        if (
          cart.items[i].properties['_item_id'] &&
          cart.items[i].properties['_item_id'] == itemId
        ) {
          return cart.items[i];
        }
      }
      return;
    },

    removeFromCart: function (lineItem) {
      CartJS.removeItem(lineItem.line_number);
    },

    isIncart: function (cart) {
      var self = this;

      switch (this.type) {
        case 'cart-gift':
          return !!this.getLineItemFromCart(cart, this.item_id);

        case 'subscription-gift':
          return !!this.getLineItemFromCart(cart, this.item_id);

        case 'cart-gift-options':
          var itemsMatchInCart = _.map(this.options, function (product) {
            return !!self.getLineItemFromCart(cart, product.item_id);
          });

          return itemsMatchInCart.indexOf(true) > -1;

        case 'free-shipping':
          return !!this.getPropertyFromCart('_free_shipping', cart);
      }
    },

    getPropertyFromCart: function (property, cart) {
      var i = cart.items.length,
        item;
      while (i--) {
        if (cart.items[i].properties[property]) {
          return cart.items[i].properties[property];
        }
      }
      return;
    },

    isEligible: function (cart) {
      function hasSubscriptionProduct(cart){
        var i = cart.items.length,
        item;
        while (i--) {
          item = cart.items[i];
          if (item.properties && item.properties[this.eligibility_property]) {
            return true;
          }
        }
        return false;
      }
      function cartReachMinPriceAndXProduct(cart){
        if (cart.total_price === 0) {
          return false
        }
        if (cart.total_price > this.minimum_cart_price) {
          var required_product_id_list = this.product_in_cart_required_id_list.includes(',')?this.product_in_cart_required_id_list.split(','):[this.product_in_cart_required_id_list];
          var i = cart.items.length,item,product_id,cart_product_id_list=[],j = required_product_id_list.length;
          while (i--) {
            item = cart.items[i];
            if (item.product_id) {
              cart_product_id_list.push(item.product_id.toString());
            }
          }
          while (j--) {
            product_id = required_product_id_list[j];
            if (cart_product_id_list.indexOf(product_id) < 0) {
              return false;
            }
          }
          return true;
        }
        return false
      }
      switch (this.cart_gift_type) {
        case 'cart-price-min':
          return cart.total_price > this.minimum_cart_price;

        case 'item-property':
          if (cart.total_price > this.minimum_cart_price) {
            return hasSubscriptionProduct.call(this,cart);
          }
          return false;
        case 'cart-price-min-and-specific-product-subscription':
          if(!hasSubscriptionProduct.call(this,cart)){
            return false;
          }
          return cartReachMinPriceAndXProduct.call(this,cart);

          
        case 'cart-price-min-and-specific-product':
          return cartReachMinPriceAndXProduct.call(this,cart);
      }
    },

    addToCart: function (cart) {
      var self = this;
      if (self.requestQueued) {
        return;
      }

      self.requestQueued = true;

      if (document.body.classList.contains('cart-loading')) {
        console.info('Cart is loading. Waiting before applying cart gift.');

        $(document).on('cart.requestComplete.' + self.item_id, function () {
          if (document.body.classList.contains('cart-loading')) {
            console.info('Still loading, waiting before applying cart gift.');
            return;
          }

          $(document).off('cart.requestComplete.' + self.item_id);
          apply();
        });
      } else {
        apply();
      }

      function apply() {
        console.info('Applying cart gift');

        switch (self.type) {
          case 'cart-gift':
            if (self.failureOnAdd) {
              console.error('failed to add to cart');

              $(document).off('cart.requestComplete' + self.namespace);

              if (!$('.cart-drawer-item--promo-text').length) {
                $('.cart-drawer .tabs-group__tab').append(
                  '<div class="cart-drawer-item cart-drawer-item--promo-text center-xs color-primary">All free gifts are out of stock!</div>'
                );
              }

              return false;
            }

            var properties = {
              _is_free_gift: self.cart_gift_type,
              _item_id: self.item_id,
            };

            CartJS.addItem(self.variant_id, 1, properties, {
              error: function (jqXHR, textStatus, errorThrown) {
                self.failureOnAdd = true;
                self.requestQueued = false;
              },
              success: function (jqXHR, textStatus, errorThrown) {
                self.requestQueued = false;
              },
            });
            break;

          case 'subscription-gift':
            if (self.failureOnAdd) {
              console.error('failed to add to cart');

              $(document).off('cart.requestComplete' + self.namespace);

              if (!$('.cart-drawer-item--promo-text').length) {
                $('.cart-drawer .tabs-group__tab').append(
                  '<div class="cart-drawer-item cart-drawer-item--promo-text center-xs color-primary">All free gifts are out of stock!</div>'
                );
              }

              return false;
            }

            var properties = {
              _item_id: self.item_id,
              _disable_quantity_selector: true,
            };

            CartJS.addItem(self.variant_id, 1, properties, {
              error: function (jqXHR, textStatus, errorThrown) {
                self.failureOnAdd = true;
                self.requestQueued = false;
              },
              success: function (jqXHR, textStatus, errorThrown) {
                self.requestQueued = false;
              },
            });
            break;

          case 'free-shipping':
            console.info('Applying free shipping');

            var firstLineItem = cart.items[0];

            if (!firstLineItem) {
              self.requestQueued = false;
              return;
            }

            var lineNumber = firstLineItem.line_number;
            var quantity = firstLineItem.quantity;
            var properties = firstLineItem.properties;

            properties['_free_shipping'] = self.item_id;

            CartJS.updateItem(lineNumber, quantity, properties);

            self.requestQueued = false;

            break;
        }
      }
    },
  });

  return CartGifts;
})();

window.theme = window.theme || {};

theme.Password = (function () {
  var selectors = {
    passwordPage: '.password-page',
    loginModal: '#LoginModal',
    focusOnOpen: '#Password',
  };

  if (!$(selectors.passwordPage).length) {
    return;
  }

  initModal();

  function initModal() {
    var $loginModal = $(selectors.loginModal);

    if (!$loginModal.length) {
      return;
    }

    var passwordModal = new theme.Modals(selectors.loginModal, 'login-modal', {
      focusOnOpen: selectors.focusOnOpen,
    });

    // Open modal if errors exist
    if ($loginModal.find('.errors').length) {
      passwordModal.open();
    }
  }
})();

theme.FeatureColRows = (function () {
  var sliderArgs = {
    prevArrow:
      '<button type="button" class="slick-prev">' +
      theme.icons.chevronLeft +
      '</button>',
    nextArrow:
      '<button type="button" class="slick-next">' +
      theme.icons.chevronRight +
      '</button>',
  };

  enquire.register(theme.settings.mediaQuery.small, {
    match: function () {
      $('.feature-row--default .column_items').slick(sliderArgs);

      $('.feature-row--aligned .column_items a:not([href="#"])').wrapAll(
        '<div class="feature-row__slide-wrap"></div>'
      );
      $('.feature-row__slide-wrap').slick(sliderArgs);
    },

    unmatch: function () {
      $('.feature-row--default .column_items').slick('unslick');
      $('.feature-row__slide-wrap').slick('unslick');
    },
  });
})();

(function () {
  var $filterBy = $('#BlogTagFilter');

  if (!$filterBy.length) {
    return;
  }

  $filterBy.on('change', function () {
    location.href = $(this).val();
  });
})();

window.theme = window.theme || {};
theme.GiftProduct = (function () {
  const selectors = {
    container: '[data-gift-wrap]',
    input: 'input[type="checkbox"]',
  };

  if(!theme.current.gift_wrapping){
    return;
  }

  const giftWrapping = theme.current.gift_wrapping;
  const data = Object.assign({}, giftWrapping, {
    cart: CartJS.cart,
    ignore: giftWrapping.ignore,
  });

  const template = theme.utils.getTemplate('gift-wrapping');

  function updateGift() {
    this.checked
      ? CartJS.addItem(theme.current.gift_wrapping.variant_id, 1, {
          _hidden: true,
        })
      : CartJS.cart.items.map(
          (v) =>
            v.variant_id == theme.current.gift_wrapping.variant_id &&
            CartJS.removeItem(v.line_number)
        );
  }

  function init() {
    const $elements = document.querySelectorAll(selectors.container);
    [].map.call($elements, ($element) => {
      let html = theme.utils.createElementFromHTML(template),
        element = $element.appendChild(html);

      tinybind.bind(element, {
        data: data,
        methods: {
          update: updateGift.bind($element.querySelector(selectors.input)),
        },
      });
    });
  }

  return {
    init: init,
  };
})();

$(document).ready(function () {
  if(!theme.current.gift_wrapping){
    return;
  }
  theme.GiftProduct.init();
});

$(document).ready(function () {
  // Object-fit polyfill initialise
  objectFitImages();

  // Hacky IE Lazysizes fix until we find a better solution or drop IE
  if (typeof isMSIE != 'undefined' && isMSIE) {
    var lazyImageChecker = window.setInterval(function () {
      if (!$('img.lazyload').length) {
        window.clearInterval(lazyImageChecker);
      }
      $('img.lazyloading').each(function () {
        var imageSrc = $(this).attr('data-src');
        $(this).removeClass('lazyloading');
        $(this).get(0).src = imageSrc;
      });
    }, 3000);
  }

  var sections = new slate.Sections();
  sections.register('cart-template', theme.Cart);
  sections.register('product', theme.Product);
  sections.register('collection-template', theme.Filters);
  sections.register('sticky-sub-nav', theme.StickySubNav);
  sections.register('product-template', theme.Product);
  sections.register('header-section', theme.HeaderSection);
  sections.register('map', theme.Maps);
  sections.register('slideshow-section', theme.SlideshowSection);
  sections.register('quotes', theme.Quotes);
  sections.register('brand-values', theme.BrandValueSliders);
  // sections.register('featured-collection', theme.FeaturedCollection);
  sections.register('featured-collections', theme.FeaturedCollections);
  sections.register('featured-product', theme.FeaturedProduct);
  sections.register('featured-products', theme.FeaturedProducts);
  sections.register('image-row', theme.ImageRows);
  sections.register('content-slider', theme.ContentSliders);
  sections.register('latest-blog-posts', theme.LatestBlogPosts);
  sections.register('image-gallery-slider', theme.ImageGallerySliders);
  sections.register('instagram-feature', theme.Instagram);
  sections.register('store-locator', theme.StoreLocator);
  sections.register('wishlist-page', theme.WishlistPage);
  sections.register('ingredients', theme.Ingredients);
  sections.register('faq', theme.Faq);
  sections.register('login', theme.Customer);
  sections.register('register', theme.Customer);
  sections.register('cart-gifts', theme.CartGifts);
  sections.register('feature-col-row', theme.FeatureColRows);

  // Common a11y fixes
  slate.a11y.pageLinkFocus($(window.location.hash));

  $('.in-page-link').on('click', function (evt) {
    slate.a11y.pageLinkFocus($(evt.currentTarget.hash));
  });

  $('a[href="#"]').on('click', function (evt) {
    evt.preventDefault();
  });

  // Theme-specific selectors to make tables scrollable
  var tableSelectors = '.rte table';

  slate.rte.wrapTable({
    $tables: $(tableSelectors),
    tableWrapperClass: 'rte__table-wrapper',
  });

  // Theme-specific selectors to make iframes responsive
  var iframeSelectors =
    '.rte iframe[src*="youtube.com/embed"],' +
    '.rte iframe[src*="youtube-nocookie.com/embed"],' +
    '.rte iframe[src*="youtu.be"],' +
    '.rte iframe[src*="player.vimeo"]';

  slate.rte.wrapIframe({
    $iframes: $(iframeSelectors),
    iframeWrapperClass: 'rte__video-wrapper',
  });

  // Apply a specific class to the html element for browser support of cookies.
  if (slate.cart.cookiesEnabled()) {
    document.documentElement.className = document.documentElement.className.replace(
      'supports-no-cookies',
      'supports-cookies'
    );
  }

  // Setup progress bar plugin
  if ('NProgress' in window) {
    NProgress.configure({
      showSpinner: false,
    });
  }

  // Show/record recently viewed products
  if (theme.RecentlyViewed) {
    theme.RecentlyViewed.showRecentlyViewed();
    theme.RecentlyViewed.recordRecentlyViewed();
  }

  // Transition helpers
  $('[data-prepare-transition="hover"]').on('mouseenter', function () {
    var activeClass = $(this).data('data-prepare-transition-class') || 'hover';
    $(this).prepareTransition().addClass(activeClass);
  });

  $('[data-prepare-transition="hover"]').on('mouseleave', function () {
    var activeClass = $(this).data('data-prepare-transition-class') || 'hover';
    $(this).prepareTransition().removeClass(activeClass);
  });

  // Update 'last viewed of type' text to match last viewed object, e.g. breadcrumbs

  $('[data-last-viewed]').each(function () {
    var $this = $(this);
    var type = $this.data('last-viewed');
    var typeVar = 'lastViewed' + type.charAt(0).toUpperCase() + type.slice(1);
    var lastViewed = sessionStorage[typeVar];

    if (lastViewed !== undefined) {
      type += 's';
      var relatedObjects = $this.data('related-' + type);
      if (relatedObjects[lastViewed] !== undefined) {
        $this.text(relatedObjects[lastViewed].title);
      }
    }
  });

  document
    .querySelectorAll('[data-viewport-container]')
    .forEach(function (elem) {
      if (elem.scrollWidth > elem.clientWidth) {
        elem.classList.add('force-visibility');
      }
    });

  // Show password buttons
  $('.form-vertical__password-toggle').on('click', function () {
    var $input = $($(this).siblings('input'));

    $(this).toggleClass('active');

    if ($input.attr('type') == 'password') {
      $input.attr('type', 'text');
    } else {
      $input.attr('type', 'password');
    }
  });

  // theme.Translate = theme.Translate || {};
  // theme.Translate.updateSelectElements = function(elem){
  //   var countryCode = $('option:selected', elem).data('country-code');
  //   $(elem).parent().attr('data-lang', countryCode);
  // };

  // if ($.cookie('googtrans')) {
  //   $('.translate-select option[data-google-code="' + $.cookie('googtrans') + '"]').attr('selected', 'selected');
  //   $('.translate-select').trigger('change');
  // }

  // Init CSS Custom Property polyfill
  cssVars();

  if (window.location.hostname == 'localhost') {
    document.documentElement.classList.add('localhost');
  }

  // Set omnibar colour in chrome mobile
  try {
    var colorPrimary = getComputedStyle(document.body)
      .getPropertyValue('--color-primary')
      .trim();
    $('meta[name=theme-color]').attr('content', colorPrimary);
  } catch (err) {
    console.error(err);
  }

  // Submit customer forms with Accentuate
  var asyncForms = document.querySelectorAll('[data-async-submit]');

  for (var i = asyncForms.length - 1; i >= 0; i--) {
    var asyncForm = asyncForms[i];
    $(asyncForm).on('submit.asyncSubmit', function () {
      event.preventDefault();
      asyncSubmitForm(asyncForm);
    });
  }

  function asyncSubmitForm(form) {
    var submitButton = form.querySelector('[type="submit"]');
    form.classList.add('loading');
    submitButton.classList.add('loading');

    var $form = $(form);
    loadJS('https://app.accentuate.io/dist/proxy.js', function () {
      $form.off('submit.asyncSubmit');

      Accentuate($form, function () {
        setTimeout(function () {
          window.location.reload();
        }, 500);
      });

      $form.submit();
    });
  }

  /* Parallax Animations */
  theme.Parallax = new Rellax('.rellax', {
    speed: -3,
    center: false,
    wrapper: null,
    round: true,
    vertical: true,
    horizontal: false,
  });

  var subscriptionProductForm = $('#rc_container');
  if (subscriptionProductForm.length) {
  } else {
    //Pretty Select Elements
    // $('.product-form__item select').selectize({
    //   onFocus: function () {
    //     this.$control_input.attr('readonly', true);
    //     this.$control.css('cursor', 'pointer');
    //     this.$wrapper.css('cursor', 'pointer');
    //   },
    // });
  }

  /* Cookie Banner */

  function openCookieConsentPopup() {

    if ('cookieconsent' in window) {
      var setCookieStatusVar = function (status) {
        if (status == 'allow' || status == 'dismiss') {
          window.__rmcp = [1, 2, 3, 4, 5];
        } else {
          window.__rmcp = [];
        }
      };

        window.cookieconsent.initialise({
          
          palette: {
            popup: {
              background: '#f1efeb',
              text: '#565550',
            },
            button: {
              background: 'transparent',
              border: 'var(--color-header-bg)',
              text: 'var(--color-header-bg)',
            },
          },
          position: 'bottom',
          mobileForceFloat: false,
          content: {
            message:
              'This site uses cookies and other tracking technologies to assist with navigation and your ability to provide feedback...',
            dismiss: 'Accept Cookies',
            link: 'Read our Cookie Policy here',
            href: '/pages/privacy-policy',
          },
          layouts: {
            od: '{{messagelink}}{{compliance}}{{close}}',
          },
          layout: 'od',
          elements: {
            close:
              '<span aria-label="dismiss cookie message" tabindex="0" id="cc-id-close" class="cc-customClose">&times;</span><div class="opt_out" id="cc-opt-out">opt out</div>',
          },
          onInitialise: function (status) {
            setCookieStatusVar(status);
          },
          onPopupOpen: function (status) {
            setCookieStatusVar(status);
          },
          onStatusChange: function (status) {
            setCookieExpiry();
            setCookieStatusVar(status);
          },
        });

        $('#cc-id-close').on('click', setCookieExpiry);
        $('#cc-opt-out').on('click', setCookieExpiry);

        function setCookieExpiry() {
          var ccDaysClose = 30; //'{{settings.cookies_days_ttl}}';
          $(".cc-window[aria-label='cookieconsent']:first").hide();
          const ttl = 1000 * 3600 * 24 * ccDaysClose; 
          localStorage.setItem("cookieConsent::expiry", (new Date()).getTime() + ttl );  
          console.log("cookieConsent::expiry", (new Date()).getTime() + ttl );
        } 

      if(region == "US" || region == "AU"){
        $(".cc-window[aria-label='cookieconsent']:first").addClass("cookies_style_2");
      }
    }
  }


  popupExpiry = localStorage.getItem("cookieConsent::expiry");

  if(!popupExpiry || parseInt(popupExpiry) < (new Date()).getTime()) {
    openCookieConsentPopup();
  };

  $(document).on(
    'change',
    'input[name="customer[accepts_marketing]"]',
    function () {
      var $button = $(this).parents('form').find('.btn[type="submit"]');
      if ($(this).is(':checked')) {
        $button.prop('disabled', false);
      } else {
        $button.prop('disabled', true);
      }
    }
  );

  // Multi add to cart buttons (text.liquid)
  $('.btn--multi-cart-add').on('click', function () {
    var $btn = $(this),
      variantsToAdd;

    variantsToAdd = $btn.data('variants').map(function (variantId) {
      return {
        quantity: 1,
        id: variantId,
      };
    });

    $btn.addClass('loading');

    var requestData = {
      items: variantsToAdd,
    };

    $.post(
      '/cart/add.js',
      requestData,
      function (data) {
        $btn.removeClass('loading');
        CartJS.getCart();
        theme.CartDrawer.open();
      },
      'json'
    );
  });
});

/* Old Page Overrides */
var $oldCarousels = $('.owl-carousel');
if ($oldCarousels.length) {
  $oldCarousels.slick({
    arrows: false,
    autoplay: true,
    accessibility: true,
    adaptiveHeight: false,
    autoplaySpeed: 5000,
    centerMode: false,
    centerPadding: '40px',
    dots: false,
    draggable: true,
    fade: false,
    infinite: true,
    rows: 0,
    slidesPerRow: 1,
    slidesToScroll: 1,
    slidesToShow: 1,
    swipeToSlide: true,
    touchThreshold: 20,
  });
}

var swiper = new Swiper('.swiper-container', {
  slidesPerView: 3,
  spaceBetween: 12,
  grabCursor: true,
  freeMode: true,
  autoHeight: false,
  navigation: {
    nextEl: '.swiper-button-next',
    prevEl: '.swiper-button-prev',
  },
});


const $subscribeForms = document.querySelectorAll('.js-subscribe-form');
if ($subscribeForms.length) {
  $subscribeForms.forEach(function (form) {
    const $inputWrappers = form.querySelectorAll('.js-floating-wrapper');
    if ($inputWrappers.length) {
      floatingFormLabel($inputWrappers);
      form.addEventListener('change', function() {
        floatingFormLabel($inputWrappers);
      });
    }
  });
}

function floatingFormLabel(inputWrappers) {
  inputWrappers.forEach(function (wrapper) {
    const $input = wrapper.querySelector('input.floating-label__input');
    if ($input) {
      $input.addEventListener('focus', function() {
        wrapper.classList.add('has-focus');
        wrapper.classList.add('is-floating');
      });

      $input.addEventListener('blur', function(event) {
        wrapper.classList.remove('has-focus');

        if(event.target.value === '') {
          wrapper.classList.remove('is-floating');
        }
      });
    }
  })
}

(function() {
  const afterpayModal = $('.afterpay-modal');
  const openAfterPayPopup = function() {
    afterpayModal.removeClass('hidden');
    $('body').append(afterpayModal);
    $('body').css('overflow', 'hidden');
    $(document).on('click', function(e) {
      let target = e.target;
      if(target.classList.contains('afterpay-modal-close') || !target.closest('.modal-content')) {
        closeAfterPayPopup()
      }
    });
  }
  
  const closeAfterPayPopup = function() {
    afterpayModal.addClass('hidden');
    $('body').css('overflow', '');
  }
  
  $('.product__payments-vidget a.afterpay-link').on('click', function(e){
    e.preventDefault();
    e.stopPropagation();
    openAfterPayPopup();
  });
})();


var button = document.querySelectorAll('.product-cart-item__buttons')
for (let j = 0; j < button.length; j++) {

  button[j].addEventListener('click', function(e){
  var hideElement = this; 
  hideElement = hideElement.parentElement

  if (hideElement){
    hideElement.classList.add("fadeAway")
    setTimeout(function(){
      hideElement.classList.add("hide_upsell")
    }, 350)
  }
})
} 


theme.Marquee = (function() {

  function Marquee(slider) {
        $(slider).slick({
            speed: 5000,
            autoplay: true,
            autoplaySpeed: 0,
            centerMode: true,
            cssEase: 'linear',
            slidesToShow: 1,
            slidesToScroll: 1,
            variableWidth: true,
            infinite: true,
            initialSlide: 1,
            arrows: false,
            buttons: false
          });
  }
  return Marquee;
})();

$( document ).ready(function() {
  var slider = document.getElementById("marquee_slider");
  if (slider){
    new theme.Marquee(slider);
  }



  let productGridItems = document.querySelectorAll('.product-grid-item');
  if (productGridItems.length > 0){

    for (let item of productGridItems) {

      let productData = item.querySelector('[data-product-grid-item-json]').innerHTML;
      let product = null;
      try {
        product = JSON.parse(productData)
      }
      catch(e){

      }
      if (product){
        let quickAdd = item.querySelector('.product-grid-item-add-to-cart');
        if (quickAdd){
          quickAdd.addEventListener('click', function(){
            item.classList.toggle('active');
          })
        }
        var options = {
          $container: $(item),
          enableHistoryState: false,
          singleOptionSelector: '[data-single-option-selector]',
          originalSelectorId: '[data-product-select]',
          product: product,
          subscriptionSelector: 'input[name="purchase_type"]',
        };
        //this.variants = new slate.Variants(options);
      }

      let variantSelect = item.querySelector('.single-option-selector__select');
  
      let productForm = item.querySelector('.product-form');
      if (productForm){
        productForm.addEventListener('submit',function(event){
          event.preventDefault();
          // event.stopPropagation();
          let variantId = variantSelect.value;
          let quantity = 1;
          let properties = {};

          // Disable the button for a moment
          let formSubmitButton = productForm.querySelector('.product-form__submit');
          formSubmitButton.style.pointerEvents = 'none';
          setTimeout(()=>{
            formSubmitButton.style.pointerEvents = "all";
          },1000)

          if (variantId){
            $.ajax({
              url: '/cart/add.js',
              dataType: 'json',
              cache: false,
              type: 'post',
              data: {
                id: variantId, 
                quantity: quantity,
                properties: properties          
              },
              beforeSend: function () {

              },
              success: function (product) {
                let addToCartButton = item.querySelector('.product-form__submit ')
                addToCartButton.innerText = 'Added'
                theme.MiniCart.show(product);
              },
              fail: function(error){
                console.log(error)
              }
            });
          }
          else {
            console.log('failed to find variant id to add to cart')
          }


        });
      }
      

    }
  }
  setTimeout(()=>{
    // console.log("load==")
    // console.log(document.querySelector('span[data-variant-id="8651780128882"]'))
    // document.querySelector('span[data-variant-id="8651780128882"]').childNodes[1].textContent = "PRE-ORDER"
  }, 1000);

});
var faqclick = document.getElementsByClassName("js-dropdown");
var faqContent = document.getElementsByClassName('-arrow-link-content');
for (var i = 0; i < faqclick.length; i++) {
    faqclick[i].onclick = function () {
      if (this.parentNode.querySelector('div.-arrow-link-content').classList.contains('faq-active')) {
        this.parentNode.querySelector('div.-arrow-link-content').classList.remove('faq-active'); 
      }
      else {
        try {
          // if an open element exists, close it first
          this.parentNode.parentNode.querySelector('.faq-active').classList.remove('faq-active');
         }
          catch (error){ 
            // Error occurs when no open elment exists, in that case: Do nothing
          }
        this.parentNode.querySelector('div.-arrow-link-content').classList.add('faq-active');
      }
    }
  }


  $( document ).ready(function() {
    $("#c-iconslist h3").click(function () {
      //Inner 
      var jqInner = $(this).next();
    $(this).toggleClass('plus minus');
})
});
